import React, { useEffect, useState, useRef, useContext, useMemo } from 'react'
import DocTagsService from '../../components/utils/docTags.service'
import GroupIcon from '@mui/icons-material/Group'
import AnchorIcon from '@mui/icons-material/Anchor'
import TableCustomsOffice from '../../components/utils/tableCustomsOffice'
import { Paper, Tooltip, Dialog, DialogTitle, DialogContent } from '@mui/material'
import { CloseRounded } from '@mui/icons-material'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import ZoomInIcon from '@mui/icons-material/ZoomIn'
import ZoomOutIcon from '@mui/icons-material/ZoomOut'
import Draggable from 'react-draggable'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import { Download as DownloadIcon, Refresh, Search, Settings } from '@mui/icons-material'
import download from 'downloadjs'
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ContextMenu } from 'primereact/contextmenu'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Splitter, SplitterPanel } from 'primereact/splitter'
import './createBL.css'
import AddIcon from '@mui/icons-material/Add'
import CancelIcon from '@mui/icons-material/Cancel'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import PostAddIcon from '@mui/icons-material/PostAdd'
import { LoadingBar, M_Fieldset, M_Header, M_TabsInpage, NavigateContext } from 'src/M_Components'
import { ExtensionForm } from 'src/components/genericEntity/entity/ExtensionForm'
import { saveAs } from 'file-saver'
import jsPDF from 'jspdf'
import { PDFDocument } from 'pdf-lib'
import { Star, Delete } from '@mui/icons-material';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import LensOutlinedIcon from '@mui/icons-material/LensOutlined'
import axios from 'axios'

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { useSignalR } from 'src/services/signalRContext'

import { M_SwitchButton, M_ElementDrawer, M_TextArea, M_MessageBoard, M_TimeLine, M_Button, M_CheckBox, M_InputTextField, M_DrawerTableTextField, M_Select, LoadingContext, BufferService, filtersSortService, M_FormFavorites, useFavorites } from 'src/M_Components'
import { Popover, TextField as MuiTextField, IconButton, MenuItem as MuiMenuItem, ListItemText, Divider as MuiDivider } from '@mui/material'

function GroupFavoriteActionsBL({ groupName, t }) {
    const favCtx = useFavorites();
    const [anchorEl, setAnchorEl] = useState(null);
    const [name, setName] = useState('');

    if (!favCtx) return null;

    const { saveGroupFavorite, getGroupFavorites, handleApplyFavorite, handleDeleteFavorite } = favCtx;
    const groupFavs = getGroupFavorites(groupName);

    return (
        <div style={{ position: 'absolute', top: '65px', right: '30px', zIndex: 10 }}>
            <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
                <Star sx={{ color: groupFavs.length > 0 ? 'var(--color-yellow, #f9a825)' : '#ccc', fontSize: '20px' }} />
            </IconButton>
            <Popover
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={() => { setAnchorEl(null); setName(''); }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <div style={{ minWidth: '250px' }}>
                    <div style={{ padding: '12px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <MuiTextField
                            size="small"
                            label={t('FavoriteName') || 'Name'}
                            value={name}
                            onChange={e => setName(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' && name.trim()) {
                                    saveGroupFavorite(groupName, name);
                                    setName('');
                                }
                            }}
                            autoFocus
                            fullWidth
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Save') || 'Save'}
                            backgroundColor={'var(--color-blue)'}
                            labelColor="var(--color-white)"
                            onClick={() => {
                                if (name.trim()) {
                                    saveGroupFavorite(groupName, name);
                                    setName('');
                                }
                            }}
                        />
                    </div>
                    {groupFavs.length > 0 && <MuiDivider />}
                    {groupFavs.map(fav => (
                        <MuiMenuItem
                            key={fav.Id}
                            onClick={() => { handleApplyFavorite(fav); setAnchorEl(null); }}
                            sx={{
                                '& .fav-delete': { opacity: 0, transition: 'opacity 0.2s' },
                                '&:hover .fav-delete': { opacity: 1 }
                            }}
                        >
                            <ListItemText>{fav.Description}</ListItemText>
                            <IconButton
                                className="fav-delete"
                                size="small"
                                onClick={(e) => { e.stopPropagation(); handleDeleteFavorite(fav.Id, e); }}
                                sx={{ marginLeft: '8px' }}
                            >
                                <Delete fontSize="small" sx={{ color: 'var(--color-red, #d32f2f)' }} />
                            </IconButton>
                        </MuiMenuItem>
                    ))}
                </div>
            </Popover>
        </div>
    );
}

export default function CreateBL({ handleTabClose, toastMessages }) {
    const extensionFormRef = useRef(null)
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const signalR = useSignalR()
    const matches = useMediaQuery('(min-width:0px)')
    const { t } = useTranslation()
    const cm = useRef(null)
    const bl1 = useRef(null)
    const bl2 = useRef(null)
    const [leavingPage, setLeavingPage] = useState(false)

    const ref = useRef(null)


    const entityLabels = [
        {
            label: 'Shipper',
            fields: ['Name', 'Address', 'Address2', 'ZipCode', 'Country', 'Vat']
        },
        {
            label: 'Consignee',
            fields: ['Name', 'Address', 'Address2', 'ZipCode', 'Country', 'Vat']
        },
        {
            label: 'Notify',
            fields: ['Name', 'Address', 'Address2', 'ZipCode', 'Country', 'Vat']
        },
    ]

    const portsLocations = [
        { label: 'Original Port', tablecode: 'Name', type: 'textfield', code: 'voyagePlaceReceipt', id: 'LocationReceiptId', name: 'LocationReceiptPortName' },
        { label: 'Loading Port', tablecode: 'Name', type: 'textfield', code: 'voyagePortLoading', id: 'LoadingPortId', name: 'LocationLoadingPortName' },
        { label: 'Discharge Port', tablecode: 'Name', type: 'textfield', code: 'voyagePortDischarge', id: 'DischargePortId', name: 'LocationDischargePortName' },
        { label: 'Final Port', tablecode: 'Name', type: 'textfield', code: 'voyagePlaceDelivery', id: 'LocationDeliveryPortId', name: 'LocationDeliveryPortName' },
        { label: 'Transhipment', tablecode: '', type: 'checkbox', code: 'Transhipment', name: 'Transhipment' },
    ]

    //*document
    const [blHTML, setBlHTML] = useState()
    const [blHTMLCopy, setBlHTMLCopy] = useState()

    const [blSecondHTML, setBlSecondHTML] = useState()
    const [blSecondHTMLCopy, setBlSecondHTMLCopy] = useState()

    //* tag building states
    const [varNameDict, setVarNameDict] = useState(new Map())



    const [open, setOpen] = useState(false)

    const [customOfficeDict, setCustomOfficeDict] = useState(new Map())
    const [dictCustomOfficeDict, setDictCustomOFficeDict] = useState([])

    const [showInput, setShowInput] = useState(false)
    const [zoom, setZoom] = useState(50)
    const [page, setPage] = useState(1)
    const [lines, setLines] = useState(0)
    const [docSize, setDocSize] = useState(2)
    const [pageSize, setPageSize] = useState(10) //* MAX LINES OF THE FIRST PAGE
    const [auxPageSize, setAuxPageSize] = useState(35) //35 linhas por pagina de continuacao
    const [descriptionSize, setDescriptionSize] = useState(40) //* MAX SIZE OF A DESCRIPTION LINE
    const [entitySize, setEntitySize] = useState(38)

    const passOperation = sessionStorage.getItem('operation') !== null ? sessionStorage.getItem('operation') : 'Create'
    const [operation, setOperation] = useState(passOperation)
    const [organizedData, setOrganizedData] = useState(new Map())
    const [containerTypes, setContainerTypes] = useState([])
    const [totalIds, setTotalIds] = useState(1)
    const [shipmentIndex, setShipmentIndex] = useState(1)
    const [equipmentIndex, setEquipmentIndex] = useState(1)
    const [selectedLine, setSelectedLine] = useState(null)
    const [separator, setSeparator] = useState([55, 45])
    const [listErrors, setListErrors] = useState('')

    //* options menu
    const [formEntities, setFormEntities] = useState(passOperation === 'Edit' || passOperation === 'Create' ? true : false)
    const [formCustomOffice, setFormCustomOffice] = useState(false)
    const [formShipmentDetails, setFormShipmentDetails] = useState(false)
    const [formPorts, setFormPorts] = useState(passOperation === 'Edit' || passOperation === 'Create' ? false : true)
    const [formAdditionalFields, setFormAdditionalFields] = useState(false)

    const [anchor, setAnchor] = useState(null)
    const [top, setTop] = useState(0)
    const [left, setLeft] = useState(0)
    const [width, setWidth] = useState(0)
    const [rowHeight, setRowHeight] = useState(0)

    const [anchorShip, setAnchorShip] = useState(null)
    const [shipLeft, setShipLeft] = useState(0)
    const [shipTop, setShipTop] = useState(0)
    const [shipHeight, setShipHeight] = useState(0)
    const [shipWidth, setShipWidth] = useState(0)

    const [hoverLine, setHoverLine] = useState(null)

    const [shipmentToDispatch, setShipmentToDispatch] = useState(null)

    const [imoCounter, setImoCounter] = useState(1)

    const [isDragShip, setIsDragShip] = useState(null)

    const [anchorDrag, setAnchorDrag] = useState(null)
    const [topDrag, setTopDrag] = useState(0)
    const [leftDrag, setLeftDrag] = useState(0)
    const [widthDrag, setWidthDrag] = useState(0)
    const [hoverIndex, setHoverIndex] = useState(null)

    const [anchorDragShip, setAnchorDragShip] = useState(null)
    const [shipTopDrag, setShipTopDrag] = useState(0)
    const [shipHeightDrag, setShipHeightDrag] = useState(0)
    const [shipWidthDrag, setShipWidthDrag] = useState(0)
    const [shipLeftDrag, setShipLeftDrag] = useState(0)

    const [hideOriginals, setHideOriginals] = useState(false)
    const [originOriginalNumber, setOriginOriginalNumbers] = useState(0)
    const [destinationOriginalNumber, setDestinationOriginalNumber] = useState(0)
    const [originCopyNumber, setOriginCopyNumbers] = useState(0)
    const [destinationCopyNumber, setDestinationCopyNumber] = useState(0)

    const docTagsService = new DocTagsService()

    const [selectedRows, setSelectedRows] = useState([])
    const [customsRows, setCustomsRows] = useState([])

    const [rejectFields, setRejectFields] = useState(new Map())
    const [finalNotes, setFinalNotes] = useState("")
    const [openConfirmModal, setOpenConfirmModal] = useState(false)

    const [confirmationModal, setConfirmationModal] = useState(false)
    const [approveSuccess, setApproveSuccess] = useState(false)
    const [isApprove, setIsApprove] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')

    const [openContainer, setOpenContainer] = useState(false)
    const [newContainerMap, setNewContainerMap] = useState(new Map())

    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const [isFirstIteration, setIsFirstIteration] = useState(true)
    const [isLoaded, setIsLoaded] = useState(true)
    const [errors, setErrors] = useState('')
    const [OpenModalSeeErrors, setOpenModalSeeErrors] = useState(false)

    const [hasOutdatedClauses, setHasOutdatedClauses] = useState(false)
    const [clausesLastUpdate, setClausesLastUpdate] = useState(null)

    // Clauses states
    const [openClauses, setOpenClauses] = useState(false)
    const [clausesData, setClausesData] = useState([])
    const [loadingClauses, setLoadingClauses] = useState(false)
    const [expandedRows, setExpandedRows] = useState([])
    const [clauseDetails, setClauseDetails] = useState({})
    const [loadingDetails, setLoadingDetails] = useState({})
    const [openConfirmRegenerate, setOpenConfirmRegenerate] = useState(false)
    const [openConfirm, setOpenConfirm] = useState(false)

    const [changesTabs, setChangesTabs] = useState([])

    const sessionKeys = [
        'varNameDict', 'customOfficeDict', 'dictCustomOfficeDict', 'showInput',
        'lines', 'docSize', 'pageSize', 'auxPageSize', 'descriptionSize',
        'organizedData', 'containerTypes', 'totalIds', 'shipmentIndex', 'hideOriginals',
        'originOriginalNumber', 'destinationOriginalNumber', 'originCopyNumber', 'bookingDate',
        'destinationCopyNumber', 'formEntities', 'formCustomOffice', 'formShipmentDetails',
        'blHTMLCopy', 'blSecondHTMLCopy', 'operation', 'BLDate', 'page', 'approveDate', 'containerDate',
        'formPorts', 'entitySize', 'changesTabs', 'downloadablePDF', 'errors', 'listErrors', 'dataBLs',
        'imoCounter'
    ]
    const BookingV2Service = new BufferService('ViewBooking')
    const BLService = new BufferService('ViewBL')
    const BLServiceDelete = new BufferService('ViewBL/delete')
    const BLOriginalService = new BufferService('BL')
    const ProcessStatusService = new BufferService('processStatus')
    const approveService = new BufferService('approval')
    const officeService = new BufferService('AccountOffice')
    const auditService = new BufferService('audit/lastbl')
    const errorsList = new BufferService('viewblerrors')
    const approveBL = new BufferService('viewblapproval')
    const ClausesService = new BufferService('BLClause')
    const ClauseDetailsService = new BufferService('TransportClauseDetail')
    const RegenerateClausesService = new BufferService('blclause')
    const TransportClauseService = new BufferService('TransportClause')


    const filterService = new filtersSortService()

    const lineId = JSON.parse(sessionStorage.getItem('blContext')) ? JSON.parse(sessionStorage.getItem('blContext')).Id : null
    const [bookingDate, setBookingDate] = useState("")
    const [BLDate, setBLDate] = useState("")
    const [dataBLs, setDataBLs] = useState({})
    const [openModalConfirmDeletion, setModalConfirmDeletion] = useState(false)
    const [approveDateBL, setApproveDateBL] = useState("")
    const [approveDate, setApproveDate] = useState("")
    const [containerDate, setContainerDate] = useState("")


    const [openElement, setOpenElement] = useState(false)

    const [downloadablePDF, setDownloadablePDF] = useState(false)

    const closeElement = () => {
        // ValidaÃ§Ãµes Reefer
        if (shipmentToDispatch?.onOff === true &&
            (shipmentToDispatch?.temp === '' || shipmentToDispatch?.temp === undefined || shipmentToDispatch?.temp === null)) {
            toastMessages('error', t('tempEmpty'), '')
            return
        }

        setOpenElement(false)
        const newMap = new Map()
        containerTypes.forEach(container => {
            let tempArray = organizedData.get(container).map(data => {
                if (data.shipment === shipmentToDispatch.shipment) {
                    let tempObj = {
                        ...data,

                        'dispatchNumber': shipmentToDispatch.dispatchNumber,
                        'CommodityCode': shipmentToDispatch.CommodityCode,
                        'CommodityName': shipmentToDispatch.CommodityName,
                        'IdCommodity': shipmentToDispatch.IdCommodity,
                        'IMO': shipmentToDispatch.IMO,
                        'dangerousGoods': [],
                        'Prefix': shipmentToDispatch.Prefix,
                        'Number': shipmentToDispatch.Number,
                        'CheckDigit': shipmentToDispatch.CheckDigit,
                        'marks': shipmentToDispatch.marks,
                        'Payload': shipmentToDispatch.Payload,
                        'Tare': shipmentToDispatch.Tare,
                        'IdEquipment': shipmentToDispatch.IdEquipment,
                        'OnOff': shipmentToDispatch.onOff,
                        'Temperature': shipmentToDispatch.temp,
                    }
                    if (tempObj.IMO) tempObj.dangerousGoods = shipmentToDispatch.dangerousGoods
                    return tempObj
                } else {
                    return data
                }
            })
            newMap.set(container, tempArray)
        })
        setOrganizedData(new Map(newMap))
    }

    const totalOfOriginals = () => {
        if ((parseInt(originOriginalNumber) < 0 || parseInt(destinationOriginalNumber) < 0)) {
            return <p className='textCheckbox textInherit'> {t("LabelNumberLess0")}</p>
        }
        else
            if ((parseInt(originOriginalNumber) + parseInt(destinationOriginalNumber)) > 3) {
                return <p className='textCheckbox textInherit'> {t("LabelMaxOrig")}</p>
            } else
                return
    }

    const cards = [
        { id: 4, name: 'Ports', code: 'Ports', icon: <AnchorIcon className='iconCard' /> },
        { id: 1, name: t("Entities"), code: 'Entities', icon: <GroupIcon className='iconCard' /> },
        { id: 2, name: 'Custom Office', code: 'CustomOffice', icon: <PostAddIcon className='iconCard' /> },
        { id: 3, name: 'Shipment Details', code: 'ShipmentDetails', icon: <i className="pi pi-box" ></i> },
        {
            id: 5,
            name: t('AdditionalFields') || 'Additional Fields',
            code: 'AdditionalFields',
            icon: <i className="pi pi-list" style={{ marginRight: '4px' }} />
        },
    ]

    const valueTimeline = operation === 'Create' ?
        [
            { icon: 'pi pi-circle-fill', name: t("TimeLineCreatBook"), color: 'white', connectorColor: 'var(--color-blue)', date: bookingDate },
            { icon: 'pi pi-circle-fill', name: t("TimeLineBookAccp"), color: 'white', connectorColor: 'var(--color-blue)', date: approveDate },
            { icon: 'pi pi-circle-fill', name: t("TimeLineInsCont"), color: 'white', connectorColor: 'var(--color-blue)', date: containerDate },
            { icon: 'pi pi-spin pi-spinner', name: t("TimeLineCreBL"), color: 'white', connectorColor: 'var(--color-blue)', date: '' },
            { icon: 'pi pi-circle', name: t("TimeLineBLAccep"), color: 'White', connectorColor: 'var(--color-blue-light)', date: '' }
        ] :
        [
            //! por o resto das datas!!
            { icon: 'pi pi-circle-fill', name: t("TimeLineCreatBook"), color: 'white', connectorColor: 'var(--color-blue)', date: bookingDate },
            { icon: 'pi pi-circle-fill', name: t("TimeLineBookAccp"), color: 'white', connectorColor: 'var(--color-blue)', date: approveDate },
            { icon: 'pi pi-circle-fill', name: t("TimeLineInsCont"), color: 'white', connectorColor: 'var(--color-blue)', date: containerDate },
            { icon: 'pi pi-circle-fill', name: t("TimeLineCreBL"), color: 'white', connectorColor: 'var(--color-blue)', date: BLDate },
            { icon: approveDateBL ? 'pi pi-circle-fill' : 'pi pi-spin pi-spinner', name: t("TimeLineBLAccep"), color: 'White', connectorColor: 'var(--color-blue-light)', date: approveDateBL ? approveDateBL : '' }
        ]

    const changesFields = ['IdCommodity', 'IMO', 'DangerousGoodsId', 'FlashPT', 'PackagingGroup', 'shipmentDispatch', 'Prefix', 'Number', 'CheckDigit', 'Payload', 'Tare', 'IdEquipment', 'onOff', 'temp']

    const customOffice = ['Document Type', 'Despatch number', 'Customs office', 'Date']

    const DangerousGoods = [
        { label: 'UN No.', type: 'textfield', code: 'DangerousGoodsCode', },
        { label: 'Class', type: 'textfield', code: 'DangerousGoodsClass', },
        { label: 'Flash Point (ºC)', type: 'number', code: 'FlashPT', },
        { label: 'Package Group', type: 'textfield', code: 'PackagingGroup', },
    ]

    const SOC = [
        { label: 'Prefix', type: 'textfield', code: 'Prefix', fieldChanges: 'IdEquipment' },
        { label: 'Number', type: 'textfield', code: 'Number', fieldChanges: 'IdEquipment' },
        { label: 'Check Digit', type: 'textfield', code: 'CheckDigit', fieldChanges: 'IdEquipment' },
        { label: 'Payload', type: 'textfield', code: 'Payload', fieldChanges: 'Payload' },
        { label: 'Tare(KG)', type: 'textfield', code: 'Tare', fieldChanges: 'Tare' }
    ]

    const Reefer = [
        { label: 'On/Off', type: 'switch', code: 'onOff', fieldChanges: 'onOff' },
        { label: 'Temperature', type: 'textfield', code: 'temp', fieldChanges: 'temp' }
    ]

    const BLCustomsOfficeFields = [
        { webtrans: 'CustomsOfficeId', backend: 'Id' },
        { webtrans: 'Document Type', backend: 'PCOMCustomsDocumentTypeDesc' },
        { webtrans: 'Despatch number', backend: 'PCOMCustomsDocumentNumber' },
        { webtrans: 'Customs office', backend: 'PCOMCustomsOffice' },
        { webtrans: 'Date', backend: 'PCOMCustomsDocumentDate' },
    ]

    const BLFields = [
        { webtrans: 'voyagePortDischarge', backend: 'DischargePort' },
        { webtrans: 'voyagePortLoading', backend: 'LoadingPort' },
        { webtrans: 'voyagePlaceDelivery', backend: 'Delivery' },
        { webtrans: 'voyagePlaceReceipt', backend: 'Receipt' },
        { webtrans: 'voyageVoyageNumber', backend: 'Voyage' },
        { webtrans: 'voyageVesselName', backend: 'Vessel' },

        { webtrans: 'freightBLNumber', backend: 'BLNumber' },
        { webtrans: 'freightOriginalCopies', backend: 'NumberOriginal' },
        { webtrans: 'AddressId', backend: 'AddressId' },

        { webtrans: 'id', backend: 'Id' },
    ]

    const BLBookingFields = [
        { webtrans: 'freightBookingNumber', backend: 'BookingNumber' },
        { webtrans: 'freightClientReference', backend: 'ClientReference' },
        { webtrans: 'LocationReceiptId', backend: 'LocationReceiptId' },
        { webtrans: 'LoadingPortId', backend: 'LoadingPortId' },
        { webtrans: 'DischargePortId', backend: 'DischargePortId' },
        { webtrans: 'LocationDeliveryPortId', backend: 'LocationDeliveryPortId' },
        { webtrans: 'Transhipment', backend: 'Transhipment' },
        { webtrans: 'shipperId', backend: 'ShipperId' },
        { webtrans: 'shipperCode', backend: 'ShipperCode' },
        { webtrans: 'shipperMainVat', backend: 'ShipperVat' },
        { webtrans: 'consigneeId', backend: 'ConsigneeId' },
        { webtrans: 'consigneeCode', backend: 'ConsigneeCode' },
        { webtrans: 'consigneeMainVat', backend: 'ConsigneeVat' },
        { webtrans: 'notifyId', backend: 'NotifyId' },
        { webtrans: 'notifyCode', backend: 'NotifyCode' },
        { webtrans: 'notifyMainVat', backend: 'NotifyVat' },
        { webtrans: 'IdBooking', backend: 'Id' },
        { webtrans: 'UserCompanyId', backend: 'UserCompanyId' },
    ]

    const BLAddressFields = [
        { webtrans: 'shipperName', backend: 'ShipperAddress1' },
        { webtrans: 'shipperAddress', backend: 'ShipperAddress2' },
        { webtrans: 'shipperAddress2', backend: 'ShipperAddress3' },
        { webtrans: 'shipperZipCode', backend: 'ShipperAddress4' },
        { webtrans: 'shipperCountry', backend: 'ShipperCity' },
        { webtrans: 'shipperVat', backend: 'ShipperState' },

        { webtrans: 'consigneeName', backend: 'ConsigneeAddress1' },
        { webtrans: 'consigneeAddress', backend: 'ConsigneeAddress2' },
        { webtrans: 'consigneeAddress2', backend: 'ConsigneeAddress3' },
        { webtrans: 'consigneeZipCode', backend: 'ConsigneeAddress4' },
        { webtrans: 'consigneeCountry', backend: 'ConsigneeCity' },
        { webtrans: 'consigneeVat', backend: 'ConsigneeState' },

        { webtrans: 'notifyName', backend: 'NotifyAddress1' },
        { webtrans: 'notifyAddress', backend: 'NotifyAddress2' },
        { webtrans: 'notifyAddress2', backend: 'NotifyAddress3' },
        { webtrans: 'notifyZipCode', backend: 'NotifyAddress4' },
        { webtrans: 'notifyCountry', backend: 'NotifyCity' },
        { webtrans: 'notifyVat', backend: 'NotifyState' },
    ]

    const BLShipmentDetailsFields = [
        { webtrans: 'ShipmentDetailId', backend: 'Id' },
        { webtrans: 'nrPackage', backend: 'Package' },
        { webtrans: 'description', backend: 'Description' },
        { webtrans: 'grossWeight', backend: 'Weight' },
        { webtrans: 'measurements', backend: 'Measures' },
    ]

    const BLShipmentFields = [
        { webtrans: 'ShipmentId', backend: 'Id' },
        { webtrans: 'CommodityCode', backend: 'CommodityCode' },
        { webtrans: 'CommodityName', backend: 'CommodityName' },
        { webtrans: 'IdCommodity', backend: 'IdCommodity' },
        { webtrans: 'IMO', backend: 'IMODangerGoods' },
    ]

    const BLIMOFields = [
        { webtrans: 'IdDangerousGoodsList', backend: 'Id' },
        { webtrans: 'DangerousGoodsId', backend: 'IdDangerousGoods' },
        { webtrans: 'FlashPT', backend: 'FlashPT' },
        { webtrans: 'PackagingGroup', backend: 'PackagingGroup' },
        { webtrans: 'DangerousGoodsCode', backend: 'Code' },
        { webtrans: 'DangerousGoodsClass', backend: 'Class' },
    ]


    const shipmentDetailsList = {
        'Equipment': [
            'matricula',
            'Prefix',
            'Number',
            'CheckDigit',
            'IdEquipment',
            'equipmentType',
            'IdBookingEquipment',
            'EquipmentClassCode',
            'EquipmentTypeId',
            'IdEquipment',
            'IdEquipmentDimensions',
            'Cargo',
            'Weight',
            'Date',
            'SOC',
            'Payload',
            'Tare',
            'Width',
            'Height',
            'Length',
            'Front',
            'Back',
            'Left',
            'Right',
            'Brand',
            'Model',
            'Chassis',
            'DimensionsFROId',
            'DimensionsBACId',
            'DimensionsLEFId',
            'DimensionsRIGId',
            'DimensionsOVEId'

        ],
        'Shipment': [
            'shipment',
            'dispatchNumber',
            'CommodityCode',
            'CommodityName',
            'IdCommodity',
            'IdShipment',
            'IMO',
            'dangerousGoods'
        ],
        'ShipmentDetail': [
            'id',
            'nrPackage',
            'description',
            'grossWeight',
            'measurements',
            'IdShipmentDetails',
            'order'
            // 'shipmentChanged'
        ],
    }


    const contextCopyContainer = (isShipment) => {
        const tempArray = []

        if (selectedLine) {
            containerTypes.forEach(container => {
                if (container !== selectedLine.matricula) {
                    const tempObj = {
                        label: container,
                        items: contextMenuMoveShipment(container, isShipment, true)
                    }
                    tempArray.push(tempObj)
                }
            })
        }
        return tempArray
    }

    const contextMenuMoveContainer = (passIsShipment) => {
        const isShipment = passIsShipment !== null ? passIsShipment : false
        const tempArray = []
        if (selectedLine) {
            containerTypes.forEach(container => {
                if (container !== selectedLine.matricula) {
                    const tempObj = {
                        label: container,
                        items: contextMenuMoveShipment(container, isShipment)
                    }
                    tempArray.push(tempObj)
                }
            })
        }
        return tempArray
    }

    const contextMenuMoveShipment = (passMatricula, passIsShipment, passIsCopy) => {
        const isShipment = passIsShipment !== null ? passIsShipment : false
        const isCopy = passIsCopy !== null ? passIsCopy : false
        let tempArray = []
        if (selectedLine) {
            const tempShipments = []
            organizedData.get(passMatricula).forEach(obj => {
                if (!tempShipments.includes(obj.shipment)) tempShipments.push(obj.shipment)
            })

            tempArray = tempShipments.map(ship => {
                if (isShipment && !isCopy) return {
                    label: `Shipment ${ship}`,
                    command: () => moveToShipment(passMatricula, ship, true)
                }
                if (isCopy && isShipment) return {
                    label: `Shipment ${ship}`,
                    command: () => copy(true, selectedLine, passMatricula, ship)
                }
                if (isCopy && !isShipment) return {
                    label: `Shipment ${ship}`,
                    command: () => copy(false, selectedLine, passMatricula, ship)
                }
                if (!isShipment && !isCopy) return {
                    label: `Shipment ${ship}`,
                    command: () => moveToShipment(passMatricula, ship)
                }
            })
            if (isShipment && !isCopy) {
                tempArray.push({
                    label: 'Create new shipment',
                    command: () => moveToShipment(passMatricula, 'new', true)
                })
            }
            if (isCopy && isShipment) {
                tempArray.push({
                    label: 'Same shipment',
                    command: () => copyAsSameShipment(selectedLine, passMatricula)
                })
                tempArray.push({
                    label: 'Create new shipment',
                    command: () => copy(true, selectedLine, passMatricula, 'new')
                })
            }
            if (isCopy && !isShipment) {
                tempArray.push({
                    label: 'Create new shipment',
                    command: () => copy(false, selectedLine, passMatricula, 'new')
                })
            }
            if (!isShipment && !isCopy) {
                tempArray.push({
                    label: 'Create new shipment',
                    command: () => moveToShipment(passMatricula, 'new')
                })
            }
        }
        return tempArray
    }

    const menuModel = [
        { label: t("LabelCopyLine"), icon: 'pi pi-copy', command: () => copy() },
        {
            label: t("LabelMoveLine"),
            icon: 'pi pi-sort-alt',
            items: [
                {
                    label: t("LabelShipment"),
                    items: contextMenuMoveShipment(selectedLine?.matricula),
                },
                {
                    label: t("LabelContainer"),
                    items: contextMenuMoveContainer(),
                }
            ]
        },
        { label: t("LabelDeleteLine"), icon: 'pi pi-fw pi-times', command: () => deleteLine(selectedLine) },
        {
            separator: true
        },
        {
            label: t("LabelCopyShipment"),
            icon: 'pi pi-copy',
            items: [
                {
                    label: t("LabelSameContainer"),
                    command: () => copy(true)
                },
                {
                    label: t("LabelOtherContainer"),
                    items: contextCopyContainer(),
                }
            ]
        },
        {
            label: t("LabelMoveShipment"),
            icon: 'pi pi-sort-alt',
            items: [
                {
                    label: t("LabelShipment"),
                    items: contextMenuMoveShipment(selectedLine?.matricula, true),
                },
                {
                    label: t("LabelContainer"),
                    items: contextMenuMoveContainer(true),
                }
            ]
        },
        { label: t("LabelDeleteShipment"), icon: 'pi pi-fw pi-times', command: () => deleteLine(selectedLine, true) }
    ]

    const rebuildContextMenu = () => {
        return menuModel.map(obj => {
            if (obj.label === t("LabelCopyLine")) {
                return {
                    key: '1',
                    label: t("LabelCopyLine"),
                    icon: 'pi pi-copy',
                    items: [
                        {
                            key: '1.1',
                            label: t("LabelSameContainer"),
                            command: () => copy(false)
                        },
                        {
                            key: '1.2',
                            label: t("LabelOtherContainer"),
                            items: contextCopyContainer(false),
                        }
                    ]
                }
            }
            if (obj.label === t("LabelCopyShipment")) {
                return {
                    key: '2',
                    label: t("LabelCopyShipment"),
                    icon: 'pi pi-copy',
                    items: [
                        {
                            key: '2.1',
                            label: t("LabelSameContainer"),
                            command: () => copy(true)
                        },
                        {
                            key: '2.2',
                            label: t("LabelOtherContainer"),
                            items: contextCopyContainer(true),
                        }
                    ]
                }
            }
            if (obj.label === t("LabelMoveLine")) {
                return {
                    key: '3',
                    label: t("LabelMoveLine"),
                    icon: 'pi pi-sort-alt',
                    items: [
                        {
                            key: '3.1',
                            label: t("LabelShipment"),
                            items: contextMenuMoveShipment(selectedLine?.matricula),
                        },
                        {
                            key: '3.2',
                            label: t("LabelContainer"),
                            items: contextMenuMoveContainer(),
                        }
                    ]
                }
            }
            if (obj.label === t("LabelMoveShipment")) {
                return {
                    key: '4',
                    label: t("LabelMoveShipment"),
                    icon: 'pi pi-sort-alt',
                    items: [
                        {
                            key: '4.1',
                            label: t("LabelShipment"),
                            items: contextMenuMoveShipment(selectedLine?.matricula, true),
                        },
                        {
                            key: '4.2',
                            label: t("LabelContainer"),
                            items: contextMenuMoveContainer(true),
                        }
                    ]
                }
            }
            else {
                return obj
            }
        })

    }

    const tempContexMenu = useMemo(() => rebuildContextMenu(), [selectedLine])

    function toJSONLocal(date) {
        return date.slice(0, 10)
    }

    function reformatDate(dateStr) {
        var dArr = dateStr.split("-")  // ex input: "2010-01-18"
        return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/2010"
    }

    useEffect(() => {
        if (isFirstIteration) {
            ctx.setIsLoad(true);
            
            // Limpeza inicial
            setOrganizedData(new Map());
            setContainerTypes([]);
            
            sessionStorage.removeItem('blContext');
            sessionStorage.removeItem('operation');

            getSessionStorageData(id);
            setIsFirstIteration(false);
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys));
        }
        else {
            if (blHTMLCopy) {
                customOfficeFill();
            }
        }
        
        htmlRefresh(); 

        // eslint-disable-next-line
    }, [isFirstIteration, blHTMLCopy, id]);

    useEffect(() => {
        const processKey = varNameDict.get('freightBookingNumber')

        if (signalR && processKey) {
            signalR.joinGroup(processKey)
                .then(() => console.log(`Joined group: ${processKey}`))
                .catch(err => console.error("Error:", err))
        }
    }, [signalR, varNameDict])

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {

        const safeParse = (key) => {
            const data = sessionStorage.getItem(`${sessionID}${key}`)
            if (data === null || data === undefined || data === 'undefined') return null
            try { return JSON.parse(data) } catch (e) { return null }
        }

        const TempVND = safeParse('varNameDict')
        const TempCOD = safeParse('customOfficeDict')
        const TempDCOD = safeParse('dictCustomOfficeDict')
        const TempSI = safeParse('showInput')
        const TempLines = safeParse('lines')
        const TempDS = safeParse('docSize')
        const TempPS = safeParse('pageSize')
        const TempAPS = safeParse('auxPageSize')
        const TempDSize = safeParse('descriptionSize')
        const TempOD = safeParse('organizedData')
        const TempCT = safeParse('containerTypes')
        const TempTIDS = safeParse('totalIds')
        const TempSIndex = safeParse('shipmentIndex')
        const TempHO = safeParse('hideOriginals')
        const TempOON = safeParse('originOriginalNumber')
        const TempDON = safeParse('destinationOriginalNumber')
        const TempOCN = safeParse('originCopyNumber')
        const TempDCN = safeParse('destinationCopyNumber')
        const frmPorts = safeParse('formPorts')
        const frmEntities = safeParse('formEntities')
        const frmCustmsOff = safeParse('formCustomOffice')
        const frmshipDets = safeParse('formShipmentDetails')
        const TempBLHTML = safeParse('blHTMLCopy')
        const TempBlSecondHTML = safeParse('blSecondHTMLCopy')
        const TempBDT = safeParse('bookingDate')
        const TempO = safeParse('operation')
        const TempBLD = safeParse('BLDate')
        const TempP = safeParse('page')
        const TempAD = safeParse('approveDate')
        const TempCD = safeParse('containerDate')
        const tempES = safeParse('entitySize')
        const tempCT = safeParse('changesTabs')
        const tempDPDF = safeParse('downloadablePDF')
        const tempER = safeParse('errors')
        const TempListErrors = safeParse('listErrors')
        const TempDB = safeParse('dataBLs')

        if (TempVND || TempCOD || TempDCOD || TempSI || TempLines || TempDS || TempPS ||
            TempAPS || TempDSize || TempOD || TempCT || TempTIDS || TempSIndex || TempHO ||
            TempOON || TempDON || TempOCN || TempDCN || frmEntities || frmCustmsOff ||
            frmshipDets || TempBLHTML || TempBlSecondHTML || TempBDT || TempO || TempBLD ||
            TempP || TempAD || frmPorts || tempES || tempCT || tempDPDF || tempER || TempListErrors || TempDB) {
            setVarNameDict(new Map(TempVND))
            setCustomOfficeDict(new Map(TempCOD))
            setDictCustomOFficeDict(TempDCOD)
            setShowInput(TempSI)
            setLines(TempLines)
            setDocSize(TempDS)
            // setPageSize(TempPS)      // intentionally not restored — new defaults apply
            // setAuxPageSize(TempAPS) // intentionally not restored — new defaults apply
            setDescriptionSize(TempDSize)
            setEntitySize(tempES)
            setOrganizedData(new Map(TempOD))
            setContainerTypes(TempCT)
            setTotalIds(TempTIDS)
            setShipmentIndex(TempSIndex)
            setHideOriginals(TempHO)
            setOriginOriginalNumbers(TempOON)
            setDestinationOriginalNumber(TempDON)
            setOriginCopyNumbers(TempOCN)
            setDestinationCopyNumber(TempDCN)
            setFormPorts(frmPorts)
            setFormEntities(frmEntities)
            setFormCustomOffice(frmCustmsOff)
            setFormShipmentDetails(frmshipDets)
            setBookingDate(TempBDT)
            setBlHTMLCopy(TempBLHTML)
            setBlSecondHTMLCopy(TempBlSecondHTML)
            setOperation(TempO)
            setBLDate(TempBLD)
            setPage(TempP)
            setApproveDate(TempAD)
            setContainerDate(TempCD)
            setChangesTabs(tempCT)
            setDownloadablePDF(tempDPDF)
            setErrors(tempER)
            setListErrors(TempListErrors)
            setDataBLs(TempDB)
            htmlRefresh(TempSI, TempP, new Map(TempOD), new Map(TempVND))
            setTimeout(() => {
                setIsLoaded(false)
                ctx.setIsLoad(false)
            }, 1500)
            return
        }
        get()
        htmlRefresh()
    }

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // if (showInput !== JSON.parse(sessionStorage.getItem(`${id}showInput`))) {
        //     htmlRefresh() 
        // }
        // htmlRefresh()
        // eslint-disable-next-line
    }, [id, varNameDict, customOfficeDict, dictCustomOfficeDict, showInput,
        lines, docSize, pageSize, auxPageSize, descriptionSize,
        organizedData, containerTypes, totalIds, shipmentIndex, hideOriginals,
        originOriginalNumber, destinationOriginalNumber, originCopyNumber,
        destinationCopyNumber, formEntities, formCustomOffice, formShipmentDetails,
        blSecondHTMLCopy, blHTMLCopy, operation, BLDate, page, approveDate, containerDate, formPorts,
        entitySize, changesTabs, downloadablePDF, errors, listErrors
    ])

    useEffect(() => {
        if (sessionStorage.getItem('isPageLoading')) return
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
        // htmlRefresh()
    })


    const checkOutdatedClauses = (blId, blLastUpdate) => {
        if (!blId) return

        ClausesService.getId(`by-bl/${blId}`).then(clausesData => {
            if (Array.isArray(clausesData) && clausesData.length > 0) {
                // Verificar se alguma clause foi atualizada apÃ³s a Ãºltima atualizaÃ§Ã£o do BL
                const blUpdateDate = blLastUpdate ? new Date(blLastUpdate) : null

                const hasOutdated = clausesData.some(clause => {
                    if (!clause.LastUpdate || !blUpdateDate) return false
                    const clauseUpdateDate = new Date(clause.LastUpdate)
                    return clauseUpdateDate > blUpdateDate
                })

                setHasOutdatedClauses(hasOutdated)
                if (hasOutdated) {
                    // Guardar a data da clause mais recente para referÃªncia
                    const mostRecentClause = clausesData.reduce((latest, clause) => {
                        if (!clause.LastUpdate) return latest
                        const clauseDate = new Date(clause.LastUpdate)
                        return !latest || clauseDate > new Date(latest) ? clause.LastUpdate : latest
                    }, null)
                    setClausesLastUpdate(mostRecentClause)
                }
            } else {
                setHasOutdatedClauses(false)
            }
        }).catch(err => {
            console.error('Error checking clauses:', err)
            setHasOutdatedClauses(false)
        })
    }

    const get = () => {
        setOrganizedData(new Map());
        setContainerTypes([]);
        setVarNameDict(new Map());

        const currentContext = JSON.parse(sessionStorage.getItem('blContext'));
        const currentLineId = currentContext ? currentContext.Id : lineId;
        const currentOperation = sessionStorage.getItem('operation') || operation;

        if (!currentLineId) {
            handleTabClose(JSON.parse(id))
            toastMessages('error', t("SelectedLine"), '')
            ctx.setIsLoad(false)
            return
        }

        errorsList.getId(currentLineId).then(dataErrorList => {
            if (dataErrorList.name === 'AxiosError') {
                toastMessages('error', dataErrorList.message, '')
                handleTabClose(JSON.parse(id))
                ctx.setIsLoad(false)
                return
            }
            setListErrors(dataErrorList)
        })

        ProcessStatusService.get().then(dataProcessStatusService => {
            if (dataProcessStatusService.name === 'AxiosError') {
                handleTabClose(JSON.parse(id))
                toastMessages('error', dataProcessStatusService.message, '')
                ctx.setIsLoad(false)
                return
            }

            if (currentOperation === 'Create') {
                BLOriginalService.filter(`?page=1&pagesize=20&filter= IdBooking eq ${currentLineId}`).then(bls => {
                    if (bls.name === 'AxiosError') {
                        handleTabClose(JSON.parse(id))
                        toastMessages('error', bls.message, '')
                        ctx.setIsLoad(false)
                        return
                    }
                    if (bls.Items.length > 0) {
                        handleTabClose(JSON.parse(id))
                        toastMessages('error', '', t("LabelBookingAlreadyHasBL"))
                        ctx.setIsLoad(false)
                        return
                    }
                    BookingV2Service.getId(currentLineId).then(dataBooking => {
                        if (dataBooking.name === 'AxiosError') {
                            handleTabClose(JSON.parse(id))
                            toastMessages('error', dataBooking.message, '')
                            ctx.setIsLoad(false)
                            return
                        }

                        const tempBooking = dataBooking.Booking
                        if (tempBooking.CreatedOn !== "") {
                            setBookingDate(reformatDate(toJSONLocal(tempBooking.CreatedOn)))
                        }
                        if (tempBooking.DateApproved !== "") {
                            setApproveDate(toJSONLocal(tempBooking.DateApproved))
                        }
                        if (tempBooking.ContainerInsertedDate !== "") {
                            setContainerDate(toJSONLocal(tempBooking.ContainerInsertedDate))
                        }

                        dataBooking.ShipmentPlusList.sort((a, b) => a.Shipment.Order === b.Shipment.Order ? a.Shipment.TransportKey - b.Shipment.TransportKey : a.Shipment.Order - b.Shipment.Order)
                        dataBooking.ShipmentPlusList.forEach(ship => ship.ShipmentDetailPlusList.sort((a, b) => a.ShipmentDetail.Order === b.ShipmentDetail.Order ? a.ShipmentDetail.TransportKey - b.ShipmentDetail.TransportKey : a.ShipmentDetail.Order - b.ShipmentDetail.Order))
                        getDataManager(dataBooking, dataProcessStatusService)
                    })
                })
            } else if (currentOperation === 'Edit') {
                BLService.getId(currentLineId).then(dataBL => {
                    if (dataBL.name === 'AxiosError') {
                        handleTabClose(JSON.parse(id))
                        ctx.setIsLoad(false)
                        toastMessages('error', dataBL.Message, '')
                        return
                    }

                    auditService.getId(currentLineId).then(audit => {
                        const tempMap = new Map(Object.entries(audit)) || new Map()
                        const tempBooking = dataBL.Booking

                        if (tempBooking.DateApproved !== "") {
                            setApproveDate(toJSONLocal(tempBooking.DateApproved))
                        }
                        if (tempBooking.ContainerInsertedDate !== "") {
                            setContainerDate(toJSONLocal(tempBooking.ContainerInsertedDate))
                        }
                        
                        dataBL.ShipmentPlusBLList.sort((a, b) => a.Shipment.Order === b.Shipment.Order ? a.Shipment.TransportKey === b.Shipment.TransportKey : a.Shipment.Order - b.Shipment.Order)
                        dataBL.ShipmentPlusBLList.forEach(ship => ship.ShipmentDetailPlusBLList.sort((a, b) => a.ShipmentDetail.Order === b.ShipmentDetail.Order ? a.ShipmentDetail.TransportKey - b.ShipmentDetail.TransportKey : a.ShipmentDetail.Order - b.ShipmentDetail.Order))

                        checkOutdatedClauses(currentLineId, dataBL.BL?.LastUpdate)
                        getDataManager(dataBL, dataProcessStatusService, tempMap)
                    })
                })
            } else if (currentOperation === 'Approve') {
                approveBL.getId(currentLineId).then(dataBL => {
                    if (dataBL.name === 'AxiosError') {
                        handleTabClose(JSON.parse(id))
                        ctx.setIsLoad(false)
                        toastMessages('error', dataBL.Message, '')
                        return
                    }

                    setDataBLs(dataBL.BL)
                    auditService.getId(currentLineId).then(audit => {
                        const tempMap = new Map(Object.entries(audit)) || new Map()
                        const tempBooking = dataBL.Booking

                        if (tempBooking.DateApproved !== "") {
                            setApproveDate(toJSONLocal(tempBooking.DateApproved))
                        }
                        if (tempBooking.ContainerInsertedDate !== "") {
                            setContainerDate(toJSONLocal(tempBooking.ContainerInsertedDate))
                        }

                        dataBL.ShipmentPlusBLList.sort((a, b) => a.Shipment.Order === b.Shipment.Order ? a.Shipment.TransportKey === b.Shipment.TransportKey : a.Shipment.Order - b.Shipment.Order)
                        dataBL.ShipmentPlusBLList.forEach(ship => ship.ShipmentDetailPlusBLList.sort((a, b) => a.ShipmentDetail.Order === b.ShipmentDetail.Order ? a.ShipmentDetail.TransportKey - b.ShipmentDetail.TransportKey : a.ShipmentDetail.Order - b.ShipmentDetail.Order))

                        checkOutdatedClauses(currentLineId, dataBL.BL?.LastUpdate)
                        getDataManager(dataBL, dataProcessStatusService, tempMap)
                    })
                })
            }
        })
    }

    const getDataManager = (dataBooking, dataProcessStatusService, auditMap) => {
        const array = []
        const tempBooking = dataBooking.Booking
        let hasEquipmentNumbers = true
        let tempCustomsOfficeId = []
        let tempChangesInMenus = []
        if (operation === 'Create') {
            const tempShipments = dataBooking.ShipmentPlusList
            tempShipments.forEach((ships, indexShip) => {
                ships.ShipmentDetailPlusList.forEach((details, indexDetails) => {
                    if (details.Equipment === null) {
                        //! NO EQUIPMENT PLATE
                        // handleTabClose(JSON.parse(id))
                        // toastMessages('error', '', t("LabelBookingHasNoAssociatedConts"))
                        // return
                        hasEquipmentNumbers = false
                    }

                    const tempShipObj = {
                        'id': indexDetails + 1,
                        'equipmentType': `${details.EquipmentType.EquipmentTypeLenght}${details.EquipmentType.EquipmentTypeCode}`,
                        'prefix': details?.Equipment?.Prefix,
                        'number': details?.Equipment?.Number,
                        'checkDigit': details?.Equipment?.CheckDigit,
                        'sealA': details.BookingEquipment.SealNumberA || '',
                        'sealB': details.BookingEquipment.SealNumberB || '',
                        'marks': details.ShipmentDetail.Marks || '',

                        'IdEquipment': details?.Equipment?.Id,
                        'IdEquipmentClass': details.EquipmentType.IdEquipmentClass,
                        'EquipmentClassCode': '',
                        'SOC': details.BookingEquipment.SOC === 'N' ? false : true,
                        'Cargo': details.BookingEquipment.GoodsDetails,
                        'Weight': details.BookingEquipment.TransportDetails,
                        'Date': details.BookingEquipment.LoadingDate,
                        'Payload': details?.Equipment?.Payload,
                        'Tare': details?.Equipment?.Tare || details.EquipmentType.EquipmentTypeTareWeight,

                        'IdEquipmentDimensions': details?.BookingEquipmentDimensionsList === null || details?.BookingEquipmentDimensionsList === undefined || details?.BookingEquipmentDimensionsList.length === 0 ? 0 : details?.BookingEquipmentDimensionsList[0]?.Id,
                        'Width': details?.BookingEquipmentDimensionsList === null || details?.BookingEquipmentDimensionsList === undefined || details?.BookingEquipmentDimensionsList.length === 0 ? 0 : details.BookingEquipmentDimensionsList[0]?.DimensionsWidth || 0,
                        'Height': details?.BookingEquipmentDimensionsList === null || details?.BookingEquipmentDimensionsList === undefined || details?.BookingEquipmentDimensionsList.length === 0 ? 0 : details.BookingEquipmentDimensionsList[0]?.DimensionsHeight || 0,
                        'Length': details?.BookingEquipmentDimensionsList === null || details?.BookingEquipmentDimensionsList === undefined || details?.BookingEquipmentDimensionsList.length === 0 ? 0 : details.BookingEquipmentDimensionsList[0]?.DimensionsLength || 0,

                        'Brand': details.BookingEquipment.Brand,
                        'Model': details.BookingEquipment.Model,
                        'Chassis': details.BookingEquipment.Chassis,
                        'order': details?.Shipment?.TransportKey,
                        'cargo': [
                            {
                                'equipmentType': `${details.EquipmentType.EquipmentTypeLenght}${details.EquipmentType.EquipmentTypeCode}`,
                                'EquipmentTypeId': details.EquipmentType.Id,
                                'shipment': ships?.Shipment?.TransportKey,
                                'dispatchNumber': '',
                                'CommodityCode': ships?.Shipment?.CommodityCode,
                                'CommodityName': ships?.Shipment?.CommodityName,
                                'IdCommodity': ships?.Shipment?.IdCommodity,
                                'nrPackage': details.ShipmentDetail.Package || '',
                                'description': details.ShipmentDetail.Description || '',
                                'grossWeight': details.ShipmentDetail.Weight || '',
                                'measurements': details.ShipmentDetail.Measures || '',
                                'EquipmentClassCode': '',
                                'OnOff': ships.Shipment.Temp !== 0 && ships.Shipment.Temp !== undefined && ships.Shipment.Temp !== null ? true : false,
                                'Temperature': ships.Shipment.Temp,
                                'IdShipmentDetails': details.ShipmentDetail.Id,
                                'IdBookingEquipment': details.ShipmentDetail.IdBookingEquipment,
                                'IdShipment': details.ShipmentDetail.IdShipment,
                                'IMO': ships?.Shipment?.IMODangerGoods,
                                'dangerousGoods': ships?.ShipmentDangerousGoodsPlusList.map((imo, imoIndex) => {
                                    return {
                                        'id': imoIndex + 1,
                                        'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                                        'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                                        'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                                        'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                                        'DangerousGoodsCode': imo.DangerousGoods.Code,
                                        'DangerousGoodsClass': imo.DangerousGoods.Class,
                                    }

                                })
                            },
                        ]
                    }
                    details?.BookingEquipmentDimensionsList?.forEach(dimension => {
                        if (dimension.DimensionsCode === 'FRO') {
                            tempShipObj.Front = dimension.DimensionsLength || 0
                            tempShipObj.DimensionsFROId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'BAC') {
                            tempShipObj.Back = dimension.DimensionsLength || 0
                            tempShipObj.DimensionsBACId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'LEF') {
                            tempShipObj.Left = dimension.DimensionsWidth || 0
                            tempShipObj.DimensionsLEFId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'RIG') {
                            tempShipObj.Right = dimension.DimensionsWidth || 0
                            tempShipObj.DimensionsRIGId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'OVE') {
                            tempShipObj.Height = dimension.DimensionsHeight || 0
                            tempShipObj.DimensionsOVEId = dimension.Id
                        }
                    })


                    array.push(tempShipObj)
                })
            })
        } if (operation === 'Edit') {
            // Incluir shipments sem CustomsOffice (null) ou com CustomsOffice ativo (DbStatus === 'E')
            const tempShipments = dataBooking.ShipmentPlusBLList.filter(
                ships => !ships?.CustomsOffice || ships?.CustomsOffice?.DbStatus === 'E'
            )

            const tempCustomOffice = []
            let customIds = 1

            tempShipments.forEach((ships, indexShip) => {
                if (ships.CustomsOffice) {
                    if (!tempCustomsOfficeId.includes(ships?.CustomsOffice?.Id)) {
                        tempCustomsOfficeId.push(ships?.CustomsOffice?.Id)
                        const tempObjCustom = {
                            'id': customIds,
                            'Despatch number': ships?.CustomsOffice?.PCOMCustomsDocumentNumber,
                            'Customs office': ships?.CustomsOffice?.PCOMCustomsOffice,
                            'Date': ships?.CustomsOffice?.PCOMCustomsDocumentDate,
                            'idDocumentType': ships?.CustomsOffice?.IdCustomsDocumentType,
                            'idCustomOffice': ships?.CustomsOffice?.Id,
                            'Document Type': ships?.CustomsOffice?.PCOMCustomsDocumentTypeDesc,
                            'shipmentChanged': customsOfficedeRetardLabels(auditMap.get(ships?.CustomsOffice?.Id) || []),
                            'DBStatus': ships?.CustomsOffice?.DbStatus || 'E',
                        }

                        if (tempObjCustom?.shipmentChanged.length && !tempChangesInMenus?.includes('CustomOffice')) {
                            tempChangesInMenus.push('CustomOffice')
                        }

                        tempCustomOffice.push(tempObjCustom)
                        customIds++
                    }
                }

                ships.ShipmentDetailPlusBLList.forEach((details, indexDetails) => {
                    if (details.Equipment === null) {
                        hasEquipmentNumbers = false
                    }

                    const tempShipObj = {
                        'id': indexDetails + indexShip + 1,
                        'equipmentType': `${details.EquipmentType?.EquipmentTypeLenght || ''}${details.EquipmentType.EquipmentTypeCode}`,
                        'prefix': details?.Equipment?.Prefix,
                        'number': details?.Equipment?.Number,
                        'checkDigit': details?.Equipment?.CheckDigit,
                        'sealA': details.BookingEquipment.SealNumberA || '',
                        'sealB': details.BookingEquipment.SealNumberB || '',
                        'marks': details.ShipmentDetail.Marks || '',
                        'IdEquipment': details?.Equipment?.Id,
                        'IdEquipmentClass': details.EquipmentType.IdEquipmentClass,
                        'EquipmentClassCode': '',
                        'SOC': details.BookingEquipment.SOC === 'N' ? false : true,
                        'Cargo': details.BookingEquipment.GoodsDetails,
                        'Weight': details.BookingEquipment.TransportDetails,
                        'Date': details.BookingEquipment.LoadingDate,
                        'Payload': details?.Equipment?.Payload,
                        'Tare': details?.Equipment?.Tare || details.EquipmentType.EquipmentTypeTareWeight,
                        'Brand': details.BookingEquipment.Brand,
                        'Model': details.BookingEquipment.Model,
                        'Chassis': details.BookingEquipment.Chassis,
                        'order': details?.ShipmentDetail?.Order,
                        'cargo': [
                            {
                                'equipmentType': `${details.EquipmentType?.EquipmentTypeLenght || ''}${details.EquipmentType.EquipmentTypeCode}`,
                                'shipment': ships?.Shipment?.TransportKey,
                                'dispatchNumber': ships?.CustomsOffice?.PCOMCustomsDocumentNumber || '',
                                'CommodityCode': ships?.Shipment?.CommodityCode,
                                'CommodityName': ships?.Shipment?.CommodityName,
                                'IdCommodity': ships?.Shipment?.IdCommodity,
                                'nrPackage': details.ShipmentDetail.Package || '',
                                'description': details.ShipmentDetail.Description || '',
                                'grossWeight': details.ShipmentDetail.Weight || '',
                                'measurements': details.ShipmentDetail.Measures || '',
                                'IdShipmentDetails': details.ShipmentDetail.Id,
                                'IdBookingEquipment': details.ShipmentDetail.IdBookingEquipment,
                                'IdShipment': details.ShipmentDetail.IdShipment,
                                'EquipmentClassCode': '',
                                'IdEquipmentClass': details.EquipmentType.IdEquipmentClass,
                                'OnOff': ships.Shipment.Temp !== 0 && ships.Shipment.Temp !== undefined && ships.Shipment.Temp !== null,
                                'Temperature': ships.Shipment.Temp,
                                'IMO': ships?.Shipment?.IMODangerGoods,
                                'shipmentChanged': [
                                    ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.IdShipment) || [], 'Shipment'),
                                    ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.IdBookingEquipment) || [], 'Equipment'),
                                    ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.Id) || [], 'ShipmentDetail'),
                                    ...ShipmentdeRetardLabels(auditMap.get(ships?.ShipmentCustomsOfficeViewModel?.Id || '') || [], 'CustomsOffice'),
                                    ...((auditMap.get(ships?.ShipmentCustomsOfficeViewModel?.Id || '') || []).includes('Id') || (auditMap.get(details.ShipmentDetail.IdShipment) || []).includes('IdBooking') ? ['ShipmentId', 'ShipmentDetailId'] : [])
                                ],
                                'dangerousGoods': ships?.ShipmentDangerousGoodsPlusBLList.map((imo, imoIndex) => ({
                                    'id': imoIndex + 1,
                                    'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                                    'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                                    'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                                    'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                                    'DangerousGoodsCode': imo.DangerousGoods.Code,
                                    'DangerousGoodsClass': imo.DangerousGoods.Class,
                                    'shipmentChanged': IMOdeRetardLabels([...(auditMap.get(imo?.ShipmentDangerousGoods?.Id) || [])])
                                }))
                            },
                        ]
                    }

                    details?.BookingEquipmentDimensions?.forEach(dimension => {
                        if (dimension.DimensionsCode === 'FRO') {
                            tempShipObj.Front = dimension.DimensionsLength || 0
                            tempShipObj.DimensionsFROId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'BAC') {
                            tempShipObj.Back = dimension.DimensionsLength || 0
                            tempShipObj.DimensionsBACId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'LEF') {
                            tempShipObj.Left = dimension.DimensionsWidth || 0
                            tempShipObj.DimensionsLEFId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'RIG') {
                            tempShipObj.Right = dimension.DimensionsWidth || 0
                            tempShipObj.DimensionsRIGId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'OVE') {
                            tempShipObj.Height = dimension.DimensionsHeight || 0
                            tempShipObj.DimensionsOVEId = dimension.Id
                        }
                    })

                    array.push(tempShipObj)
                })
            })

            setDictCustomOFficeDict(tempCustomOffice)
        }


        if (operation === 'Approve') {
            // ðŸ”¹ Mostra todos os CustomsOffice (ativos e desativados)
            const tempShipments = dataBooking.ShipmentPlusBLList
            const tempCustomOffice = []
            let customIds = 1
            tempShipments.forEach((ships, indexShip) => {
                if (ships.CustomsOffice) {
                    if (!tempCustomsOfficeId.includes(ships?.CustomsOffice?.Id)) {
                        tempCustomsOfficeId.push(ships?.CustomsOffice?.Id)

                        const tempObjCustom = {
                            'id': customIds,
                            'Despatch number': ships?.CustomsOffice?.PCOMCustomsDocumentNumber,
                            'Customs office': ships?.CustomsOffice?.PCOMCustomsOffice,
                            'Date': ships?.CustomsOffice?.PCOMCustomsDocumentDate,
                            'idDocumentType': ships?.CustomsOffice?.IdCustomsDocumentType,
                            'idCustomOffice': ships?.CustomsOffice?.Id,
                            'Document Type': ships?.CustomsOffice?.PCOMCustomsDocumentTypeDesc,
                            'shipmentChanged': customsOfficedeRetardLabels(auditMap.get(ships?.CustomsOffice?.Id) || []),
                            'DBStatus': ships?.CustomsOffice?.DbStatus || 'E', // E-Enabled, D-Disabled
                        }

                        if (tempObjCustom?.shipmentChanged.length && !tempChangesInMenus?.includes('CustomOffice')) {
                            tempChangesInMenus.push('CustomOffice')
                        }

                        tempCustomOffice.push(tempObjCustom)
                        customIds++
                    }
                }

                ships.ShipmentDetailPlusBLList.forEach((details, indexDetails) => {

                    if (details.Equipment === null) {
                        hasEquipmentNumbers = false
                    }

                    const tempShipObj = {
                        'id': indexDetails + indexShip + 1,
                        'equipmentType': `${details.EquipmentType?.EquipmentTypeLenght || ''}${details.EquipmentType.EquipmentTypeCode}`,
                        'prefix': details?.Equipment?.Prefix,
                        'number': details?.Equipment?.Number,
                        'checkDigit': details?.Equipment?.CheckDigit,
                        'sealA': details.BookingEquipment.SealNumberA || '',
                        'sealB': details.BookingEquipment.SealNumberB || '',
                        'marks': details.ShipmentDetail.Marks || '',
                        'IdEquipment': details?.Equipment?.Id,
                        'IdEquipmentClass': details.EquipmentType.IdEquipmentClass,
                        'EquipmentClassCode': '',
                        'SOC': details.BookingEquipment.SOC === 'N' ? false : true,
                        'Cargo': details.BookingEquipment.GoodsDetails,
                        'Weight': details.BookingEquipment.TransportDetails,
                        'Date': details.BookingEquipment.LoadingDate,
                        'Payload': details?.Equipment?.Payload,
                        'Tare': details?.Equipment?.Tare || details.EquipmentType.EquipmentTypeTareWeight,
                        'Brand': details.BookingEquipment.Brand,
                        'Model': details.BookingEquipment.Model,
                        'Chassis': details.BookingEquipment.Chassis,
                        'order': details?.ShipmentDetail?.Order,
                        'DBStatus': details?.ShipmentDetail?.DbStatus || 'Epahhh',
                        'cargo': [
                            {
                                'equipmentType': `${details.EquipmentType?.EquipmentTypeLenght || ''}${details.EquipmentType.EquipmentTypeCode}`,
                                'shipment': ships?.Shipment?.TransportKey,
                                'dispatchNumber': ships?.CustomsOffice?.PCOMCustomsDocumentNumber || '',
                                'CommodityCode': ships?.Shipment?.CommodityCode,
                                'CommodityName': ships?.Shipment?.CommodityName,
                                'IdCommodity': ships?.Shipment?.IdCommodity,
                                'nrPackage': details.ShipmentDetail.Package || '',
                                'description': details.ShipmentDetail.Description || '',
                                'grossWeight': details.ShipmentDetail.Weight || '',
                                'measurements': details.ShipmentDetail.Measures || '',
                                'DbStatus': ships?.Shipment?.DbStatus || 'fddddd',
                                'IdShipmentDetails': details.ShipmentDetail.Id,
                                'IdBookingEquipment': details.ShipmentDetail.IdBookingEquipment,
                                'IdShipment': details.ShipmentDetail.IdShipment,
                                'EquipmentClassCode': '',
                                'IdEquipmentClass': details.EquipmentType.IdEquipmentClass,
                                'OnOff': ships.Shipment.Temp !== 0 && ships.Shipment.Temp !== undefined && ships.Shipment.Temp !== null,
                                'Temperature': ships.Shipment.Temp,
                                'IMO': ships?.Shipment?.IMODangerGoods,
                                'shipmentChanged': [
                                    ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.IdShipment) || [], 'Shipment'),
                                    ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.IdBookingEquipment) || [], 'Equipment'),
                                    ...ShipmentdeRetardLabels(auditMap.get(details.ShipmentDetail.Id) || [], 'ShipmentDetail'),
                                    ...ShipmentdeRetardLabels(auditMap.get(ships?.ShipmentCustomsOfficeViewModel?.Id || '') || [], 'CustomsOffice'),
                                    ...((auditMap.get(ships?.ShipmentCustomsOfficeViewModel?.Id || '') || []).includes('Id') || (auditMap.get(details.ShipmentDetail.IdShipment) || []).includes('IdBooking') ? ['ShipmentId', 'ShipmentDetailId'] : [])
                                ],
                                'dangerousGoods': ships?.ShipmentDangerousGoodsPlusBLList.map((imo, imoIndex) => ({
                                    'id': imoIndex + 1,
                                    'IdDangerousGoodsList': imo.ShipmentDangerousGoods.Id,
                                    'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                                    'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                                    'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                                    'DangerousGoodsCode': imo.DangerousGoods.Code,
                                    'DangerousGoodsClass': imo.DangerousGoods.Class,
                                    'shipmentChanged': IMOdeRetardLabels([...(auditMap.get(imo?.ShipmentDangerousGoods?.Id) || [])])
                                }))
                            },
                        ]
                    }

                    details?.BookingEquipmentDimensions?.forEach(dimension => {
                        if (dimension.DimensionsCode === 'FRO') {
                            tempShipObj.Front = dimension.DimensionsLength || 0
                            tempShipObj.DimensionsFROId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'BAC') {
                            tempShipObj.Back = dimension.DimensionsLength || 0
                            tempShipObj.DimensionsBACId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'LEF') {
                            tempShipObj.Left = dimension.DimensionsWidth || 0
                            tempShipObj.DimensionsLEFId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'RIG') {
                            tempShipObj.Right = dimension.DimensionsWidth || 0
                            tempShipObj.DimensionsRIGId = dimension.Id
                        }
                        if (dimension.DimensionsCode === 'OVE') {
                            tempShipObj.Height = dimension.DimensionsHeight || 0
                            tempShipObj.DimensionsOVEId = dimension.Id
                        }
                    })

                    array.push(tempShipObj)
                })

            })

            setDictCustomOFficeDict(tempCustomOffice)
        }


        fetchHTML().then((data) => {
            setBlSecondHTML(docTagsService.tagRemoval(data[1]))
            setBlSecondHTMLCopy(data[1])
            setBlHTML(docTagsService.tagRemoval(data[0]))
            setBlHTMLCopy(data[0])
            const tempValuesMap = new Map(docTagsService.getVarNameDict())
            if (operation === 'Create') {
                tempValuesMap.set('voyagePortDischarge', tempBooking.LocationDischargePortName || '')
                tempValuesMap.set('voyagePortLoading', tempBooking.LocationLoadingPortName || '')
                tempValuesMap.set('voyagePlaceDelivery', tempBooking.LocationDeliveryPortName || '')
                tempValuesMap.set('voyagePlaceReceipt', tempBooking.LocationReceiptPortName || '')
                tempValuesMap.set('voyageVoyageNumber', tempBooking.VoyageNumber || '')
                tempValuesMap.set('voyageVesselCode', tempBooking.VesselCode || '')
                tempValuesMap.set('voyageVesselName', tempBooking.VesselName || '')
            }

            BLBookingFields.forEach(elem => {
                if (elem.webtrans === 'Transhipment') {
                    tempValuesMap.set(elem.webtrans, tempBooking[elem.backend] === 'N' || tempBooking[elem.backend] === '' ? false : true)
                } else {
                    tempValuesMap.set(elem.webtrans, tempBooking[elem.backend] || '')
                }
            })

            if (tempBooking.CreatedOn !== "") {
                const tempBookingCreatedOn = reformatDate(toJSONLocal(tempBooking.CreatedOn))
                setBookingDate(tempBookingCreatedOn)
            }

            if (operation === 'Edit' || operation === 'Approve') {
                const dataAddress = dataBooking.Address
                const dataBL = dataBooking.BL

                BLFields.forEach(elem => {
                    tempValuesMap.set(elem.webtrans, dataBL[elem.backend] || '')
                })

                BLAddressFields.forEach(elem => {
                    tempValuesMap.set(elem.webtrans, dataAddress[elem.backend] || '')
                })

                tempValuesMap.set('shipmentChanged', BLdeRetardLabels([...(auditMap.get(dataBL.Id) || []), ...(auditMap.get(tempBooking.Id) || []), ...(auditMap.get(dataAddress.Id) || [])]))

                if (portsLocations.some(loc => tempValuesMap.get('shipmentChanged').includes(loc.id))) {
                    tempChangesInMenus.push('Ports')
                }
                if (['shipperId', 'consigneeId', 'notifyId'].concat(BLAddressFields).some(adr => tempValuesMap.get('shipmentChanged').includes(adr.webtrans))) {
                    tempChangesInMenus.push('Entities')
                }


                setChangesTabs(tempChangesInMenus)


                setOriginOriginalNumbers(dataBL.OriginOriginalNumber)
                setDestinationOriginalNumber(dataBL.DestinationOriginalNumber)
                setOriginCopyNumbers(dataBL.OriginCopyNumber)
                setDestinationCopyNumber(dataBL.DestinationCopyNumber)

                if (dataBL.DateApproved !== "") {
                    setApproveDateBL(dataBL.DateApproved)
                }

                if (dataBL.CreatedOn !== "") {
                    const tempBLdate = reformatDate(toJSONLocal(dataBL.CreatedOn))
                    setBLDate(tempBLdate)
                }
            }
            dataProcessStatusService.Items.forEach(data2 => {
                if (data2.StatusName === 'Waiting for Approval') {
                    if (tempBooking.ProcessStatusId === data2.Id) {
                        handleTabClose(JSON.parse(id))
                        ctx.setIsLoad(false)
                        toastMessages('error', '', t("LabelStillInApproval"))
                        return
                    }
                    tempValuesMap.set('WaitingApproval', data2.Id)
                }
                if (data2.StatusName === 'Approved') {
                    if (dataBooking?.BL?.ProcessStatusId === data2?.Id) {
                        setDownloadablePDF(true)
                    }
                }
            })
            setVarNameDict(new Map(tempValuesMap))
        })

        let tempId = totalIds
        let tempShipIndex = shipmentIndex
        const tempContainerTypesArray = []
        const tempData = []
        let tempEquipmentIds = equipmentIndex
        let tempEquipIdsMap = new Map()
        array.forEach((container) => {
            container.cargo.forEach((cargo) => {
                let matricula = ''
                if (!container.prefix && !container.number && !container.checkDigit) {
                    if (tempEquipIdsMap.get(cargo.IdBookingEquipment)) {
                        matricula = tempEquipIdsMap.get(cargo.IdBookingEquipment)
                    } else {
                        matricula = `To Be Filled ${tempEquipmentIds}`
                        tempEquipIdsMap.set(cargo.IdBookingEquipment, matricula)
                        tempEquipmentIds++
                    }
                } else {
                    matricula = `${container.prefix} ${container.number} ${container.checkDigit} ${container.sealA} ${container.sealB} `
                }

                const tempObj = {
                    'id': tempId,
                    'matricula': matricula,
                    'Prefix': container.prefix,
                    'Number': container.number,
                    'CheckDigit': container.checkDigit,
                    'sealA': container.sealA,
                    'sealB': container.sealB,
                    'marks': container.marks,
                    'shipment': cargo.shipment,
                    'equipmentType': container.equipmentType,
                    'dispatchNumber': cargo.dispatchNumber,
                    'CommodityCode': cargo.CommodityCode,
                    'CommodityName': cargo.CommodityName,
                    'IdCommodity': cargo.IdCommodity,
                    'nrPackage': cargo.nrPackage,
                    'description': cargo.description,
                    'grossWeight': cargo.grossWeight,
                    'measurements': cargo.measurements,
                    'IdShipmentDetails': cargo.IdShipmentDetails,
                    'IdBookingEquipment': cargo.IdBookingEquipment,
                    'IdShipment': cargo.IdShipment,
                    'IdEquipmentClass': container.IdEquipmentClass,
                    'EquipmentClassCode': container.EquipmentClassCode,
                    'IdEquipment': container.IdEquipment,
                    'IdEquipmentDimensions': container.IdEquipmentDimensions,
                    'SOC': container.SOC,
                    'Cargo': container.Cargo,
                    'Weight': container.Weight,
                    'Date': container.Date,
                    'Payload': container.Payload,
                    'Tare': container.Tare,
                    'Width': container.Width,
                    'Length': container.Length,
                    'Height': container.Height,
                    'Front': container.Front,
                    'Back': container.Back,
                    'Left': container.Left,
                    'Right': container.Right,
                    'DimensionsFROId': container.DimensionsFROId,
                    'DimensionsBACId': container.DimensionsBACId,
                    'DimensionsLEFId': container.DimensionsLEFId,
                    'DimensionsRIGId': container.DimensionsRIGId,
                    'DimensionsOVEId': container.DimensionsOVEId,
                    'Brand': container.Brand,
                    'Model': container.Model,
                    'Chassis': container.Chassis,
                    'OnOff': cargo.OnOff,
                    'Temperature': cargo.Temperature,
                    'IMO': cargo.IMO,
                    'dangerousGoods': cargo.dangerousGoods,
                    'shipmentChanged': cargo.shipmentChanged,
                    'order': container.order,
                    'DBStatus': container.DBStatus || 'E',
                    'shipmentDBStatus': cargo.DbStatus || 'E',

                }
                if (tempObj.shipmentChanged?.length > 0 && !tempChangesInMenus?.includes('ShipmentDetails')) {
                    tempChangesInMenus.push('ShipmentDetails')
                }
                if (!tempChangesInMenus?.includes('ShipmentDetails') && tempObj?.dangerousGoods?.some(dang => dang?.shipmentChanged?.length > 0)) {
                    tempChangesInMenus.push('ShipmentDetails')
                }

                if (!tempContainerTypesArray.includes(tempObj.matricula)) {
                    tempContainerTypesArray.push(tempObj.matricula)
                }
                tempShipIndex = tempShipIndex <= tempObj.shipment ? tempObj.shipment : tempShipIndex

                tempId = tempId + 1
                tempData.push(tempObj)
            })
            setEquipmentIndex(tempEquipmentIds)
        })
        tempShipIndex++
        setShipmentIndex(tempShipIndex)

        //* Save Data by matricula in Map

        tempContainerTypesArray.forEach(type => {
            const tempObjArray = []
            tempData.forEach(obj => {
                if (obj.matricula === type) {
                    tempObjArray.push(obj)
                }
            })
            organizedData.set(type, tempObjArray)
        })

        setTotalIds(tempId)

        //* get all equipment types 

        const tempOrganize = new Map()
        const tempMap = new Map()

        tempContainerTypesArray.forEach(container => {
            //* if there's already this this of equipment 
            if (tempMap.get(organizedData.get(container)[0].equipmentType)) {
                const tempMapArray = tempMap.get(organizedData.get(container)[0].equipmentType)
                tempMapArray.push({ 'key': container, 'value': organizedData.get(container) })
                //* if there isn't:
            } else {
                tempMap.set(organizedData.get(container)[0].equipmentType, [{ 'key': container, 'value': organizedData.get(container) }])
            }
        })

        //* reorganized Data and matricula Map with equipment types
        const tempContainer = []
        tempMap.forEach((value, key) => {
            value.forEach(obj => {
                tempOrganize.set(obj.key, obj.value)
                tempContainer.push(obj.key)
            })
        })
        setOrganizedData(new Map(tempOrganize))
        setContainerTypes(tempContainer)
        htmlRefresh()
        setTimeout(() => {
            setIsLoaded(false)
            ctx.setIsLoad(false)
        }, 1500)
    }

    const BLdeRetardLabels = (newList) => {
        const tempList = []
        newList.forEach(el => {
            BLFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
            BLBookingFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
            BLAddressFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
        })
        return tempList
    }

    const deleteBL = () => {
        BLServiceDelete.delete(dataBLs.Id).then(data => {
            if (data.name === "AxiosError") {
                ctx.toastMessages('error', '', data.response.data.Message || data.message)
                return
            }
            setOpenConfirm(true)
        })
    }

    const ShipmentdeRetardLabels = (newList, type) => {
        const tempList = []
        if (type === 'CustomsOffice') {

        }
        newList.forEach(el => {
            if (type === 'ShipmentDetail') {
                BLShipmentDetailsFields.forEach(elem => {
                    if (elem.backend === el) {
                        tempList.push(elem.webtrans)
                    }
                })
            }
            if (type === 'Shipment') {
                BLShipmentFields.forEach(elem => {
                    if (elem.backend === el) {
                        tempList.push(elem.webtrans)
                    }
                })
            }
            if (type === 'CustomsOffice') {
                if (el === 'CustomsOfficeId') {
                    tempList.push('shipmentDispatch')
                }
            }
        })
        return tempList
    }

    const IMOdeRetardLabels = (newList) => {
        const tempList = []
        newList.forEach(el => {
            BLIMOFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
        })
        return tempList
    }

    const customsOfficedeRetardLabels = (newList) => {
        const tempList = []
        newList.forEach(el => {
            BLCustomsOfficeFields.forEach(elem => {
                if (elem.backend === el) {
                    tempList.push(elem.webtrans)
                }
            })
        })
        return tempList
    }


    const redefineData = (data, containers) => {
        let tempArray
        containers.forEach(type => {
            const tempArrayShip = []
            tempArray = data.get(type).map(obj => {
                if (tempArrayShip.includes(obj.shipment)) {
                    return { ...obj, 'nrPackage': null, 'grossWeight': null, 'measurements': null }
                } else {
                    tempArrayShip.push(obj.shipment)
                    //* IF NEED ANOTHER FIELD FOR MAIN LINE ADJUST HERE
                    return obj
                }
            })
            organizedData.set(type, tempArray)
        })
        setOrganizedData(new Map(organizedData))
    }

    const addRejectFields = (e, label, key, dict) => {
        if (e.target.checked === true) {
            setRejectFields(new Map(rejectFields.set(key, { 'key': key, 'label': label, 'value': dict.get(key), 'Notes': '' })))
        }
        else {
            rejectFields.delete(key)
            setRejectFields(new Map(rejectFields))
        }
    }

    const customOfficeFill = () => {
        customOffice.forEach((elem) => {
            customOfficeDict.set(elem, '')
            setCustomOfficeDict(new Map(customOfficeDict))
        })
    }

    const fetchHTML = async () => {
        const tempData = await (await fetch('/bl/figma_htmlgenerator/BL_NAIP.html')).text()
        const tempSecondData = await (await fetch('/bl/figma_htmlgenerator/blSecondPage.html')).text()
        return [tempData, tempSecondData]
    }

    const htmlRefresh = (passBol, tempPage, sentData, passGlobalDict) => {
        let tempBLCopy = blHTMLCopy
        let tempBL2Copy = blSecondHTMLCopy
        if (!tempBLCopy) return
        const bol = passBol !== null && passBol !== undefined ? passBol : showInput
        const newPage = tempPage ? tempPage : page
        const newData = sentData ? sentData : organizedData
        const globalDict = passGlobalDict ? passGlobalDict : varNameDict
        const OGData = []
        containerTypes.forEach(container => {
            newData.get(container)?.forEach(obj => {
                OGData.push(obj)
            })
        })
        globalDict.set('freightOriginalCopies', docSize)
        const tempData = docTagsService.updateDoc(tempBLCopy, globalDict, OGData, bol, 1, pageSize, auxPageSize, docSize)
        let tempSecondData
        if (tempData === undefined) return
        if (tempData[1] >= pageSize) {
            setVarNameDict(new Map(globalDict.set('blPage', (newPage - 1))))
            tempSecondData = docTagsService.updateDoc(tempBL2Copy, globalDict, OGData, bol, newPage, pageSize, auxPageSize, docSize)

            if (tempSecondData[1] >= auxPageSize) {
                let tempLines = tempSecondData[1]
                let totalPages = 0
                while (tempLines >= 0) {
                    tempLines = tempLines - auxPageSize
                    totalPages = totalPages + 1
                }
                const newDocSize = totalPages + 1
                setDocSize(newDocSize)
                globalDict.set('freightOriginalCopies', newDocSize)
            }
            setLines(tempSecondData[1])
            setBlSecondHTML(tempSecondData[0])
        } else {
            setLines(tempData[1])
        }
        setBlHTML(tempData[0])
        if (newPage == 1) {
            return tempData[0]
        } else {
            return tempSecondData[0]
        }
    }

    const inputChanged = (key, value) => {
        if (key === 'voyagePlaceReceipt') {
            if (value === '') {
                varNameDict.set('Transhipment', false)
            } else {
                varNameDict.set('Transhipment', true)
            }
        }

        if (typeof value === 'string' || value instanceof String) {
            value = value.toLocaleUpperCase()
        }

        setVarNameDict(new Map(varNameDict.set(key, value)))
        htmlRefresh()

    }

    const inputCustomOffice = () => {
        //if (!customOfficeDict.get('Document Type') || !customOfficeDict.get('Despatch number') || !customOfficeDict.get('Customs office')) {
        if (!customOfficeDict.get('Document Type') || !customOfficeDict.get('Despatch number')) {
            ctx.toastMessages('error', t('MessageRequiredFields'))
            return
        }

        const tempObj = { ...Object.fromEntries(customOfficeDict), shipmentChanged: [], 'id': (dictCustomOfficeDict[dictCustomOfficeDict.length - 1]?.id + 1 || 1) }
        setDictCustomOFficeDict(prev => [...prev, tempObj])
        customOfficeFill()
    }

    const updateContainer = (key, value) => {
        if (typeof value === 'string' || value instanceof String) {
            value = value.toLocaleUpperCase()
        }
        newContainerMap.set(key, value)
        setNewContainerMap(new Map(newContainerMap))
    }

    const createContainer = () => {
        const tempArray = []
        let errorBol = false
        const tempObj = {
            'id': totalIds,

            'matricula': `${newContainerMap.get('Prefix') || ''} ${newContainerMap.get('Number')} ${newContainerMap.get('CheckDigit')} `,
            'Prefix': newContainerMap.get('Prefix') || '',
            'Number': newContainerMap.get('Number'),
            'CheckDigit': newContainerMap.get('CheckDigit'),
            'IdEquipment': newContainerMap.get('IdEquipment'),

            'shipment': shipmentIndex,
            'equipmentType': newContainerMap.get('EquipmentType'),

            'dispatchNumber': '',
            'CommodityCode': '',
            'CommodityName': '',
            'IdCommodity': '',

            'nrPackage': '',
            'description': '',
            'grossWeight': '',
            'measurements': '',

            'IdShipmentDetails': '00000000-0000-0000-0000-000000000000',
            'IdBookingEquipment': '00000000-0000-0000-0000-000000000000',
            'IdShipment': '00000000-0000-0000-0000-000000000000',
            'EquipmentClassCode': newContainerMap.get('EquipmentClassCode'),
            'EquipmentTypeId': newContainerMap.get('EquipmentTypeId'),
            'IdEquipment': newContainerMap.get('IdEquipment'),
            'IdEquipmentDimensions': newContainerMap.get('IdEquipmentDimensions'),
            'Cargo': newContainerMap.get('Cargo'),
            'Weight': newContainerMap.get('Weight'),
            'Date': newContainerMap.get('Date'),
            'SOC': newContainerMap.get('SOC'),
            'Payload': newContainerMap.get('Payload'),
            'Tare': newContainerMap.get('Tare'),

            'OnOff': newContainerMap.get('OnOff') === undefined ? true : newContainerMap.get('OnOff'),
            'Temperature': newContainerMap.get('Temperature'),

            'Width': newContainerMap.get('Width'),
            'Height': newContainerMap.get('Height'),
            'Length': newContainerMap.get('Length'),
            'Front': newContainerMap.get('Front'),
            'Back': newContainerMap.get('Back'),
            'Right': newContainerMap.get('Right'),
            'Left': newContainerMap.get('Left'),
            'Brand': newContainerMap.get('Brand'),
            'Model': newContainerMap.get('Model'),
            'Chassis': newContainerMap.get('Chassis'),
            'IMO': false,
            'dangerousGoods': [],
            'shipmentChanged': []
        }

        if (!tempObj.equipmentType) {
            toastMessages('error', 'NO EQUIPMENT TYPE', '')
            errorBol = true
        } else {
            if ((tempObj.Number?.length !== 6 || tempObj.CheckDigit?.length !== 1)) {
                if (tempObj.SOC === true) {
                    toastMessages('error', t('SOCEmpty'), '')
                    errorBol = true
                } else {
                    tempObj.matricula = `To Be Filled ${equipmentIndex}`
                }
            }
            if (tempObj.equipmentType.search('RF') !== -1 && tempObj.OnOff === true && (tempObj.Temperature === '' || tempObj.Temperature === undefined)) {
                toastMessages('error', t('tempEmpty'), '')
                errorBol = true
            }
            if ((tempObj.equipmentType.search('RORO') !== -1 || tempObj.equipmentType.search('BULK') !== -1) && (tempObj.Width === '' || tempObj.Width === undefined || tempObj.Height === '' || tempObj.Height === undefined || tempObj.Length === '' || tempObj.Length === undefined)) {
                toastMessages('error', t('dimensionsEmpty'), '')
                errorBol = true
            }
            if ((tempObj.equipmentType.search('RORO') !== -1 || tempObj.equipmentType.search('BULK') !== -1) && (tempObj.Brand === '' || tempObj.Brand === undefined || tempObj.Model === '' || tempObj.Model === undefined || tempObj.Chassis === '' || tempObj.Chassis === undefined)) {
                toastMessages('error', t('ROROEmpty'), '')
                errorBol = true
            }
        }


        if (errorBol === false) {
            const tempShipIndex = shipmentIndex + 1
            const tempTotalIds = totalIds + 1
            const tempEquipmentIds = equipmentIndex + 1
            setTotalIds(tempTotalIds)
            setShipmentIndex(tempShipIndex)
            setEquipmentIndex(tempEquipmentIds)
            setContainerTypes(prev => [...prev, tempObj.matricula])
            organizedData.set(tempObj.matricula, [tempObj])

            // return
            setOrganizedData(new Map(organizedData))
            cancelContainer()
        }
    }

    const cancelContainer = () => {
        setNewContainerMap(new Map())
        setOpenContainer(false)
    }

    const showForm = (n) => {
        switch (n) {
            case 1:
                setFormEntities(true)
                setFormCustomOffice(false)
                setFormShipmentDetails(false)
                setFormPorts(false)
                setFormAdditionalFields(false)
                break
            case 2:
                setFormEntities(false)
                setFormCustomOffice(true)
                setFormShipmentDetails(false)
                setFormPorts(false)
                setFormAdditionalFields(false)
                break
            case 3:
                setFormEntities(false)
                setFormCustomOffice(false)
                setFormShipmentDetails(true)
                setFormPorts(false)
                setFormAdditionalFields(false)
                break
            case 4:
                setFormEntities(false)
                setFormCustomOffice(false)
                setFormShipmentDetails(false)
                setFormPorts(true)
                setFormAdditionalFields(false)
                break
            case 5:
                setFormEntities(false)
                setFormCustomOffice(false)
                setFormShipmentDetails(false)
                setFormPorts(false)
                setFormAdditionalFields(true)
                break
            default:
                return null
        }
    }

    const handleClickOpen = () => {
        setHideOriginals(false)
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const toLocal = (date) => {
        const local = new Date(date)
        local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
        return local.toJSON()
    }

    const validateBL = () => {
        const errors = []

        containerTypes.forEach(container => {
            const rows = organizedData.get(container) || []

            // agrupa por shipment
            const shipmentsMap = {}
            rows.forEach(row => {
                const shipment = row.shipment || 'Unknown'
                if (!shipmentsMap[shipment]) shipmentsMap[shipment] = []
                shipmentsMap[shipment].push(row)
            })

            // valida cada shipment
            Object.entries(shipmentsMap).forEach(([shipmentName, shipmentRows]) => {
                const hasDescription = shipmentRows.some(row => row.description?.trim() !== '')
                const hasNrPackage = shipmentRows.some(row => Number(row.nrPackage) > 0)
                const hasGrossWeight = shipmentRows.some(row => Number(row.grossWeight) > 0)

                if (!(hasDescription && hasNrPackage && hasGrossWeight)) {
                    errors.push(
                        `${t("Shipment")} ${shipmentName}: ${t("AtLeastOneLineMustHave")} "Description", "Nr. of Packages" ${t("And")} "Gross Weight".`
                    )
                }
            })
        })

        return errors
    }





    const submitBl = () => {
        ctx.setIsLoad(true)

        const validationErrors = validateBL()
        if (validationErrors.length > 0) {
            ctx.setIsLoad(false)
            setOpen(false)
            toastMessages(
                'error',
                '',
                <div>
                    {validationErrors.map((err, i) => (
                        <div key={i}>{err}</div>
                    ))}
                </div>
            )
            return
        }


        const BLObj = dataToUpdate()
        if (BLObj?.Error) {
            ctx.setIsLoad(false)
            toastMessages('error', '', BLObj?.Message)
            return
        } else {

            //post BL
            if (operation === 'Create') {
                BLService.post(BLObj).then(resBL => {
                    ctx.setIsLoad(false)
                    if (resBL.name === 'AxiosError') {
                        // if (Array.isArray(resBL?.response?.data?.Errors)) {
                        //     ctx.toastMessages('error', resBL?.response?.data?.Errors.toString(), 'Erro, ')
                        // } else {
                        ctx.toastMessages('error', resBL?.response.data.Message, 'Error: ')
                        // }
                        return
                    }
                    const blId = resBL?.BL?.Id ?? resBL?.Id ?? varNameDict.get('id')
                    if (blId && extensionFormRef.current?.canSave?.()) {
                        extensionFormRef.current.handleCreate(blId)
                    } else if (extensionFormRef.current && !extensionFormRef.current.canSave()) {
                        toastMessages('warning', '', t('ExtensionFieldsInvalid') || 'Extension fields are incomplete.')
                    }
                    handleTabClose(JSON.parse(id))
                    toastMessages('success', '', t("LabelBLCreated"))
                })
            }
            if (operation === 'Edit') {
                BLService.update(varNameDict.get('id'), BLObj).then(resBL => {
                    ctx.setIsLoad(false)
                    if (resBL.name === 'AxiosError') {
                        ctx.toastMessages('error', resBL?.response.data.Message, 'Error: ')
                        return
                    }
                    if (extensionFormRef.current?.canSave?.()) {
                        extensionFormRef.current.handleSave()
                    } else if (extensionFormRef.current) {
                        toastMessages('warning', '', t('ExtensionFieldsInvalid') || 'Extension fields are incomplete.')
                    }
                    handleTabClose(JSON.parse(id))
                    toastMessages('success', '', t("LabelBLUpdated"))
                })
            }

        }
    }

    const addCustomOffice = (key, value) => {

        if (typeof value === 'string' || value instanceof String) {
            value = value.toLocaleUpperCase()
        }

        customOfficeDict.set(key, value)
        setCustomOfficeDict(new Map(customOfficeDict))
    }

    const getValuesInput = () => {
        docTagsService.getVarNameInputArray().forEach((name) => {
            let tempVar = document.getElementById(name.toUpperCase())?.value
            if (tempVar === undefined) {
                return
            }
            if (typeof tempVar === 'string' || tempVar instanceof String) {
                tempVar = tempVar.toLocaleUpperCase()
            }
            varNameDict.set(name, tempVar)
        })
        setVarNameDict(new Map(varNameDict))
        containerTypes.forEach(container => {
            organizedData.get(container).forEach(obj => {
                columns.forEach(col => {
                    let tempValue = document.getElementById(`${obj.id}${col}`)?.value
                    if (tempValue === undefined) {
                        return
                    }
                    if (typeof tempValue === 'string' || tempValue instanceof String) {
                        tempValue = tempValue.toLocaleUpperCase()
                    }
                    if (col === 'description') {
                        if (tempValue.length > descriptionSize) {
                            //* split value
                            let tempString = tempValue
                            let tempIds = totalIds
                            const tempOldObj = {
                                ...obj,
                                'description': tempString.slice(0, descriptionSize),
                            }
                            let tempLinesArray = []
                            while (tempString.length > descriptionSize) {
                                tempString = tempString.slice(descriptionSize)
                                const tempNewObj = {
                                    ...obj,
                                    'id': tempIds,
                                    'nrPackage': '',
                                    'description': tempString.slice(0, descriptionSize),
                                    'grossWeight': '',
                                    'measurements': '',
                                    'IdShipmentDetails': '',
                                    'shipmentChanged': []
                                }
                                tempIds++
                                tempLinesArray.push(tempNewObj)
                            }
                            setTotalIds(tempIds)
                            const tempArray = organizedData.get(obj.matricula)
                            const tempData = []
                            tempArray.forEach(obj2 => {
                                if (obj2.id === obj.id) {
                                    tempData.push(tempOldObj)
                                    tempData.push(...tempLinesArray)
                                } else {
                                    tempData.push(obj2)
                                }
                            })
                            organizedData.set(obj.matricula, tempData)
                            setOrganizedData(new Map(organizedData))
                            return
                        }
                    }
                    editLine(tempValue, obj, col)
                })
                // read marks input from BL draft
                let tempMarks = document.getElementById(`${obj.id}marks`)?.value
                if (tempMarks !== undefined) {
                    if (typeof tempMarks === 'string' || tempMarks instanceof String) {
                        tempMarks = tempMarks.toLocaleUpperCase()
                    }
                    editLine(tempMarks, obj, 'marks')
                }
            })
        })
    }

    const editLine = (changes, oldLine, field) => {
        let tempObj = oldLine
        if (typeof changes === 'string' || changes instanceof String) {
            changes = changes.toLocaleUpperCase()
        }
        tempObj[field] = changes
        const tempArray = organizedData.get(oldLine.matricula).map(elem => {
            return elem.id === field.id ? tempObj : elem
        })
        organizedData.set(oldLine.matricula, tempArray)
        setOrganizedData(new Map(organizedData))
    }

    const editDispatch = (changes, oldLine) => {
        let tempArray = []
        if (typeof changes === 'string' || changes instanceof String) {
            changes = changes.toLocaleUpperCase()
        }
        containerTypes.forEach((type) => {
            tempArray = organizedData.get(type).map(obj => {
                if (obj.shipment === oldLine.shipment) {
                    return { ...obj, 'dispatchNumber': changes }
                }
                return obj
            })
            organizedData.set(type, tempArray)
        })
        setOrganizedData(new Map(organizedData))
    }

    const editCommodity = (changes, oldLine) => {
        let tempArray = []
        containerTypes.forEach((type) => {
            tempArray = organizedData.get(type).map(obj => {
                if (obj.shipment === oldLine.shipment) {
                    return {
                        ...obj,
                        'CommodityCode': typeof changes.get('CommodityCode') === 'string' || changes.get('CommodityCode') instanceof String ? changes.get('CommodityCode').toLocaleUpperCase() : changes.get('CommodityCode'),
                        'CommodityName': typeof changes.get('CommodityName') === 'string' || changes.get('CommodityName') instanceof String ? changes.get('CommodityName').toLocaleUpperCase() : changes.get('CommodityName'),
                        'IdCommodity': changes.get('Id'),
                    }
                }
                return obj
            })
            organizedData.set(type, tempArray)
        })
        setOrganizedData(new Map(organizedData))
    }

    const testDescriptionStringSize = (data, index, position) => {
        if (data.length < position) {
            return data
        }
        if (data.lastIndexOf(' ', position) === 0) {
            data = data.slice(1,)
        }
        if (data.lastIndexOf(' ', position) === -1) {
            if (data.indexOf(' ') === -1) { return data }
            return data.slice(index, data.indexOf(' '))
        }
        return data.slice(index, data.lastIndexOf(' ', position))
    }

    const onCellEditComplete = (row, field) => {
        if (field === 'description') {
            if (row.description?.length > descriptionSize) {
                //* split value
                let tempString = row.description
                let tempIds = totalIds
                const tempOldObj = {
                    ...row,
                    'description': testDescriptionStringSize(tempString, 0, descriptionSize),
                }
                let tempLinesArray = []
                if (tempString.indexOf(' ') === -1) return
                let i = 0
                while (tempString.length > descriptionSize && i < 500) {
                    if (tempString.lastIndexOf(' ', descriptionSize) === 0) {
                        tempString = tempString.slice(1,)
                    }
                    if (tempString.lastIndexOf(' ') === -1 && tempString.indexOf(' ')) break
                    tempString = tempString.lastIndexOf(' ', descriptionSize) === -1 ? tempString.slice(tempString.indexOf(' ')) : tempString.slice(tempString.lastIndexOf(' ', descriptionSize))
                    const tempNewObj = {
                        ...row,
                        'id': tempIds,
                        'nrPackage': '',
                        'description': testDescriptionStringSize(tempString, 0, descriptionSize),
                        'grossWeight': '',
                        'measurements': '',
                        'IdShipmentDetails': '',
                        'shipmentChanged': []
                    }
                    tempIds++
                    tempLinesArray.push(tempNewObj)
                    i++
                }
                setTotalIds(tempIds)
                const tempArray = organizedData.get(row.matricula)
                const tempData = []
                tempArray.forEach(obj => {
                    if (obj.id === row.id) {
                        tempData.push(tempOldObj)
                        tempData.push(...tempLinesArray)
                    } else {
                        tempData.push(obj)
                    }
                })
                organizedData.set(row.matricula, tempData)
                setOrganizedData(new Map(organizedData))
            }
        }
        const tempBol = false
        if (tempBol === false) {
            getValuesInput()
        }
        htmlRefresh()
    }

    const columns = ["nrPackage", "description", "grossWeight", "measurements"]

    const headerBody = (e, col) => {
        if (col === 'grossWeight') {
            col = 'Gross Weight'
        }
        if (col === 'measurements') {
            col = 'Measures'
        }
        return col
    }

    const containerColumns = columns.map(col => {
        if (matches) {
            return <Column
                headerStyle={{
                    borderBottom: `2px solid ${ctx.primaryColor}`,
                    color: ctx.secondaryColor,
                    backgroundColor: 'var(--color-white)',
                }}
                onDrop={(e) => {
                    handleDrop(e)
                    setHoverIndex(null)
                    mergeLines(hoverLine, anchorDrag, e.ctrlKey)
                }}
                onDragEnter={(e) => dragEnter(e)}
                className='tableShipmentColumn'
                key={col}
                style={{
                    // backgroundColor: 'var(--color-yellow)',
                    ...(col === 'description'
                        ? { minWidth: '280px', maxWidth: '100%', cursor: 'text' }
                        : { minWidth: '90px', maxWidth: '90px', cursor: 'text' })
                }}
                columnKey={col}
                header={(e) => headerBody(e, col)
                }
                body={(e) => cellBody(e, col)}
            />
        } else {
            return <Column

                headerStyle={{
                    borderBottom: `2px solid ${ctx.primaryColor}`,
                    color: ctx.secondaryColor,
                    backgroundColor: 'var(--color-white)',
                }}
                onDrop={(e) => {
                    handleDrop(e)
                    setHoverIndex(null)
                    mergeLines(hoverLine, anchorDrag, e.ctrlKey)
                }}
                onDragEnter={(e) => dragEnter(e)}
                className='tableShipmentColumn'
                style={{ cursor: 'text' }}
                key={col}
                columnKey={col}
                header={col}
                body={(e) => cellBody(e, col)} />
        }
    })

    const dynamicContainerColumns = columns.map(col => {
        if (matches) {
            return <Column
                headerStyle={{ display: 'none' }}
                onDrop={(e) => {
                    handleDrop(e)
                    setHoverIndex(null)
                    mergeLines(hoverLine, anchorDrag, e.ctrlKey)
                }}
                onDragEnter={(e) => dragEnter(e)}
                className='tableShipmentColumn'
                key={col}
                style={col === 'description' ? { 'padding': '0px', 'minWidth': '280px', 'maxWidth': '280px', 'cursor': 'text' } : { 'padding': '0px', 'minWidth': '90px', 'maxWidth': '90px', 'cursor': 'text' }}
                columnKey={col}
                body={(e) => cellBody(e, col)} />
        } else {
            return <Column
                headerStyle={{ display: 'none' }}
                onDrop={(e) => {
                    handleDrop(e)
                    setHoverIndex(null)
                    mergeLines(hoverLine, anchorDrag, e.ctrlKey)
                }}
                onDragEnter={(e) => dragEnter(e)}
                className='tableShipmentColumn'
                key={col}
                style={{ display: 'none' }}
                columnKey={col}
                body={(e) => cellBody(e, col)} />
        }
    })

    const header = (data) => {
        return (
            <span className="image-text headerStyle" style={{ justifyContent: 'space-between', flexDirection: 'row', flexWrap: 'nowrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div><b style={{ color: 'var(--color-blue)' }}>{data}</b></div>
                </div>
                <b>{organizedData.get(data)[0].equipmentType}</b>
            </span>
        )

    }


    const checkShipmentChanges = (data) => {
        if (data?.shipmentChanged?.some(field => changesFields.includes(field))) {
            return true
        }
        if (data?.dangerousGoods?.some(obj => obj?.shipmentChanged?.some(field => changesFields?.includes(field)))) {
            return true
        }
    }

    const subHeader = (data) => {

        let tempValues = []
        let tempIsIn = false
        organizedData.get(data.matricula).forEach(obj => {
            if (tempIsIn) {
                if (obj.shipment !== data.shipment) {
                    tempIsIn = false
                } else {
                    tempValues.push(obj)
                }
            }
            if (obj.id === data.id) {
                tempIsIn = true
                tempValues.push(obj)
            }
        })
        let tempBol
        tempValues.length > 1 ? tempBol = tempValues.length : tempBol = 0
        const isDeleted = tempValues.every(obj => obj.DBStatus === 'D')
        const isNewShipment = tempValues.every(obj => obj?.shipmentChanged?.includes('ShipmentId') && obj?.shipmentChanged?.includes('ShipmentDetailId'))

        return (
            <div
                onDrop={(e) => {
                    handleDrop(e)
                    setHoverIndex(null)
                    mergeShip(isDragShip, hoverLine, e.ctrlKey)
                }}
                onDragEnter={(e) => dragEnterShip(e)}
                id='shipment'
                className='subHeaderContainer'
                style={{
                    borderRadius: '5px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: ((33 * tempBol) - 37) / 2,
                    paddingBottom: ((33 * tempBol) - 37) / 2,
                    border: isDeleted ? '2px solid var(--color-red)' : isNewShipment ? '2px solid var(--color-green)' : 'transparent',
                    backgroundColor: isDeleted ? 'var(--color-grey)' : 'var(--color-white)',
                    margin: '5px'
                }}>
                <div className='cursorDefault' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '65px', minWidth: '115px', borderRadius: '5px', padding: '5px', position: 'relative' }}>
                    <div id={data.id} className='image-text'>Shipment {data.shipment}</div>
                    <div className='shipmentButtons' style={{ maxHeight: '10px', width: 'auto' }}>
                        {!isDeleted ?
                            <Tooltip title={t('copyShipment')}>

                                <ContentCopyIcon className='cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => copy(true, data, data.matricula, data.shipment)} />
                            </Tooltip>
                            : null}
                        {!isDeleted ?
                            <Tooltip title={t('deleteShipment')}>
                                <CancelIcon className='buttonColorRed cursorPointer' style={{ transform: 'scale(.6)' }} onClick={() => deleteLine(data, true)} />
                            </Tooltip>
                            : null}
                        <Tooltip title={t('shipmentOptions')}>
                            <Settings
                                className={'cursorPointer'}
                                style={{
                                    color: checkShipmentChanges(data) && !data?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : data.dispatchNumber === "" ? 'var(--color-blue)' : 'var(--color-green)',
                                    transform: 'scale(.65)'
                                }}
                                onClick={() => {
                                    if (data.dangerousGoods.length !== 0) {
                                        setImoCounter(data.dangerousGoods[data.dangerousGoods.length - 1].id + 1)
                                        setShipmentToDispatch({
                                            ...data,
                                            onOff: data.OnOff,
                                            temp: data.Temperature
                                        })
                                    } else {
                                        const tempArray = data?.dangerousGoods || []
                                        let tempObj = { id: imoCounter }
                                        DangerousGoods.forEach(imo => {
                                            tempObj[imo.code] = null
                                        })
                                        tempArray.push(tempObj)
                                        setShipmentToDispatch({
                                            ...data,
                                            dangerousGoods: tempArray,
                                            onOff: data.OnOff,
                                            temp: data.Temperature
                                        })
                                        setImoCounter(imoCounter + 1)
                                    }
                                    setOpenElement(true)
                                }} />
                        </Tooltip>
                    </div>
                    <div className='dispatchDisplay' style={{ marginTop: '18px', fontSize: '13px', maxWidth: '108px' }}>{data?.dispatchNumber || ''}</div>
                </div>
                <i className="pi pi-bars subHeaderOrder"
                    style={{
                        marginRight: '5px',
                        cursor: 'grab'
                    }}
                    draggable="true"
                    onDragEnd={handleDragEnd}
                    onDragStart={(e) => {
                        handleDragStart(e, 'shipment', data)
                        setIsDragShip(data)
                    }} >
                </i>
            </div >
        )
    }

    const copyAsSameShipment = (passLine, passMatricula) => {
        let tempArray = organizedData.get(passLine.matricula).filter(obj => obj.shipment === passLine.shipment)

        let tempIds = totalIds
        tempArray = tempArray.map(obj => {
            const tempObj = {
                ...obj,
                'id': tempIds,
                'IdShipmentDetails': '',
                'matricula': passMatricula,
                'Prefix': organizedData.get(passMatricula)[0].Prefix,
                'Number': organizedData.get(passMatricula)[0].Number,
                'CheckDigit': organizedData.get(passMatricula)[0].CheckDigit,
                'IdEquipment': organizedData.get(passMatricula)[0].IdEquipment,
                'equipmentType': organizedData.get(passMatricula)[0].equipmentType,
                'EquipmentClassCode': organizedData.get(passMatricula)[0].EquipmentClassCode,
                'EquipmentTypeId': organizedData.get(passMatricula)[0].EquipmentTypeId,
                'Cargo': organizedData.get(passMatricula)[0].Cargo,
                'Weight': organizedData.get(passMatricula)[0].Weight,
                'Date': organizedData.get(passMatricula)[0].Date,
                'SOC': organizedData.get(passMatricula)[0].SOC,
                'Payload': organizedData.get(passMatricula)[0].Payload,
                'Tare': organizedData.get(passMatricula)[0].Tare,
                'IdBookingEquipment': organizedData.get(passMatricula)[0].IdBookingEquipment,
                'IdEquipment': organizedData.get(passMatricula)[0].IdEquipment,
                'IdEquipmentDimensions': organizedData.get(passMatricula)[0].IdEquipmentDimensions,
                'Width': organizedData.get(passMatricula)[0].Width,
                'Height': organizedData.get(passMatricula)[0].Height,
                'Length': organizedData.get(passMatricula)[0].Length,
                'Front': organizedData.get(passMatricula)[0].Front,
                'Back': organizedData.get(passMatricula)[0].Back,
                'Left': organizedData.get(passMatricula)[0].Left,
                'Right': organizedData.get(passMatricula)[0].Right,
                'DimensionsFROId': organizedData.get(passMatricula)[0].DimensionsFROId,
                'DimensionsBACId': organizedData.get(passMatricula)[0].DimensionsBACId,
                'DimensionsLEFId': organizedData.get(passMatricula)[0].DimensionsLEFId,
                'DimensionsRIGId': organizedData.get(passMatricula)[0].DimensionsRIGId,
                'DimensionsOVEId': organizedData.get(passMatricula)[0].DimensionsOVEId,
                'Brand': organizedData.get(passMatricula)[0].Brand,
                'Model': organizedData.get(passMatricula)[0].Model,
                'Chassis': organizedData.get(passMatricula)[0].Chassis,
                'shipmentChanged': []
            }
            tempIds++
            return tempObj
        })

        const tempNewArray = organizedData.get(passMatricula)
        tempNewArray.push(...tempArray)
        organizedData.set(passMatricula, tempNewArray)
        setOrganizedData(new Map(organizedData))
    }

    const addShipment = (passdata, position) => {
        let tempIndex = shipmentIndex
        let tempIds = totalIds
        const data = passdata
        const tempObj = {
            ...data,
            'id': tempIds,
            'shipment': tempIndex,
            'dispatchNumber': '',
            'CommodityCode': '',
            'CommodityName': '',
            'IdCommodity': '',
            'nrPackage': '',
            'description': '',
            'grossWeight': '',
            'measurements': '',
            'IdShipment': '',
            'IdShipmentDetails': '',
            'dangerousGoods': [],
            'IMO': false,
            'shipmentChanged': []
        }
        tempIndex++
        tempIds++

        const tempData = []
        let tempBol = false
        let isIncluded = false
        organizedData.get(data.matricula).forEach(obj => {
            if (tempBol === false) {
                if (obj.shipment === data.shipment) {
                    if (position === 'top' && isIncluded === false) {
                        tempData.push(tempObj)
                        isIncluded = true
                    } if (position === 'bottom' && isIncluded === false) {
                        tempBol = true
                    }
                }
                tempData.push(obj)
            } else {
                if (obj.shipment !== data.shipment) {
                    tempData.push(tempObj)
                    isIncluded = true
                    tempBol = false
                }
                tempData.push(obj)
            }
        })
        if (isIncluded === false) {
            tempData.push(tempObj)
        }


        setShipmentIndex(tempIndex)
        setTotalIds(tempIds)

        organizedData.set(data.matricula, tempData)
        setOrganizedData(new Map(organizedData))
        htmlRefresh()
    }

    const addLine = (e, position) => {
        const tempObj = {
            ...e,
            'id': totalIds,
            'nrPackage': '',
            'description': '',
            'grossWeight': '',
            'measurements': '',
            IdShipmentDetails: '',
            'shipmentChanged': []
        }
        const tempData = []
        organizedData.get(e.matricula).forEach(obj => {
            if (obj.id === e.id) {
                if (position === 'bottom') {
                    tempData.push(obj)
                    tempData.push(tempObj)
                } else {
                    tempData.push(tempObj)
                    tempData.push(obj)
                }
            } else {
                tempData.push(obj)
            }
        })
        organizedData.set(e.matricula, tempData)
        setOrganizedData(new Map(organizedData))

        setTotalIds(prev => prev + 1)
        htmlRefresh()
    }

    const moveToShipment = (passMatricula, shipment, passIsShipment, moveShipment, passSelectLine) => {
        const tempSelectedLine = passSelectLine ? passSelectLine : selectedLine
        const isShipment = passIsShipment ? passIsShipment : false
        const matricula = passMatricula ? passMatricula : selectedLine.matricula
        const oldShipment = moveShipment ? moveShipment : selectedLine.shipment

        if (isShipment) {

            //* MOVING ONE SHIPMENT (MULTI LINE) TO ANOTHER SHIPMENT

            let tempShip
            if (shipment === 'new') {
                let tempShipIndex = shipmentIndex
                tempShip = tempShipIndex
                tempShipIndex++
                setShipmentIndex(tempShipIndex)
            } else {
                tempShip = shipment
            }
            let tempArray = organizedData.get(tempSelectedLine.matricula).filter(obj => obj.shipment === oldShipment)
            const tempOldArray = organizedData.get(tempSelectedLine.matricula).filter(obj => obj.shipment !== oldShipment)
            let tempNewArray = []
            if (tempSelectedLine.matricula === passMatricula) {
                tempNewArray = organizedData.get(tempSelectedLine.matricula).filter(obj => obj.shipment !== oldShipment)
            } else {
                tempNewArray = organizedData.get(passMatricula)

            }
            tempArray = tempArray.map(obj => {
                return {
                    ...obj,
                    'matricula': passMatricula,
                    'equipmentType': organizedData.get(passMatricula)[0].equipmentType,
                    'shipment': tempShip,
                    'dispatchNumber': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.dispatchNumber || '',
                    'CommodityCode': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.CommodityCode || '',
                    'CommodityName': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.CommodityName || '',
                    'IdCommodity': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.IdCommodity || '',
                    'IdBookingEquipment': organizedData.get(passMatricula)[0].IdBookingEquipment,
                    'IdShipment': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.IdShipment || '',
                    'dangerousGoods': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.dangerousGoods || [],
                    'IMO': organizedData.get(matricula).filter(filt => filt.shipment === tempShip)[0]?.IMO || false,

                    'IdShipmentDetails': '',

                    'Prefix': organizedData.get(passMatricula)[0]?.Prefix,
                    'Number': organizedData.get(passMatricula)[0]?.Number,
                    'CheckDigit': organizedData.get(passMatricula)[0]?.CheckDigit,
                    'IdEquipment': organizedData.get(passMatricula)[0]?.IdEquipment,
                    'equipmentType': organizedData.get(passMatricula)[0]?.equipmentType,
                    'EquipmentClassCode': organizedData.get(passMatricula)[0]?.EquipmentClassCode,
                    'EquipmentTypeId': organizedData.get(passMatricula)[0]?.EquipmentTypeId,
                    'IdEquipment': organizedData.get(passMatricula)[0].IdEquipment,
                    'IdEquipmentDimensions': organizedData.get(passMatricula)[0].IdEquipmentDimensions,
                    'Cargo': organizedData.get(passMatricula)[0]?.Cargo,
                    'Weight': organizedData.get(passMatricula)[0]?.Weight,
                    'Date': organizedData.get(passMatricula)[0]?.Date,
                    'SOC': organizedData.get(passMatricula)[0]?.SOC,
                    'Payload': organizedData.get(passMatricula)[0]?.Payload,
                    'Tare': organizedData.get(passMatricula)[0]?.Tare,
                    'IdBookingEquipment': organizedData.get(passMatricula)[0]?.IdBookingEquipment,
                    'Width': organizedData.get(passMatricula)[0]?.Width,
                    'Height': organizedData.get(passMatricula)[0]?.Height,
                    'Length': organizedData.get(passMatricula)[0]?.Length,
                    'Front': organizedData.get(passMatricula)[0]?.Front,
                    'Back': organizedData.get(passMatricula)[0]?.Back,
                    'Left': organizedData.get(passMatricula)[0]?.Left,
                    'Right': organizedData.get(passMatricula)[0]?.Right,
                    'DimensionsFROId': organizedData.get(passMatricula)[0]?.DimensionsFROId,
                    'DimensionsBACId': organizedData.get(passMatricula)[0]?.DimensionsBACId,
                    'DimensionsLEFId': organizedData.get(passMatricula)[0]?.DimensionsLEFId,
                    'DimensionsRIGId': organizedData.get(passMatricula)[0]?.DimensionsRIGId,
                    'DimensionsOVEId': organizedData.get(passMatricula)[0]?.DimensionsOVEId,

                    'Brand': organizedData.get(passMatricula)[0]?.Brand,
                    'Model': organizedData.get(passMatricula)[0]?.Model,
                    'Chassis': organizedData.get(passMatricula)[0]?.Chassis,
                }
            })

            const tempData = []
            let tempBol = false
            let isIncluded = false
            tempNewArray.forEach(obj => {
                if (tempBol === false) {
                    if (obj.shipment === tempShip) {
                        tempBol = true
                    }
                    tempData.push(obj)
                } else {
                    if (obj.shipment !== tempShip) {
                        tempArray.forEach(newObj => {
                            tempData.push(newObj)
                        })
                        isIncluded = true
                        tempBol = false
                    }
                    tempData.push(obj)
                }
            })
            if (isIncluded === false) {
                tempArray.forEach(newObj => {
                    tempData.push(newObj)
                })
            }


            if (tempOldArray.length === 0) {
                if (shipment === 'new') {
                    tempShip++
                } else {
                    tempShip = shipmentIndex
                }
                tempOldArray.push({
                    'id': totalIds,
                    'matricula': tempSelectedLine.matricula,
                    'equipmentType': tempSelectedLine.equipmentType,
                    'shipment': tempShip,
                    'dispatchNumber': '',
                    'CommodityCode': '',
                    'CommodityName': '',
                    'IdCommodity': '',
                    'nrPackage': '',
                    'description': '',
                    'grossWeight': '',
                    'measurements': '',
                    'IdShipment': '',
                    'IdBookingEquipment': tempSelectedLine.IdBookingEquipment,
                    'IdShipmentDetails': '',
                    'dangerousGoods': [],
                    'IMO': false,

                    'Prefix': tempSelectedLine?.Prefix,
                    'Number': tempSelectedLine?.Number,
                    'CheckDigit': tempSelectedLine?.CheckDigit,
                    'IdEquipment': tempSelectedLine?.IdEquipment,
                    'equipmentType': tempSelectedLine?.equipmentType,
                    'EquipmentClassCode': tempSelectedLine?.EquipmentClassCode,
                    'EquipmentTypeId': tempSelectedLine?.EquipmentTypeId,
                    'IdEquipment': tempSelectedLine?.IdEquipment,
                    'IdEquipmentDimensions': tempSelectedLine?.IdEquipmentDimensions,
                    'Cargo': tempSelectedLine?.Cargo,
                    'Weight': tempSelectedLine?.Weight,
                    'Date': tempSelectedLine?.Date,
                    'SOC': tempSelectedLine?.SOC,
                    'Payload': tempSelectedLine?.Payload,
                    'Tare': tempSelectedLine?.Tare,
                    'IdBookingEquipment': tempSelectedLine?.IdBookingEquipment,
                    'Width': tempSelectedLine?.Width,
                    'Height': tempSelectedLine?.Height,
                    'Length': tempSelectedLine?.Length,
                    'Front': tempSelectedLine?.Front,
                    'Back': tempSelectedLine?.Back,
                    'Left': tempSelectedLine?.Left,
                    'Right': tempSelectedLine?.Right,
                    'DimensionsFROId': tempSelectedLine?.DimensionsFROId,
                    'DimensionsBACId': tempSelectedLine?.DimensionsBACId,
                    'DimensionsLEFId': tempSelectedLine?.DimensionsLEFId,
                    'DimensionsRIGId': tempSelectedLine?.DimensionsRIGId,
                    'DimensionsOVEId': tempSelectedLine?.DimensionsOVEId,


                    'Brand': tempSelectedLine?.Brand,
                    'Model': tempSelectedLine?.Model,
                    'Chassis': tempSelectedLine?.Chassis,
                    'shipmentChanged': []
                })
                tempShip++
                setShipmentIndex(tempShip)
                setTotalIds(prev => prev + 1)
            }

            organizedData.set(tempSelectedLine.matricula, tempOldArray)
            organizedData.set(matricula, tempData)
            setOrganizedData(new Map(organizedData))


        } else {
            //* shipment - shipment a passar
            //* matricula - matricula a passar

            //* MOVING ONE LINE TO ANOTHER SHIPMENT

            const newArray = organizedData.get(tempSelectedLine.matricula).filter(obj => obj.shipment === tempSelectedLine.shipment)
            let tempArray = []
            if (newArray.length === 1) {
                let tempId = totalIds
                const tempObj = {
                    ...tempSelectedLine,
                    'id': tempId,
                    'nrPackage': '',
                    'description': '',
                    'grossWeight': '',
                    'measurements': '',
                    IdShipmentDetails: '',
                    'shipmentChanged': []
                }
                tempArray = organizedData.get(tempSelectedLine.matricula)
                tempArray = tempArray.map(obj => {
                    if (obj.id === tempSelectedLine.id) {
                        return tempObj
                    } else return obj
                })
                tempId++
                setTotalIds(tempId)

            } else {
                tempArray = organizedData.get(tempSelectedLine.matricula).filter(obj => obj.id !== tempSelectedLine.id)
            }
            organizedData.set(tempSelectedLine.matricula, tempArray)

            const tempNewArray = organizedData.get(matricula)

            let tempObj

            if (shipment === 'new') {
                let tempShip = shipmentIndex
                tempObj = {
                    ...tempSelectedLine,
                    'matricula': matricula,
                    'equipmentType': organizedData.get(matricula)[0].equipmentType,
                    'shipment': tempShip,
                    'dispatchNumber': '',
                    'CommodityCode': '',
                    'CommodityName': '',
                    'IdCommodity': '',
                    'IdShipment': '',
                    'IdBookingEquipment': organizedData.get(matricula)[0].IdBookingEquipment,
                    'dangerousGoods': [],
                    'IMO': false,

                    'IdShipmentDetails': '',
                    'Prefix': organizedData.get(matricula)[0]?.Prefix,
                    'Number': organizedData.get(matricula)[0]?.Number,
                    'CheckDigit': organizedData.get(matricula)[0]?.CheckDigit,
                    'IdEquipment': organizedData.get(matricula)[0]?.IdEquipment,
                    'equipmentType': organizedData.get(matricula)[0]?.equipmentType,
                    'EquipmentClassCode': organizedData.get(matricula)[0]?.EquipmentClassCode,
                    'EquipmentTypeId': organizedData.get(matricula)[0]?.EquipmentTypeId,
                    'IdEquipment': organizedData.get(matricula)[0]?.IdEquipment,
                    'IdEquipmentDimensions': organizedData.get(matricula)[0]?.IdEquipmentDimensions,
                    'Cargo': organizedData.get(matricula)[0]?.Cargo,
                    'Weight': organizedData.get(matricula)[0]?.Weight,
                    'Date': organizedData.get(matricula)[0]?.Date,
                    'SOC': organizedData.get(matricula)[0]?.SOC,
                    'Payload': organizedData.get(matricula)[0]?.Payload,
                    'Tare': organizedData.get(matricula)[0]?.Tare,
                    'IdBookingEquipment': organizedData.get(matricula)[0]?.IdBookingEquipment,
                    'Width': organizedData.get(matricula)[0]?.Width,
                    'Height': organizedData.get(matricula)[0]?.Height,
                    'Length': organizedData.get(matricula)[0]?.Length,
                    'Front': organizedData.get(matricula)[0]?.Front,
                    'Back': organizedData.get(matricula)[0]?.Back,
                    'Left': organizedData.get(matricula)[0]?.Left,
                    'Right': organizedData.get(matricula)[0]?.Right,
                    'DimensionsFROId': organizedData.get(matricula)[0]?.DimensionsFROId,
                    'DimensionsBACId': organizedData.get(matricula)[0]?.DimensionsBACId,
                    'DimensionsLEFId': organizedData.get(matricula)[0]?.DimensionsLEFId,
                    'DimensionsRIGId': organizedData.get(matricula)[0]?.DimensionsRIGId,
                    'DimensionsOVEId': organizedData.get(matricula)[0]?.DimensionsOVEId,

                    'Brand': organizedData.get(matricula)[0]?.Brand,
                    'Model': organizedData.get(matricula)[0]?.Model,
                    'Chassis': organizedData.get(matricula)[0]?.Chassis,
                }
                tempShip++
                setShipmentIndex(tempShip)
            } else {
                tempObj = {
                    ...selectedLine,
                    'matricula': matricula,
                    'equipmentType': organizedData.get(matricula)[0].equipmentType,
                    'shipment': shipment,
                    'dispatchNumber': organizedData.get(matricula)[0].dispatchNumber,
                    'CommodityCode': organizedData.get(matricula)[0].CommodityCode,
                    'CommodityName': organizedData.get(matricula)[0].CommodityName,
                    'IdCommodity': organizedData.get(matricula)[0].IdCommodity,
                    'IdShipment': organizedData.get(matricula).filter(filt => filt.shipment === shipment)[0]?.IdShipment || '',
                    'IdBookingEquipment': organizedData.get(matricula)[0].IdBookingEquipment || '',
                    'dangerousGoods': organizedData.get(matricula)[0].dangerousGoods,
                    'IMO': organizedData.get(matricula)[0].IMO,

                    'IdShipmentDetails': '',
                    'Prefix': organizedData.get(matricula)[0]?.Prefix,
                    'Number': organizedData.get(matricula)[0]?.Number,
                    'CheckDigit': organizedData.get(matricula)[0]?.CheckDigit,
                    'IdEquipment': organizedData.get(matricula)[0]?.IdEquipment,
                    'equipmentType': organizedData.get(matricula)[0]?.equipmentType,
                    'EquipmentClassCode': organizedData.get(matricula)[0]?.EquipmentClassCode,
                    'EquipmentTypeId': organizedData.get(matricula)[0]?.EquipmentTypeId,
                    'IdEquipment': organizedData.get(matricula)[0]?.IdEquipment,
                    'IdEquipmentDimensions': organizedData.get(matricula)[0]?.IdEquipmentDimensions,
                    'Cargo': organizedData.get(matricula)[0]?.Cargo,
                    'Weight': organizedData.get(matricula)[0]?.Weight,
                    'Date': organizedData.get(matricula)[0]?.Date,
                    'SOC': organizedData.get(matricula)[0]?.SOC,
                    'Payload': organizedData.get(matricula)[0]?.Payload,
                    'Tare': organizedData.get(matricula)[0]?.Tare,
                    'IdBookingEquipment': organizedData.get(matricula)[0]?.IdBookingEquipment,
                    'Width': organizedData.get(matricula)[0]?.Width,
                    'Height': organizedData.get(matricula)[0]?.Height,
                    'Length': organizedData.get(matricula)[0]?.Length,
                    'Front': organizedData.get(matricula)[0]?.Front,
                    'Back': organizedData.get(matricula)[0]?.Back,
                    'Left': organizedData.get(matricula)[0]?.Left,
                    'Right': organizedData.get(matricula)[0]?.Right,
                    'DimensionsFROId': organizedData.get(matricula)[0]?.DimensionsFROId,
                    'DimensionsBACId': organizedData.get(matricula)[0]?.DimensionsBACId,
                    'DimensionsLEFId': organizedData.get(matricula)[0]?.DimensionsLEFId,
                    'DimensionsRIGId': organizedData.get(matricula)[0]?.DimensionsRIGId,
                    'DimensionsOVEId': organizedData.get(matricula)[0]?.DimensionsOVEId,

                    'Brand': organizedData.get(matricula)[0]?.Brand,
                    'Model': organizedData.get(matricula)[0]?.Model,
                    'Chassis': organizedData.get(matricula)[0]?.Chassis,
                }
            }

            const tempData = []
            let tempBol = false
            let isIncluded = false
            tempNewArray.forEach(obj => {
                if (tempBol === false) {
                    if (obj.shipment === tempObj.shipment) {
                        tempBol = true
                    }
                    tempData.push(obj)
                } else {
                    if (obj.shipment !== tempObj.shipment) {
                        tempData.push(tempObj)
                        isIncluded = true
                        tempBol = false
                    }
                    tempData.push(obj)
                }
            })
            if (isIncluded === false) {
                tempData.push(tempObj)
            }
            organizedData.set(matricula, tempData)
            setOrganizedData(new Map(organizedData))
        }
        htmlRefresh()
    }

    const copy = (passIsShipment, passLine, passMatricula, passShipment) => {
        const isShipment = passIsShipment !== null ? passIsShipment : false
        const line = passLine ? passLine : selectedLine
        const matricula = passMatricula ? passMatricula : line.matricula
        const shipment = passShipment ? passShipment : line.shipment
        let tempId = totalIds
        if (isShipment) {
            const tempOldArray = organizedData.get(line.matricula).filter(obj => obj.shipment === line.shipment)
            const tempNewArray = organizedData.get(line.matricula)

            let shipIndex = shipmentIndex

            tempOldArray.forEach(obj => {
                const tempObj = {
                    ...obj,
                    'id': tempId,
                    'shipment': shipIndex,
                    IdShipment: '',
                    IdShipmentDetails: ''
                }
                tempId++
                tempNewArray.push(tempObj)
            })
            organizedData.set(line.matricula, tempNewArray)
            setOrganizedData(new Map(organizedData))

            if (line.matricula !== matricula) {
                moveToShipment(matricula, shipment, isShipment, shipIndex, line)
            }
            shipIndex++
            setShipmentIndex(shipIndex)
        } else {
            const tempObj = {
                ...line,
                'id': tempId,
                IdShipmentDetails: ''
            }
            const tempData = []
            let tempBol = false
            let isIncluded = false
            organizedData.get(line.matricula).forEach(obj => {
                if (tempBol === false) {
                    if (obj.shipment === tempObj.shipment) {
                        tempBol = true
                    }
                    tempData.push(obj)
                } else {
                    if (obj.shipment !== tempObj.shipment) {
                        tempData.push(tempObj)
                        isIncluded = true
                        tempBol = false
                    }
                    tempData.push(obj)
                }
            })
            if (isIncluded === false) {
                tempData.push(tempObj)
            }
            organizedData.set(line.matricula, tempData)
            setOrganizedData(new Map(organizedData))
            tempId++
        }

        if (line.matricula !== matricula) {
            moveToShipment(matricula, shipment, isShipment, tempId, line)
        }

        setTotalIds(tempId)
        htmlRefresh()
    }

    const deleteLine = (line, passIsShipment) => {
        const isShipment = passIsShipment !== null ? passIsShipment : false
        if (isShipment) {
            const tempNewArray = organizedData.get(line.matricula).filter(obj => obj.shipment !== line.shipment)
            if (tempNewArray.length === 0) {
                let tempId = totalIds
                let shipIndex = shipmentIndex
                const tempObj = {
                    ...line,
                    'id': tempId,
                    'shipment': shipIndex,
                    'dispatchNumber': '',
                    'CommodityCode': '',
                    'CommodityName': '',
                    'IdCommodity': '',
                    'dangerousGoods': [],
                    'IMO': false,
                    'nrPackage': '',
                    'description': '',
                    'grossWeight': '',
                    'measurements': '',
                    IdShipment: '',
                    IdShipmentDetails: '',
                    'shipmentChanged': []
                }
                tempId++
                shipIndex++
                tempNewArray.push(tempObj)
                setTotalIds(tempId)
                setShipmentIndex(shipIndex)
            }
            organizedData.set(line.matricula, tempNewArray)
            setOrganizedData(new Map(organizedData))

        } else {
            const temp = organizedData.get(line.matricula).filter((el) => el.shipment === line.shipment)
            if (temp.length === 1) {
                const tempObj = {
                    ...line,
                    'nrPackage': '',
                    'description': '',
                    'grossWeight': '',
                    'measurements': '',
                    IdShipmentDetails: '',
                    'shipmentChanged': []
                }
                const tempArray = organizedData.get(line.matricula).map(elem => {
                    return elem.id === line.id ? tempObj : elem
                })
                organizedData.set(line.matricula, tempArray)
                setOrganizedData(new Map(organizedData))
            } else {
                const tempLine = organizedData.get(line.matricula).filter(obj => obj.id !== line.id)
                organizedData.set(line.matricula, tempLine)
                setOrganizedData(new Map(organizedData))
            }
        }
        htmlRefresh()
    }

    const hideAddLineButton = () => {
        setAnchor(null)
        setAnchorShip(null)
        setAnchorDrag(null)
        setAnchorDragShip(null)
    }

    const addLineButtonHover = (e) => {
        setAnchor(null)
        setAnchorShip(null)

        //* Move Shipment Detail
        if (e.target.className === 'p-editable-column' || e.target.className === 'reOrder' || e.target.className === 'p-datatable-reorderablerow-handle pi pi-bars' || e.target.className === 'p-inputtext p-component p-filled inputColumnsContainer' || e.target.className === 'tableShipmentColumn' || e.target.className === 'p-inputtext p-component inputColumnsContainer' || e.target.className === 'rowOrder pi pi-bars') {
            let tempEl

            if (e.target.className === 'p-datatable-reorderablerow-handle pi pi-bars') {

                tempEl = e.target.parentElement
            } else {
                if (e.target.className === 'p-inputtext p-component p-filled inputColumnsContainer' || e.target.className === 'p-inputtext p-component inputColumnsContainer' || e.target.className === 'rowOrder pi pi-bars') {

                    tempEl = e.target.parentElement.parentElement.lastChild
                } else {
                    if (e.target.className === 'tableShipmentColumn') {

                        tempEl = e.target.parentElement.lastChild
                    } else {

                        tempEl = e.target.parentElement.lastChild
                    }
                }
            }

            // if (tempEl.childElementCount === 1) return

            const tempTableLeft = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetLeft
            const tempTable = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetTop
            const tempHeader = tempEl.parentElement.offsetTop
            const tempTableHeader = tempEl.parentElement.parentElement.parentElement.offsetTop
            const tempLeftShipment = tempEl.parentElement.parentElement.childNodes[0].childNodes[0].offsetWidth

            let tempTableKey
            tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes.forEach((node, index) => {
                if (node.offsetTop === tempTable) {
                    tempTableKey = index
                }
            })

            let tempLineKey
            tempEl.parentElement.parentElement.childNodes.forEach((node, index) => {
                if (node.offsetTop === tempHeader) {
                    tempLineKey = index
                }
            })

            if (containerTypes[tempTableKey]) {
                const tempLine = organizedData.get(containerTypes[tempTableKey])[tempLineKey]
                if (tempLine?.DBStatus === 'D') {
                    hideAddLineButton()
                    return
                }
                setHoverLine(tempLine)
            }



            setAnchor(tempEl)

            let tempWidth = 0

            if (operation === 'Approve') {
                tempWidth = tempEl.parentElement.parentElement.childNodes[0].childNodes[1].offsetWidth
            }

            setTop(tempTable + tempTableHeader + tempHeader + tempEl.clientHeight)
            setWidth(tempEl.offsetLeft + tempEl.clientWidth - (tempLeftShipment + tempWidth))
            setLeft(tempLeftShipment + tempTableLeft + tempWidth)
            setRowHeight(tempEl.clientHeight)


            return

        } if (e.target.className === 'shipmentName' || e.target.className === 'image-text' || e.target.className === 'shipmentButtons' || e.target.className === 'subHeaderContainer' || e.target.className === 'pi pi-bars subHeaderOrder' || e.target.className === 'dispatchDisplay' || e.target.className === 'approvSelectionColumn p-selection-column') {
            let tempEl
            if (e.target.className === 'image-text' || e.target.className === 'dispatchDisplay') {
                tempEl = e.target.parentElement.parentElement.parentElement
            } else {
                if (e.target.className === 'shipmentButtons') {
                    tempEl = e.target.parentElement.parentElement.parentElement
                }
                else {
                    if (e.target.className === 'subHeaderContainer') {
                        tempEl = e.target.parentElement
                    } else {
                        if (e.target.className === 'pi pi-bars subHeaderOrder') {
                            tempEl = e.target.parentElement.parentElement
                        } else {
                            if (e.target.className === 'approvSelectionColumn p-selection-column') {
                                if (e.target.nextSibling.className !== 'shipmentName') {
                                    tempEl = e.target.parentElement.previousSibling.childNodes[1]
                                    for (let i = 0; tempEl.className !== 'shipmentName'; i++) {
                                        tempEl = tempEl.parentElement.previousSibling.childNodes[1]
                                        if (i === 100) break
                                    }
                                } else {
                                    tempEl = e.target.nextSibling
                                }
                            } else {
                                tempEl = e.target
                            }
                        }
                    }
                }
            }
            // if (!tempEl.childNodes[1]) return
            if (tempEl?.className !== 'shipmentName') return
            if (tempEl?.nodeName === 'TH') return

            // const tempTableLeft = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetLeft + tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.offsetLeft
            const tempTableLeft = -5
            const tempTable = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetTop            // const tempHeader = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes[0].clientHeight
            const tempShipElTop = tempEl.offsetTop
            const tempTableHeader = tempEl.parentElement.parentElement.parentElement.offsetTop

            let tempTableKey
            tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes.forEach((node, index) => {
                if (node.offsetTop === tempTable) {
                    tempTableKey = index
                }
            })
            const tempShip = tempEl.childNodes[0].firstChild.firstChild.innerHTML.replace('Shipment', '').replaceAll(' ', '')

            let tempSelectedShipment

            organizedData.get(containerTypes[tempTableKey]).forEach(obj => {
                if (obj.shipment == tempShip) {
                    tempSelectedShipment = obj
                }
            })

            if (tempSelectedShipment?.DBStatus === 'D') {
                hideAddLineButton()
                return
            }

            setHoverLine(tempSelectedShipment)

            let tempWidth = tempEl.clientWidth

            if (operation === 'Approve') {
                tempWidth = tempEl.clientWidth + tempEl.parentElement.childNodes[0].clientWidth
            }
            setAnchorShip(tempEl)
            setShipTop(tempTable + tempTableHeader + tempShipElTop + tempEl.clientHeight)
            setShipHeight(tempEl.clientHeight)
            setShipWidth(tempWidth)
            setShipLeft(tempTableLeft)

            return
        }
        hideAddLineButton()
    }

    const dragShip = (ship, newShip, position, isCtrl) => {
        if (ship.id === newShip.id) return
        let tempOldContainer = []
        let tempValues = []
        let tempIsIn = false
        let tempId = totalIds
        let shipIndex = shipmentIndex
        organizedData.get(ship.matricula).filter(obj => {
            if (tempIsIn) {
                if (obj.shipment === ship.shipment) {
                    if (isCtrl) {
                        tempValues.push({
                            ...obj,
                            'shipment': shipIndex,
                            'matricula': newShip.matricula,
                            'equipmentType': newShip.equipmentType,
                            'IdShipment': '',
                            'IdBookingEquipment': newShip?.IdBookingEquipment,

                            'IdShipmentDetails': '',
                            'Prefix': newShip?.Prefix,
                            'Number': newShip?.Number,
                            'CheckDigit': newShip?.CheckDigit,
                            'IdEquipment': newShip?.IdEquipment,
                            'equipmentType': newShip?.equipmentType,
                            'EquipmentClassCode': newShip?.EquipmentClassCode,
                            'EquipmentTypeId': newShip?.EquipmentTypeId,
                            'IdEquipment': newShip?.IdEquipment,
                            'IdEquipmentDimensions': newShip?.IdEquipmentDimensions,
                            'Cargo': newShip?.Cargo,
                            'Weight': newShip?.Weight,
                            'Date': newShip?.Date,
                            'SOC': newShip?.SOC,
                            'Payload': newShip?.Payload,
                            'Tare': newShip?.Tare,
                            'IdBookingEquipment': newShip?.IdBookingEquipment,
                            'Width': newShip?.Width,
                            'Height': newShip?.Height,
                            'Length': newShip?.Length,
                            'Front': newShip?.Front,
                            'Back': newShip?.Back,
                            'Left': newShip?.Left,
                            'Right': newShip?.Right,
                            'DimensionsFROId': newShip?.DimensionsFROId,
                            'DimensionsBACId': newShip?.DimensionsBACId,
                            'DimensionsLEFId': newShip?.DimensionsLEFId,
                            'DimensionsRIGId': newShip?.DimensionsRIGId,
                            'DimensionsOVEId': newShip?.DimensionsOVEId,

                            'Brand': newShip?.Brand,
                            'Model': newShip?.Model,
                            'Chassis': newShip?.Chassis,
                        })
                        tempOldContainer.push({
                            ...obj,
                            'id': tempId,
                            IdShipmentDetails: ''
                        })
                        tempId++
                    } else {
                        tempValues.push({
                            ...obj,
                            'matricula': newShip.matricula,
                            'equipmentType': newShip.equipmentType,
                            'IdBookingEquipment': newShip?.IdBookingEquipment,

                            'IdShipmentDetails': '',
                            'Prefix': newShip?.Prefix,
                            'Number': newShip?.Number,
                            'CheckDigit': newShip?.CheckDigit,
                            'IdEquipment': newShip?.IdEquipment,
                            'equipmentType': newShip?.equipmentType,
                            'EquipmentClassCode': newShip?.EquipmentClassCode,
                            'EquipmentTypeId': newShip?.EquipmentTypeId,
                            'IdEquipment': newShip?.IdEquipment,
                            'IdEquipmentDimensions': newShip?.IdEquipmentDimensions,
                            'Cargo': newShip?.Cargo,
                            'Weight': newShip?.Weight,
                            'Date': newShip?.Date,
                            'SOC': newShip?.SOC,
                            'Payload': newShip?.Payload,
                            'Tare': newShip?.Tare,
                            'IdBookingEquipment': newShip?.IdBookingEquipment,
                            'Width': newShip?.Width,
                            'Height': newShip?.Height,
                            'Length': newShip?.Length,
                            'Front': newShip?.Front,
                            'Back': newShip?.Back,
                            'Left': newShip?.Left,
                            'Right': newShip?.Right,
                            'DimensionsFROId': newShip?.DimensionsFROId,
                            'DimensionsBACId': newShip?.DimensionsBACId,
                            'DimensionsLEFId': newShip?.DimensionsLEFId,
                            'DimensionsRIGId': newShip?.DimensionsRIGId,
                            'DimensionsOVEId': newShip?.DimensionsOVEId,

                            'Brand': newShip?.Brand,
                            'Model': newShip?.Model,
                            'Chassis': newShip?.Chassis,
                        })
                    }
                    return
                } else {
                    tempIsIn = false
                }
            }
            if (obj.id === ship.id) {
                tempIsIn = true
                if (isCtrl) {
                    let tempListObj = {
                        ...obj,
                        'shipment': shipIndex,
                        'IdShipment': '',
                    }
                    shipmentDetailsList.Equipment.forEach(element => {
                        tempListObj[element] = newShip[element]
                    })
                    tempValues.push(tempListObj)

                    tempOldContainer.push({
                        ...obj,
                        'id': tempId,
                        IdShipmentDetails: ''
                    })
                    tempId++
                } else {
                    let tempListObj = {
                        ...obj,
                    }
                    shipmentDetailsList.Equipment.forEach(element => {
                        tempListObj[element] = newShip[element]
                    })
                    tempValues.push(tempListObj)
                }
                return
            }
            tempOldContainer.push(obj)
        })
        if (isCtrl) shipIndex++
        let tempNewContainer
        if (ship.matricula === newShip.matricula) {
            tempNewContainer = tempOldContainer
        } else {
            tempNewContainer = organizedData.get(newShip.matricula)
        }

        if (tempOldContainer.length === 0) {
            tempOldContainer.push({
                'id': tempId,
                'matricula': ship.matricula,
                'equipmentType': ship.equipmentType,
                'shipment': shipIndex,
                'dispatchNumber': '',
                'CommodityCode': '',
                'CommodityName': '',
                'IdCommodity': '',
                'dangerousGoods': [],
                'IMO': false,
                'nrPackage': '',
                'description': '',
                'grossWeight': '',
                'measurements': '',
                'IdBookingEquipment': ship?.IdBookingEquipment,
                'IdShipment': '',
                'IdShipmentDetails': '',

                'Prefix': ship?.Prefix,
                'Number': ship?.Number,
                'CheckDigit': ship?.CheckDigit,
                'IdEquipment': ship?.IdEquipment,
                'equipmentType': ship?.equipmentType,
                'EquipmentClassCode': ship?.EquipmentClassCode,
                'EquipmentTypeId': ship?.EquipmentTypeId,
                'IdEquipment': ship?.IdEquipment,
                'IdEquipmentDimensions': ship?.IdEquipmentDimensions,
                'Cargo': ship?.Cargo,
                'Weight': ship?.Weight,
                'Date': ship?.Date,
                'SOC': ship?.SOC,
                'Payload': ship?.Payload,
                'Tare': ship?.Tare,
                'IdBookingEquipment': ship?.IdBookingEquipment,
                'Width': ship?.Width,
                'Height': ship?.Height,
                'Length': ship?.Length,
                'Front': ship?.Front,
                'Back': ship?.Back,
                'Left': ship?.Left,
                'Right': ship?.Right,
                'DimensionsFROId': ship?.DimensionsFROId,
                'DimensionsBACId': ship?.DimensionsBACId,
                'DimensionsLEFId': ship?.DimensionsLEFId,
                'DimensionsRIGId': ship?.DimensionsRIGId,
                'DimensionsOVEId': ship?.DimensionsOVEId,

                'Brand': ship?.Brand,
                'Model': ship?.Model,
                'Chassis': ship?.Chassis,
                'shipmentChanged': []
            })
            tempId++
            shipIndex++
        }

        let tempArray = []
        tempIsIn = false
        tempNewContainer.forEach(obj => {
            if (obj.id === newShip.id) {
                tempIsIn = true
                if (position === 'top') {
                    tempIsIn = false
                    tempArray.push(...tempValues)
                    tempArray.push(obj)
                    return
                }
            }
            if (tempIsIn && position === 'bot' && obj.shipment !== newShip.shipment) {
                tempIsIn = false
                tempArray.push(...tempValues)
            }
            tempArray.push(obj)
        })
        if (tempIsIn === true) {
            tempArray.push(...tempValues)
        }

        organizedData.set(ship.matricula, tempOldContainer)
        organizedData.set(newShip.matricula, tempArray)
        setOrganizedData(new Map(organizedData))

        setTotalIds(tempId)
        setShipmentIndex(shipIndex)

        setIsDragShip(null)
        hideAddLineButton()
    }

    const dragLines = (line, newLine, position, isCtrl) => {

        if (line.id === newLine.id) return
        let tempId = totalIds
        let shipIndex = shipmentIndex
        let tempOldContainer = []
        if (isCtrl) {
            tempOldContainer = organizedData.get(line.matricula).map(obj => {
                if (obj.id === line.id) {
                    return { ...obj, 'id': tempId }
                }
                else return obj
            })
            tempId++
        } else {
            tempOldContainer = organizedData.get(line.matricula).filter(obj => obj.id !== line.id)
        }
        let tempNewContainer = []
        if (line.matricula === newLine.matricula) {
            tempNewContainer = tempOldContainer
        } else {
            tempNewContainer = organizedData.get(newLine.matricula)
        }

        if (tempOldContainer.length === 0) {
            tempOldContainer.push({
                'id': tempId,
                'matricula': line.matricula,
                'equipmentType': line.equipmentType,
                'shipment': shipIndex,
                'dispatchNumber': '',
                'CommodityCode': '',
                'CommodityName': '',
                'IdCommodity': '',
                'nrPackage': '',
                'description': '',
                'grossWeight': '',
                'measurements': '',
                'dangerousGoods': [],
                'IMO': false,

                IdBookingEquipment: line?.IdBookingEquipment,
                IdShipment: '',
                'IdShipmentDetails': '',

                'Prefix': line.Prefix,
                'Number': line.Number,
                'CheckDigit': line.CheckDigit,
                'IdEquipment': line.IdEquipment,
                'equipmentType': line.equipmentType,
                'EquipmentClassCode': line.EquipmentClassCode,
                'EquipmentTypeId': line.EquipmentTypeId,
                'IdEquipment': line?.IdEquipment,
                'IdEquipmentDimensions': line?.IdEquipmentDimensions,
                'Cargo': line.Cargo,
                'Weight': line.Weight,
                'Date': line.Date,
                'SOC': line.SOC,
                'Payload': line.Payload,
                'Tare': line.Tare,
                'IdBookingEquipment': line.IdBookingEquipment,
                'Width': line.Width,
                'Height': line.Height,
                'Length': line.Length,
                'Front': line?.Front,
                'Back': line?.Back,
                'Left': line?.Left,
                'Right': line?.Right,
                'DimensionsFROId': line?.DimensionsFROId,
                'DimensionsBACId': line?.DimensionsBACId,
                'DimensionsLEFId': line?.DimensionsLEFId,
                'DimensionsRIGId': line?.DimensionsRIGId,
                'DimensionsOVEId': line?.DimensionsOVEId,

                'Brand': line.Brand,
                'Model': line.Model,
                'Chassis': line.Chassis,
                'shipmentChanged': []
            })
            tempId++
            shipIndex++
        }

        const tempArray = []

        tempNewContainer.forEach(obj => {
            if (obj.id === newLine.id) {
                if (position === 'top') {
                    if (isCtrl) {
                        tempArray.push({
                            ...line,
                            'shipment': shipIndex,
                            'matricula': newLine.matricula,
                            'equipmentType': newLine.equipmentType,
                            IdShipment: '',
                            IdBookingEquipment: newLine?.IdBookingEquipment,
                            'IdShipmentDetails': '',

                            'Prefix': newLine?.Prefix,
                            'Number': newLine?.Number,
                            'CheckDigit': newLine?.CheckDigit,
                            'IdEquipment': newLine?.IdEquipment,
                            'equipmentType': newLine?.equipmentType,
                            'EquipmentClassCode': newLine?.EquipmentClassCode,
                            'EquipmentTypeId': newLine?.EquipmentTypeId,
                            'IdEquipment': newLine?.IdEquipment,
                            'IdEquipmentDimensions': newLine?.IdEquipmentDimensions,
                            'Cargo': newLine?.Cargo,
                            'Weight': newLine?.Weight,
                            'Date': newLine?.Date,
                            'SOC': newLine?.SOC,
                            'Payload': newLine?.Payload,
                            'Tare': newLine?.Tare,
                            'IdBookingEquipment': newLine?.IdBookingEquipment,
                            'Width': newLine?.Width,
                            'Height': newLine?.Height,
                            'Length': newLine?.Length,
                            'Front': newLine?.Front,
                            'Back': newLine?.Back,
                            'Left': newLine?.Left,
                            'Right': newLine?.Right,
                            'DimensionsFROId': newLine?.DimensionsFROId,
                            'DimensionsBACId': newLine?.DimensionsBACId,
                            'DimensionsLEFId': newLine?.DimensionsLEFId,
                            'DimensionsRIGId': newLine?.DimensionsRIGId,
                            'DimensionsOVEId': newLine?.DimensionsOVEId,

                            'Brand': newLine?.Brand,
                            'Model': newLine?.Model,
                            'Chassis': newLine?.Chassis,
                        })
                    } else {
                        tempArray.push({
                            ...line,
                            'matricula': newLine.matricula,
                            'equipmentType': newLine.equipmentType,
                            IdBookingEquipment: newLine?.IdBookingEquipment,
                            'IdShipmentDetails': '',
                            'Prefix': newLine?.Prefix,
                            'Number': newLine?.Number,
                            'CheckDigit': newLine?.CheckDigit,
                            'IdEquipment': newLine?.IdEquipment,
                            'equipmentType': newLine?.equipmentType,
                            'EquipmentClassCode': newLine?.EquipmentClassCode,
                            'EquipmentTypeId': newLine?.EquipmentTypeId,
                            'IdEquipment': newLine?.IdEquipment,
                            'IdEquipmentDimensions': newLine?.IdEquipmentDimensions,
                            'Cargo': newLine?.Cargo,
                            'Weight': newLine?.Weight,
                            'Date': newLine?.Date,
                            'SOC': newLine?.SOC,
                            'Payload': newLine?.Payload,
                            'Tare': newLine?.Tare,
                            'IdBookingEquipment': newLine?.IdBookingEquipment,
                            'Width': newLine?.Width,
                            'Height': newLine?.Height,
                            'Length': newLine?.Length,
                            'Front': newLine?.Front,
                            'Back': newLine?.Back,
                            'Left': newLine?.Left,
                            'Right': newLine?.Right,
                            'DimensionsFROId': newLine?.DimensionsFROId,
                            'DimensionsBACId': newLine?.DimensionsBACId,
                            'DimensionsLEFId': newLine?.DimensionsLEFId,
                            'DimensionsRIGId': newLine?.DimensionsRIGId,
                            'DimensionsOVEId': newLine?.DimensionsOVEId,

                            'Brand': newLine?.Brand,
                            'Model': newLine?.Model,
                            'Chassis': newLine?.Chassis,
                        })
                    }
                    tempArray.push(obj)
                    return
                } else {
                    tempArray.push(obj)
                    if (isCtrl) {
                        tempArray.push({
                            ...line,
                            'shipment': shipIndex,
                            'matricula': newLine.matricula,
                            'equipmentType': newLine.equipmentType,
                            IdShipment: '',
                            IdBookingEquipment: newLine?.IdBookingEquipment,
                            'IdShipmentDetails': '',

                            'Prefix': newLine?.Prefix,
                            'Number': newLine?.Number,
                            'CheckDigit': newLine?.CheckDigit,
                            'IdEquipment': newLine?.IdEquipment,
                            'equipmentType': newLine?.equipmentType,
                            'EquipmentClassCode': newLine?.EquipmentClassCode,
                            'EquipmentTypeId': newLine?.EquipmentTypeId,
                            'IdEquipment': newLine?.IdEquipment,
                            'IdEquipmentDimensions': newLine?.IdEquipmentDimensions,
                            'Cargo': newLine?.Cargo,
                            'Weight': newLine?.Weight,
                            'Date': newLine?.Date,
                            'SOC': newLine?.SOC,
                            'Payload': newLine?.Payload,
                            'Tare': newLine?.Tare,
                            'IdBookingEquipment': newLine?.IdBookingEquipment,
                            'Width': newLine?.Width,
                            'Height': newLine?.Height,
                            'Length': newLine?.Length,
                            'Front': newLine?.Front,
                            'Back': newLine?.Back,
                            'Left': newLine?.Left,
                            'Right': newLine?.Right,
                            'DimensionsFROId': newLine?.DimensionsFROId,
                            'DimensionsBACId': newLine?.DimensionsBACId,
                            'DimensionsLEFId': newLine?.DimensionsLEFId,
                            'DimensionsRIGId': newLine?.DimensionsRIGId,
                            'DimensionsOVEId': newLine?.DimensionsOVEId,

                            'Brand': newLine?.Brand,
                            'Model': newLine?.Model,
                            'Chassis': newLine?.Chassis,
                        })
                    } else {
                        tempArray.push({
                            ...line,
                            'matricula': newLine.matricula,
                            'equipmentType': newLine.equipmentType,
                            IdBookingEquipment: newLine?.IdBookingEquipment,
                            'IdShipmentDetails': '',

                            'Prefix': newLine?.Prefix,
                            'Number': newLine?.Number,
                            'CheckDigit': newLine?.CheckDigit,
                            'IdEquipment': newLine?.IdEquipment,
                            'equipmentType': newLine?.equipmentType,
                            'EquipmentClassCode': newLine?.EquipmentClassCode,
                            'EquipmentTypeId': newLine?.EquipmentTypeId,
                            'IdEquipment': newLine?.IdEquipment,
                            'IdEquipmentDimensions': newLine?.IdEquipmentDimensions,
                            'Cargo': newLine?.Cargo,
                            'Weight': newLine?.Weight,
                            'Date': newLine?.Date,
                            'SOC': newLine?.SOC,
                            'Payload': newLine?.Payload,
                            'Tare': newLine?.Tare,
                            'IdBookingEquipment': newLine?.IdBookingEquipment,
                            'Width': newLine?.Width,
                            'Height': newLine?.Height,
                            'Length': newLine?.Length,
                            'Front': newLine?.Front,
                            'Back': newLine?.Back,
                            'Left': newLine?.Left,
                            'Right': newLine?.Right,
                            'DimensionsFROId': newLine?.DimensionsFROId,
                            'DimensionsBACId': newLine?.DimensionsBACId,
                            'DimensionsLEFId': newLine?.DimensionsLEFId,
                            'DimensionsRIGId': newLine?.DimensionsRIGId,
                            'DimensionsOVEId': newLine?.DimensionsOVEId,

                            'Brand': newLine?.Brand,
                            'Model': newLine?.Model,
                            'Chassis': newLine?.Chassis,
                        })
                    }
                    return
                }
            }
            tempArray.push(obj)
        })
        if (isCtrl) shipIndex++
        organizedData.set(line.matricula, tempOldContainer)
        organizedData.set(newLine.matricula, tempArray)
        setTotalIds(tempId)
        setShipmentIndex(shipIndex)
        hideAddLineButton()
    }

    const mergeLines = (line, newLine, isCtrl) => {
        if (newLine === null) return
        if (line.id === newLine.id) return
        let tempId = totalIds
        let shipIndex = shipmentIndex
        let tempOldContainer = []
        if (isCtrl) {
            tempOldContainer = organizedData.get(line.matricula).map(obj => {
                if (obj.id === line.id) {
                    return { ...obj, 'id': tempId }
                }
                else return obj
            })
            tempId++
        } else {
            tempOldContainer = organizedData.get(line.matricula).filter(obj => obj.id !== line.id)
        }
        let tempNewContainer
        if (line.matricula === newLine.matricula) {
            tempNewContainer = tempOldContainer
        } else {
            tempNewContainer = organizedData.get(newLine.matricula)
        }

        if (tempOldContainer.length === 0) {
            tempOldContainer.push({
                'id': tempId,
                'matricula': line.matricula,
                'equipmentType': line.equipmentType,
                'shipment': shipIndex,
                'dispatchNumber': '',
                'CommodityCode': '',
                'CommodityName': '',
                'IdCommodity': '',
                'nrPackage': '',
                'description': '',
                'grossWeight': '',
                'measurements': '',
                IdShipmentDetails: '',
                IdShipment: '',
                IdBookingEquipment: line?.IdBookingEquipment,
                'dangerousGoods': [],
                'IMO': false,

                'Prefix': line?.Prefix,
                'Number': line?.Number,
                'CheckDigit': line?.CheckDigit,
                'IdEquipment': line?.IdEquipment,
                'equipmentType': line?.equipmentType,
                'EquipmentClassCode': line?.EquipmentClassCode,
                'EquipmentTypeId': line?.EquipmentTypeId,
                'IdEquipment': line?.IdEquipment,
                'IdEquipmentDimensions': line?.IdEquipmentDimensions,
                'Cargo': line?.Cargo,
                'Weight': line?.Weight,
                'Date': line?.Date,
                'SOC': line?.SOC,
                'Payload': line?.Payload,
                'Tare': line?.Tare,
                'IdBookingEquipment': line?.IdBookingEquipment,
                'Width': line?.Width,
                'Height': line?.Height,
                'Length': line?.Length,
                'Front': line?.Front,
                'Back': line?.Back,
                'Left': line?.Left,
                'Right': line?.Right,
                'DimensionsFROId': line?.DimensionsFROId,
                'DimensionsBACId': line?.DimensionsBACId,
                'DimensionsLEFId': line?.DimensionsLEFId,
                'DimensionsRIGId': line?.DimensionsRIGId,
                'DimensionsOVEId': line?.DimensionsOVEId,

                'Brand': line?.Brand,
                'Model': line?.Model,
                'Chassis': line?.Chassis,
                'shipmentChanged': []
            })
            tempId++
            shipIndex++
        }

        const tempArray = []

        tempNewContainer.forEach(obj => {
            if (obj.id === newLine.id) {
                tempArray.push(obj)
                tempArray.push({
                    ...line,
                    'shipment': newLine.shipment,
                    'matricula': newLine.matricula,
                    'equipmentType': newLine.equipmentType,
                    'dispatchNumber': newLine.dispatchNumber,
                    'CommodityCode': newLine.CommodityCode,
                    'CommodityName': newLine.CommodityName,
                    'IdCommodity': newLine.IdCommodity,
                    IdShipment: newLine?.IdShipment,
                    IdBookingEquipment: newLine?.IdBookingEquipment,
                    'dangerousGoods': newLine.dangerousGoods,
                    'IMO': newLine.IMO,
                    'IdShipmentDetails': '',

                    'Prefix': newLine?.Prefix,
                    'Number': newLine?.Number,
                    'CheckDigit': newLine?.CheckDigit,
                    'IdEquipment': newLine?.IdEquipment,
                    'equipmentType': newLine?.equipmentType,
                    'EquipmentClassCode': newLine?.EquipmentClassCode,
                    'EquipmentTypeId': newLine?.EquipmentTypeId,
                    'IdEquipment': newLine?.IdEquipment,
                    'IdEquipmentDimensions': newLine?.IdEquipmentDimensions,
                    'Cargo': newLine?.Cargo,
                    'Weight': newLine?.Weight,
                    'Date': newLine?.Date,
                    'SOC': newLine?.SOC,
                    'Payload': newLine?.Payload,
                    'Tare': newLine?.Tare,
                    'IdBookingEquipment': newLine?.IdBookingEquipment,
                    'Width': newLine?.Width,
                    'Height': newLine?.Height,
                    'Length': newLine?.Length,
                    'Front': newLine?.Front,
                    'Back': newLine?.Back,
                    'Left': newLine?.Left,
                    'Right': newLine?.Right,
                    'DimensionsFROId': newLine?.DimensionsFROId,
                    'DimensionsBACId': newLine?.DimensionsBACId,
                    'DimensionsLEFId': newLine?.DimensionsLEFId,
                    'DimensionsRIGId': newLine?.DimensionsRIGId,
                    'DimensionsOVEId': newLine?.DimensionsOVEId,

                    'Brand': newLine?.Brand,
                    'Model': newLine?.Model,
                    'Chassis': newLine?.Chassis,
                })
                return
            }
            tempArray.push(obj)
        })
        organizedData.set(line.matricula, tempOldContainer)
        organizedData.set(newLine.matricula, tempArray)
        setTotalIds(tempId)
        setShipmentIndex(shipIndex)
        hideAddLineButton()
    }

    const mergeShip = (ship, newShip, isCtrl) => {
        if (ship === null) return
        if (ship.id === newShip.id) return
        let tempOldContainer = []
        let tempValues = []
        let tempIsIn = false
        let tempId = totalIds
        let shipIndex = shipmentIndex
        organizedData.get(ship.matricula).filter(obj => {
            if (tempIsIn) {
                if (obj.shipment === ship.shipment) {
                    tempValues.push({
                        ...obj,
                        'shipment': newShip.shipment,
                        'matricula': newShip.matricula,
                        'equipmentType': newShip.equipmentType,
                        'dispatchNumber': newShip.dispatchNumber,
                        'CommodityCode': newShip.CommodityCode,
                        'CommodityName': newShip.CommodityName,
                        'IdCommodity': newShip.IdCommodity,
                        IdShipment: newShip?.IdShipment,
                        'IdShipmentDetails': '',
                        'dangerousGoods': newShip.dangerousGoods,
                        'IMO': newShip.IMO,

                        'Prefix': newShip?.Prefix,
                        'Number': newShip?.Number,
                        'CheckDigit': newShip?.CheckDigit,
                        'IdEquipment': newShip?.IdEquipment,
                        'equipmentType': newShip?.equipmentType,
                        'EquipmentClassCode': newShip?.EquipmentClassCode,
                        'EquipmentTypeId': newShip?.EquipmentTypeId,
                        'IdEquipment': newShip?.IdEquipment,
                        'IdEquipmentDimensions': newShip?.IdEquipmentDimensions,
                        'Cargo': newShip?.Cargo,
                        'Weight': newShip?.Weight,
                        'Date': newShip?.Date,
                        'SOC': newShip?.SOC,
                        'Payload': newShip?.Payload,
                        'Tare': newShip?.Tare,
                        'IdBookingEquipment': newShip?.IdBookingEquipment,
                        'Width': newShip?.Width,
                        'Height': newShip?.Height,
                        'Length': newShip?.Length,
                        'Front': newShip?.Front,
                        'Back': newShip?.Back,
                        'Left': newShip?.Left,
                        'Right': newShip?.Right,
                        'DimensionsFROId': newShip?.DimensionsFROId,
                        'DimensionsBACId': newShip?.DimensionsBACId,
                        'DimensionsLEFId': newShip?.DimensionsLEFId,
                        'DimensionsRIGId': newShip?.DimensionsRIGId,
                        'DimensionsOVEId': newShip?.DimensionsOVEId,

                        'Brand': newShip?.Brand,
                        'Model': newShip?.Model,
                        'Chassis': newShip?.Chassis,

                    })
                    if (isCtrl) {
                        tempOldContainer.push({ ...obj, 'id': tempId, IdShipmentDetails: '' })
                        tempId++
                    }
                    return
                } else {
                    tempIsIn = false
                }
            }
            if (obj.id === ship.id) {
                tempIsIn = true
                tempValues.push({
                    ...obj,
                    'shipment': newShip.shipment,
                    'matricula': newShip.matricula,
                    'equipmentType': newShip.equipmentType,
                    'dispatchNumber': newShip.dispatchNumber,
                    'CommodityCode': newShip.CommodityCode,
                    'CommodityName': newShip.CommodityName,
                    'IdCommodity': newShip.IdCommodity,
                    IdShipment: newShip?.IdShipment,
                    'IdShipmentDetails': '',
                    'dangerousGoods': newShip.dangerousGoods,
                    'IMO': newShip.IMO,

                    'Prefix': newShip?.Prefix,
                    'Number': newShip?.Number,
                    'CheckDigit': newShip?.CheckDigit,
                    'IdEquipment': newShip?.IdEquipment,
                    'equipmentType': newShip?.equipmentType,
                    'EquipmentClassCode': newShip?.EquipmentClassCode,
                    'EquipmentTypeId': newShip?.EquipmentTypeId,
                    'IdEquipment': newShip?.IdEquipment,
                    'IdEquipmentDimensions': newShip?.IdEquipmentDimensions,
                    'Cargo': newShip?.Cargo,
                    'Weight': newShip?.Weight,
                    'Date': newShip?.Date,
                    'SOC': newShip?.SOC,
                    'Payload': newShip?.Payload,
                    'Tare': newShip?.Tare,
                    'IdBookingEquipment': newShip?.IdBookingEquipment,
                    'Width': newShip?.Width,
                    'Height': newShip?.Height,
                    'Length': newShip?.Length,
                    'Front': newShip?.Front,
                    'Back': newShip?.Back,
                    'Left': newShip?.Left,
                    'Right': newShip?.Right,
                    'DimensionsFROId': newShip?.DimensionsFROId,
                    'DimensionsBACId': newShip?.DimensionsBACId,
                    'DimensionsLEFId': newShip?.DimensionsLEFId,
                    'DimensionsRIGId': newShip?.DimensionsRIGId,
                    'DimensionsOVEId': newShip?.DimensionsOVEId,

                    'Brand': newShip?.Brand,
                    'Model': newShip?.Model,
                    'Chassis': newShip?.Chassis,
                })
                if (isCtrl) {
                    tempOldContainer.push({ ...obj, 'id': tempId, IdShipmentDetails: '' })
                    tempId++
                }
                return
            }
            tempOldContainer.push(obj)
        })
        let tempNewContainer
        if (ship.matricula === newShip.matricula) {
            tempNewContainer = tempOldContainer
        } else {
            tempNewContainer = organizedData.get(newShip.matricula)
        }

        if (tempOldContainer.length === 0) {
            tempOldContainer.push({
                'id': tempId,
                'matricula': ship.matricula,
                'equipmentType': ship.equipmentType,
                'shipment': shipIndex,
                'dispatchNumber': '',
                'CommodityCode': '',
                'CommodityName': '',
                'IdCommodity': '',
                'nrPackage': '',
                'description': '',
                'grossWeight': '',
                'measurements': '',
                IdBookingEquipment: ship?.IdBookingEquipment,
                IdShipmentDetails: '',
                IdShipment: '',
                'dangerousGoods': [],
                'IMO': false,

                'Prefix': ship?.Prefix,
                'Number': ship?.Number,
                'CheckDigit': ship?.CheckDigit,
                'IdEquipment': ship?.IdEquipment,
                'equipmentType': ship?.equipmentType,
                'EquipmentClassCode': ship?.EquipmentClassCode,
                'EquipmentTypeId': ship?.EquipmentTypeId,
                'IdEquipment': ship?.IdEquipment,
                'IdEquipmentDimensions': ship?.IdEquipmentDimensions,
                'Cargo': ship?.Cargo,
                'Weight': ship?.Weight,
                'Date': ship?.Date,
                'SOC': ship?.SOC,
                'Payload': ship?.Payload,
                'Tare': ship?.Tare,
                'IdBookingEquipment': ship?.IdBookingEquipment,
                'Width': ship?.Width,
                'Height': ship?.Height,
                'Length': ship?.Length,
                'Front': ship?.Front,
                'Back': ship?.Back,
                'Left': ship?.Left,
                'Right': ship?.Right,
                'DimensionsFROId': ship?.DimensionsFROId,
                'DimensionsBACId': ship?.DimensionsBACId,
                'DimensionsLEFId': ship?.DimensionsLEFId,
                'DimensionsRIGId': ship?.DimensionsRIGId,
                'DimensionsOVEId': ship?.DimensionsOVEId,

                'Brand': ship?.Brand,
                'Model': ship?.Model,
                'Chassis': ship?.Chassis,
                'shipmentChanged': []
            })
            tempId++
            shipIndex++
        }
        let tempArray = []
        tempIsIn = false
        tempNewContainer.forEach(obj => {
            if (obj.id === newShip.id) {
                tempIsIn = true
            }
            if (tempIsIn && obj.shipment !== newShip.shipment) {
                tempIsIn = false
                tempArray.push(...tempValues)
            }
            tempArray.push(obj)
        })
        if (tempIsIn === true) {
            tempArray.push(...tempValues)
        }

        organizedData.set(ship.matricula, tempOldContainer)
        organizedData.set(newShip.matricula, tempArray)
        setOrganizedData(new Map(organizedData))

        setTotalIds(tempId)
        setShipmentIndex(shipIndex)

        setIsDragShip(null)
        hideAddLineButton()
    }

    const dragDiffContainer = (e) => {
        let tempCont
        e.currentTarget.parentElement.childNodes.forEach((nodes, index) => {
            if (nodes.offsetTop === e.currentTarget.offsetTop) {
                tempCont = containerTypes[index]
            }
        })

        if (isDragShip) {
            if (isDragShip.matricula !== tempCont) {
                if (e.ctrlKey !== true) {
                    moveToShipment(tempCont, isDragShip.shipment, true, isDragShip.shipment, isDragShip)
                } else {
                    copy(true, isDragShip, tempCont)
                }
            }
        } else {
            if (hoverLine.matricula !== tempCont) {
                if (e.ctrlKey !== true) {
                    moveToShipment(tempCont, hoverLine.shipment, false, hoverLine.shipment, hoverLine)
                } else {
                    copy(false, hoverLine, tempCont)
                }
            }
        }
        setIsDragShip(null)
    }

    const dragEnterShip = (e) => {
        setAnchor(null)
        setAnchorShip(null)
        setAnchorDrag(null)
        if (!isDragShip) return
        let tempEl
        // if (e.target.className === 'shipmentName')
        if (e.target.className === 'shipmentName' || e.target.className === 'image-text' || e.target.className === 'shipmentButtons' || e.target.className === 'subHeaderContainer' || e.target.className === 'pi pi-bars subHeaderOrder') {
            if (e.target.className === 'image-text') {
                tempEl = e.target.parentElement.parentElement.parentElement
            } else {
                if (e.target.className === 'shipmentButtons') {
                    tempEl = e.target.parentElement.parentElement.parentElement
                }
                else {
                    if (e.target.className === 'subHeaderContainer') {
                        tempEl = e.target.parentElement
                    } else {
                        if (e.target.className === 'pi pi-bars subHeaderOrder') {
                            tempEl = e.target.parentElement.parentElement
                        } else {
                            tempEl = e.target
                        }
                    }
                }
            }

            setAnchorDragShip('teste')

            const tempTableLeft = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetLeft
            const tempTable = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetTop
            // const tempHeader = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes[0].clientHeight
            const tempShipElTop = tempEl.offsetTop
            const tempTableHeader = tempEl.parentElement.parentElement.parentElement.offsetTop

            let tempTableKey
            tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes.forEach((node, index) => {
                if (node.offsetTop === tempTable) {
                    tempTableKey = index
                }
            })

            const tempSelectedShipment = organizedData.get(containerTypes[tempTableKey]).filter(obj => obj.id == tempEl?.childNodes[0]?.firstChild?.firstChild.id)[0]
            setHoverLine(tempSelectedShipment)

            setShipTopDrag(tempTable + tempTableHeader + tempShipElTop + tempEl.clientHeight)
            setShipHeightDrag(tempEl.clientHeight)
            setShipWidthDrag(tempEl.clientWidth)
            setShipLeftDrag(tempTableLeft)
        }
    }

    const dragEnter = (e) => {
        setAnchor(null)
        setAnchorShip(null)
        setAnchorDragShip(null)
        if (isDragShip) return
        let tempEl
        if (e.target.className === 'inputColumnsContainer' || e.target.className === 'p-editable-column' || e.target.className === 'reOrder' || e.target.className === 'p-datatable-reorderablerow-handle pi pi-bars' || e.target.className === 'p-inputtext p-component p-filled inputColumnsContainer' || e.target.className === 'tableShipmentColumn' || e.target.className === 'p-inputtext p-component inputColumnsContainer' || e.target.className === 'rowOrder pi pi-bars') {

            if (e.target.className === 'p-datatable-reorderablerow-handle pi pi-bars') {
                tempEl = e.target.parentElement
            } else {
                if (e.target.className === 'inputColumnsContainer' || e.target.className === 'p-inputtext p-component p-filled inputColumnsContainer' || e.target.className === 'p-inputtext p-component inputColumnsContainer' || e.target.className === 'rowOrder pi pi-bars') {
                    tempEl = e.target.parentElement.parentElement.lastChild
                } else {
                    if (e.target.className === 'tableShipmentColumn') {
                        tempEl = e.target.parentElement.lastChild
                    } else {
                        tempEl = e.target.parentElement.lastChild
                    }
                }
            }
        }
        if (!tempEl) {
            return
        }

        const tempTableLeft = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetLeft
        const tempTable = tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.offsetTop
        const tempHeader = tempEl.parentElement.offsetTop
        const tempTableHeader = tempEl.parentElement.parentElement.parentElement.offsetTop
        const tempLeftShipment = tempEl.parentElement.parentElement.childNodes[0].childNodes[0].offsetWidth

        let tempTableKey
        tempEl.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.childNodes.forEach((node, index) => {
            if (node.offsetTop === tempTable) {
                tempTableKey = index
            }
        })

        let tempLineKey
        tempEl.parentElement.parentElement.childNodes.forEach((node, index) => {
            if (node.offsetTop === tempHeader) {
                tempLineKey = index
            }
        })

        if (containerTypes[tempTableKey]) {
            setAnchorDrag(organizedData.get(containerTypes[tempTableKey])[tempLineKey])
        }

        setTopDrag(tempTable + tempTableHeader + tempHeader + tempEl.clientHeight)
        setWidthDrag(tempEl.offsetLeft + tempEl.clientWidth - tempLeftShipment)
        setLeftDrag(tempLeftShipment + tempTableLeft)
        setRowHeight(tempEl.clientHeight)
    }

    function isNumber(e) {
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 39 || e.keyCode === 37) {
            return true
        }
        e.preventDefault()
    }

    const isDecimalNumber = (e) => {
        if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 13 || e.keyCode === 190 || e.keyCode === 39 || e.keyCode === 37 || e.keyCode === 188) {
            return true
        }
        e.preventDefault()
    }

    const cellBody = (row, field) => {

        const isApprove = operation === 'Approve'; // <- verifica se Ã© modo approve
        const isDeleted = row?.DBStatus === 'D';

        // determina a cor do texto
        const textColor =
            row?.shipmentChanged?.includes(field) && !row.shipmentChanged.includes('ShipmentDetailId')
                ? 'var(--color-yellow)'
                : 'var(--color-white)';
        const isNewRow = row?.shipmentChanged?.includes('ShipmentDetailId')

        const isFieldChanged = row?.shipmentChanged?.includes(field) && !row.shipmentChanged.includes('ShipmentDetailId')

        const containerClass = `inputColumnsContainer ${isDeleted ? 'row-disabled' : ''}`;

        const containerStyle = {
            ...(isDeleted
                ? {
                    borderTop: '2px solid var(--color-red)',
                    borderBottom: '2px solid var(--color-red)',
                    borderLeft: field === 'nrPackage' ? '2px solid var(--color-red)' : undefined,
                    borderRight: field === 'measurements' ? '2px solid var(--color-red)' : undefined,
                    borderTopLeftRadius: field === 'nrPackage' ? '5px' : undefined,
                    borderBottomLeftRadius: field === 'nrPackage' ? '5px' : undefined,
                    borderTopRightRadius: field === 'measurements' ? '5px' : undefined,
                    borderBottomRightRadius: field === 'measurements' ? '5px' : undefined,
                    padding: '22px',
                    height: '100%',
                }
                : {}),
            ...(!isDeleted && isNewRow
                ? {
                    borderTop: '2px solid var(--color-green)',
                    borderBottom: '2px solid var(--color-green)',
                    borderLeft: field === 'nrPackage' ? '2px solid var(--color-green)' : undefined,
                    borderRight: field === 'measurements' ? '2px solid var(--color-green)' : undefined,
                    borderTopLeftRadius: field === 'nrPackage' ? '5px' : undefined,
                    borderBottomLeftRadius: field === 'nrPackage' ? '5px' : undefined,
                    borderTopRightRadius: field === 'measurements' ? '5px' : undefined,
                    borderBottomRightRadius: field === 'measurements' ? '5px' : undefined,
                    padding: '12px',
                    height: '100%',
                }
                : {}),
            ...(!isDeleted && !isNewRow && isApprove && isFieldChanged
                ? {

                    border: '1px solid var(--color-yellow)',
                    borderRadius: '5px',
                    marginRight: '1px',
                    height: '100%',
                }
                : {}),
        }

        // conteÃºdo comum (input ou texto)
        const renderContent = () => {
            if (isDeleted) {
                return (
                    <div
                        style={{
                            color: 'black',
                            marginLeft: '5px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {field === 'grossWeight' || field === 'measurements'
                            ? ctx.useComma
                                ? row[field]?.toString()?.replaceAll('.', ',')
                                : row[field]?.toString()?.replaceAll(',', '.')
                            : row[field] || ''}
                    </div>
                );
            }
            return (
                <M_InputTextField
                    id={field === 'nrPackage' ? 'package' : undefined}
                    type='text'
                    maxLength={field === 'nrPackage' ? 5 : field === 'grossWeight' || field === 'measurements' ? 10 : undefined}
                    value={
                        field === 'grossWeight' || field === 'measurements'
                            ? ctx.useComma
                                ? row[field]?.toString()?.replaceAll('.', ',')
                                : row[field]?.toString()?.replaceAll(',', '.') || ''
                            : row[field] || ''
                    }
                    blockSpecialChars={true}
                    onKeyDown={(e) => {
                        if (field === 'nrPackage') isNumber(e);
                        if (field === 'grossWeight' || field === 'measurements') isDecimalNumber(e);
                    }}
                    onChange={(e) => {
                        const value = field === 'grossWeight' || field === 'measurements'
                            ? e.target.value?.toString()?.replaceAll(',', '.')
                            : e.target.value;
                        editLine(value, row, field);
                    }}
                    onBlur={() => onCellEditComplete(row, field)}
                    className='inputColumnsContainer'
                    margin='7px'
                    padding='0px'
                    paddingLeft='5px'
                    height='26px'
                    size={field === 'nrPackage' ? '90px' : field === 'grossWeight' || field === 'measurements' ? '80px' : undefined}
                    color={textColor}
                    secondColor={textColor}
                />
            );
        };

        return (
            <div
                className={containerClass}
                style={containerStyle}
                onDrop={(e) => {
                    handleDrop(e);
                    setHoverIndex(null);
                    mergeLines(hoverLine, anchorDrag, e.ctrlKey);
                }}
                onDragEnter={(e) => dragEnter(e, row)}
            >
                {renderContent()}
            </div>
        );
    };



    const newOrderIconStyle = {
    }

    const normalOrderIconStyle = {
        cursor: 'grab',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: '10px',
        paddingRight: '10px',
    }

    const reorder = (row) => {
        if (row?.DBStatus === 'D') return null
        return <i
            style={row?.shipmentChanged?.includes('ShipmentDetailId') && !row?.shipmentChanged?.includes('ShipmentId') ? { ...newOrderIconStyle, ...normalOrderIconStyle } : normalOrderIconStyle}
            onDragEnd={handleDragEnd}
            onDragStart={(e) => {

                setIsDragShip(null)
                handleDragStart(e, 'linha')
            }}
            onDragEnter={(e) => dragEnter(e, row)}
            draggable={true}
            className='rowOrder pi pi-bars'
        >
        </i>
    }

    const handleDragEnd = e => {
        document.getElementById('this one').id = ''
        hideAddLineButton()
    }

    const handleDragStart = (e, type, data) => {
        let ghostEle

        e.target.offsetParent.parentElement.id = 'this one'
        ghostEle = document.getElementById('this one')

        if (type === 'shipment') {
            //* MOVING A SHIPMENT
            e.dataTransfer.setDragImage(ghostEle, ghostEle.clientWidth + 30 - (document.body.clientWidth - ghostEle.clientWidth), 40);
        } else {
            //* MOVING SHIPMENTS DETAILS
            if (ghostEle.cells[0].children[0].id == 'shipment') {
                //* MOVING FIRST LINE
                e.dataTransfer.setDragImage(ghostEle, ghostEle.clientWidth - 17, 20);
            } else {
                //* MOVING OTHER LINES
                e.dataTransfer.setDragImage(ghostEle, ghostEle.clientWidth - 179, 20);
            }
        }
        e.dataTransfer.setData('text/plain', e.target.id);
    }

    const handleDragEnter = e => {
        e.preventDefault()
        e.stopPropagation()
    }

    const handleDragLeave = e => {
        e.preventDefault()
        e.stopPropagation()
    }

    const handleDragOver = e => {
        e.preventDefault()
        e.stopPropagation()
    }

    const handleDrop = e => {
        e.preventDefault()
        e.stopPropagation()
    }

    const getEntityValues = (line, entityLabel) => {
        inputChanged(`${entityLabel.toLowerCase()}Address`, line?.OfficeAddress1?.slice(0, entitySize).trim() || '')
        inputChanged(`${entityLabel.toLowerCase()}Address2`, line?.OfficeAddress2?.slice(0, entitySize).trim() || '')
        inputChanged(`${entityLabel?.toLowerCase()}ZipCode`, `${line?.OfficePostCode1 || ''} ${line?.OfficeCity || ''}`.slice(0, entitySize).trim())
    }

    const [pdfs, setPdfs] = useState([])
    const [tempPage, setTempPage] = useState(1)

    useEffect(() => {
        if (pdfs.length === 0) return
        if (!isFirstIteration) {
            if (lines >= pageSize && tempPage < docSize) {
                const tempPageIndex = tempPage + 1
                setTempPage(tempPageIndex)
                blHtmlDownload(tempPageIndex)
                return
            }
            if (tempPage == docSize || (docSize == 2 && lines < pageSize)) {
                blobs()
            }
        }
    }, [pdfs])

    const blobs = () => {
        const blobs = pdfs
        const files = new Array(blobs.length);
        let loadedCount = 0;

        blobs.forEach((blob, i) => {
            const reader = new FileReader();
            reader.readAsArrayBuffer(blob);
            reader.onload = () => {
                files[i] = reader.result;
                loadedCount++;
                if (loadedCount === blobs.length) {
                    mergePDF(files);
                }
            };
        });
    }

    async function mergePDF(files) {
        const mergedPdf = await PDFDocument.create();

        for (const file of files) {
            const pdf = await PDFDocument.load(file);
            const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
            pages.forEach((page) => mergedPdf.addPage(page));
        }
        const mergedPdfFile = await mergedPdf.save();
    

        setTempPage(1)
        setPdfs([])
        setPage(1)

        download(mergedPdfFile, `${varNameDict.get('freightBookingNumber')}-BL.pdf`)
        ctx.setIsLoad(false)
    }

    const blHtmlDownload = (passPage) => {
        ctx.setIsLoad(true)
        toastMessages('success', t("LabelGeneratingPDF"), '')
        let doc
        setPage(passPage)

        doc = new jsPDF({
            format: "a0",
            unit: "px"
        })

        doc.setFont("Courier", "normal")

        let newHTML = htmlRefresh(showInput, passPage)

        let tempPdf
        doc.html(newHTML, {
            callback: (doc) => {
                tempPdf = doc.output('blob')
                setPdfs(prev => [...prev, tempPdf])
                doc = new jsPDF()
            },
            html2canvas: {
                onclone: (_doc) => document.fonts.ready
            }
        })
    }

    const Commmodity = [
        { label: 'Code', type: 'textfield', code: 'CommodityCode' },
        { label: 'Name', type: 'textfield', code: 'CommodityName' },
    ]

    const onSelectionChange = (e) => {
        let tempValue
        if (e.value) {
            tempValue = e.value
        } else {
            tempValue = []
        }
        setSelectedRows(tempValue)
    }

    const dataToUpdate = () => {
        // ctx.setIsLoad(true)
        let error = ''
        let today = new Date()
        let todayFormat = toLocal(today)


        let CopyNumber = (parseInt(destinationCopyNumber) + parseInt(originCopyNumber))
        let NumberOriginal = (parseInt(originOriginalNumber) + parseInt(destinationOriginalNumber))

        const tempBL = {
            'BSKEY': 0,
            'BusinessStatusKey': 0,
            'IdProcessStatus': varNameDict.get('WaitingApproval'),
            'IdBooking': varNameDict.get('IdBooking'),
            'IdAddress': varNameDict.get('AddressId') || '00000000-0000-0000-0000-000000000000',
            // 'NumberOriginal': varNameDict.get('freightOriginalCopies'),
            'BLNumber': varNameDict.get('freightBLNumber') || '',
            'NumberOriginal': NumberOriginal,
            'CopyNumber': CopyNumber,
            'Voyage': varNameDict.get('voyageVoyageNumber'),
            'Vessel': varNameDict.get('voyageVesselName'),
            'DischargePort': varNameDict.get('voyagePortDischarge'),
            'LoadingPort': varNameDict.get('voyagePortLoading'),
            'Receipt': varNameDict.get('voyagePlaceReceipt'),
            'Delivery': varNameDict.get('voyagePlaceDelivery'),
            'UserCompanyId': varNameDict.get('UserCompanyId'),
            'OriginOriginalNumber': parseInt(originOriginalNumber),
            'OriginCopyNumber': parseInt(originCopyNumber),
            'DestinationOriginalNumber': parseInt(destinationOriginalNumber),
            'DestinationCopyNumber': parseInt(destinationCopyNumber),
        }
        if (varNameDict.get('id')) {
            tempBL.Id = varNameDict.get('id')
        }

        let isBadBL = false
        const ShipmentPlusBLCreateArray = []


        const tempEntities = {
            IdShipper: varNameDict.get('shipperId') || '00000000-0000-0000-0000-000000000000',
            IdConsignee: varNameDict.get('consigneeId') || '00000000-0000-0000-0000-000000000000',
            IdNotify: varNameDict.get('notifyId') || '00000000-0000-0000-0000-000000000000',
        }

        if (!varNameDict.get('shipperId') || !varNameDict.get('consigneeId') || !varNameDict.get('notifyId')) {
            isBadBL = true
            error = t("noEntities")
        }

        const tempAddress = {
            Id: varNameDict.get('AddressId') || '00000000-0000-0000-0000-000000000000',
            ShipperAddress1: varNameDict.get('shipperName'),
            ShipperAddress2: varNameDict.get('shipperAddress'),
            ShipperAddress3: varNameDict.get('shipperAddress2'),
            ShipperAddress4: varNameDict.get('shipperZipCode'),
            ShipperCity: varNameDict.get('shipperCountry'),
            ShipperState: varNameDict.get('shipperVat'),

            ConsigneeAddress1: varNameDict.get('consigneeName'),
            ConsigneeAddress2: varNameDict.get('consigneeAddress'),
            ConsigneeAddress3: varNameDict.get('consigneeAddress2'),
            ConsigneeAddress4: varNameDict.get('consigneeZipCode'),
            ConsigneeCity: varNameDict.get('consigneeCountry'),
            ConsigneeState: varNameDict.get('consigneeVat'),

            NotifyAddress1: varNameDict.get('notifyName'),
            NotifyAddress2: varNameDict.get('notifyAddress'),
            NotifyAddress3: varNameDict.get('notifyAddress2'),
            NotifyAddress4: varNameDict.get('notifyZipCode'),
            NotifyCity: varNameDict.get('notifyCountry'),
            NotifyState: varNameDict.get('notifyVat'),
        }

        const tempArray = []
        const shipmentNumbers = []
        containerTypes.forEach(elem => {
            tempArray.push(...organizedData.get(elem))
        })
        tempArray.forEach(obj => shipmentNumbers.includes(obj.shipment) ? '' : shipmentNumbers.push(obj.shipment))


        shipmentNumbers.forEach((ship, indexShip) => {
            const shipDetails = []
            const tempShipArray = tempArray.filter(temp => temp.shipment === ship)
            tempShipArray.forEach(lines => {
                const ShipmentDetail = {
                    BookingEquipment: {

                        Id: lines.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                        IdEquipmentType: lines?.EquipmentTypeId,
                        IdEquipment: lines?.IdEquipment || "00000000-0000-0000-0000-000000000000",
                        GoodsDetails: lines?.Cargo,
                        TransportDetails: lines?.Weight,
                        LoadingDate: lines?.Date,
                        Brand: lines?.Brand,
                        Model: lines?.Model,
                        Chassis: lines?.Chassis,
                        SOC: lines?.SOC === true ? 'Y' : 'N',
                        SealNumberA: lines?.sealA,
                        SealNumberB: lines?.sealB
                    },
                    Equipment: null,
                    BookingEquipmentDimensionsList: [],
                    ShipmentDetail: {
                        Id: lines.IdShipmentDetails || "00000000-0000-0000-0000-000000000000",
                        IdBookingEquipment: lines.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                        IdShipment: lines.IdShipment || "00000000-0000-0000-0000-000000000000",
                        Package: lines.nrPackage,
                        Description: lines.description,
                        Weight: lines.grossWeight,
                        Measures: lines.measurements,
                        IdCommodity: lines.IdCommodity,
                        Marks: lines?.marks,
                        IMO: lines?.IMO,
                        dangerousGoods: lines?.dangerousGoods,
                        DbStatus: lines?.DBStatus || 'E',

                    }
                }
                if (lines?.Number) {
                    ShipmentDetail.Equipment = {
                        IdEquipmentType: lines?.EquipmentTypeId,
                        Prefix: lines?.Prefix || '',
                        Number: lines?.Number || '',
                        CheckDigit: lines?.CheckDigit || '',
                        Tare: lines?.Tare,
                        Payload: lines?.Payload,
                        SOC: lines?.SOC,
                        OwnerId: lines?.OwnerID,
                    }
                }
                if (lines?.Width && lines?.Height && lines?.Length) {
                    ShipmentDetail.BookingEquipmentDimensionsList.push({
                        Id: lines?.IdEquipmentDimensions || "00000000-0000-0000-0000-000000000000",
                        BookingEquipmentId: lines?.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                        DimensionsCode: '',
                        DimensionsWidth: lines?.Width,
                        DimensionsHeight: lines?.Height,
                        DimensionsLength: lines?.Length,
                    })
                }
                if (lines?.Front && lines?.Back && lines?.Left && lines?.Right && lines?.Height) {
                    ShipmentDetail.BookingEquipmentDimensionsList = [
                        {
                            Id: lines?.DimensionsFROId || "00000000-0000-0000-0000-000000000000",
                            BookingEquipmentId: lines?.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                            DimensionsCode: 'FRO',
                            DimensionsLength: lines?.Front || 0,
                            DimensionsWidth: 0,
                            DimensionsHeight: 0,
                        },
                        {
                            Id: lines?.DimensionsBACId || "00000000-0000-0000-0000-000000000000",
                            BookingEquipmentId: lines?.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                            DimensionsCode: 'BAC',
                            DimensionsLength: lines?.Back || 0,
                            DimensionsWidth: 0,
                            DimensionsHeight: 0,
                        },
                        {
                            Id: lines?.DimensionsLEFId || "00000000-0000-0000-0000-000000000000",
                            BookingEquipmentId: lines?.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                            DimensionsCode: 'LEF',
                            DimensionsLength: 0,
                            DimensionsWidth: lines?.Left || 0,
                            DimensionsHeight: 0,
                        },
                        {
                            Id: lines?.DimensionsRIGId || "00000000-0000-0000-0000-000000000000",
                            BookingEquipmentId: lines?.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                            DimensionsCode: 'RIG',
                            DimensionsLength: 0,
                            DimensionsWidth: lines?.Right || 0,
                            DimensionsHeight: 0,
                        },
                        {
                            Id: lines?.DimensionsOVEId || "00000000-0000-0000-0000-000000000000",
                            BookingEquipmentId: lines?.IdBookingEquipment || "00000000-0000-0000-0000-000000000000",
                            DimensionsCode: 'OVE',
                            DimensionsLength: 0,
                            DimensionsWidth: 0,
                            DimensionsHeight: lines?.Height || 0,
                        },
                    ]
                }
                shipDetails.push(ShipmentDetail)
            })
            const tempCustomsOffice = dictCustomOfficeDict.filter(customs => customs['Despatch number'] == tempShipArray[0].dispatchNumber)[0]
            if (tempCustomsOffice === undefined && tempShipArray[0].DBStatus === 'E') {
                isBadBL = true
                error = t("LabelAllShipsNeedDespatch")
            } else if (tempCustomsOffice === undefined && tempShipArray[0].DBStatus === 'D') {
            }
            else {
                const validIdShipment = shipDetails.find(
                    d => d.ShipmentDetail?.IdShipment && d.ShipmentDetail.IdShipment !== "00000000-0000-0000-0000-000000000000"
                )?.ShipmentDetail.IdShipment;
                const ShipmentPlusBLCreateObj = {
                    CustomsOffice: {
                        'IdShipment': validIdShipment || "00000000-0000-0000-0000-000000000000",
                        'IdCustomsDocumentType': tempCustomsOffice?.['idDocumentType'],
                        'PCOMCustomsDocumentNumber': tempCustomsOffice?.['Despatch number'],
                        'PCOMCustomsOffice': tempCustomsOffice?.['Customs office'],
                        'PCOMCustomsDocumentDate': tempCustomsOffice?.['Date'],
                        'PCOMCustomsEntity': null,
                        'PCOMCustomsStatus': null,
                        'PCOMExportDeclaration': null,
                        'PCOMFileName': null,
                    },
                    Shipment: {
                        Order: indexShip,
                        Id: validIdShipment || "00000000-0000-0000-0000-000000000000",
                        IdBooking: varNameDict.get('IdBooking'),
                        IdCommodity: shipDetails[0].ShipmentDetail?.IdCommodity || null,
                        IdPackage: null,
                        Temp: tempShipArray[0]?.OnOff !== false ? tempShipArray[0]?.Temperature : '',
                        IMODangerGoods: shipDetails[0].ShipmentDetail?.IMO || false,
                    },
                    ShipmentDetailPlusBLListCreate: shipDetails,
                    ShipmentDangerousGoodsPlusBLListCreate: []
                }
                if ((ShipmentPlusBLCreateObj.Shipment.IdCommodity === null || ShipmentPlusBLCreateObj.Shipment.IdCommodity === '' || ShipmentPlusBLCreateObj.Shipment.IdCommodity === undefined) && tempShipArray[0].DBStatus === 'E') {
                    isBadBL = true
                    error = t("ShipmentCommodity")
                }
                else if ((ShipmentPlusBLCreateObj.Shipment.IdCommodity === null || ShipmentPlusBLCreateObj.Shipment.IdCommodity === '' || ShipmentPlusBLCreateObj.Shipment.IdCommodity === undefined) && tempShipArray[0].DBStatus === 'D') {

                }

                let hasDangerousGoods = false

                shipDetails[0].ShipmentDetail?.dangerousGoods.forEach(danger => {
                    if (danger.DangerousGoodsId) {
                        hasDangerousGoods = true
                    }
                })

                if (hasDangerousGoods) {
                    ShipmentPlusBLCreateObj.ShipmentDangerousGoodsPlusBLListCreate = shipDetails[0].ShipmentDetail?.dangerousGoods.map((imo, imoIndex) => {
                        return {
                            'ShipmentDangerousGoods': {
                                'Id': imo.IdDangerousGoodsList,
                                'IdShipment': validIdShipment || "00000000-0000-0000-0000-000000000000",
                                'IdDangerousGoods': imo.DangerousGoodsId,
                                'FlashPT': imo.FlashPT,
                                'PackagingGroup': imo.PackagingGroup,
                            }
                        }
                    }
                    )
                }

                if (tempCustomsOffice && tempCustomsOffice.idCustomOffice) {
                    ShipmentPlusBLCreateObj.CustomsOffice.Id = tempCustomsOffice.idCustomOffice
                }
                ShipmentPlusBLCreateArray.push(ShipmentPlusBLCreateObj)
            }
        })
        if (ShipmentPlusBLCreateArray.length < 1 && !isBadBL) {
            isBadBL = true
            error = 'Must have at least one Shipment'
        }
        const tempBooking = {
            LocationReceiptId: varNameDict.get('LocationReceiptId'),
            LoadingPortId: varNameDict.get('LoadingPortId'),
            DischargePortId: varNameDict.get('DischargePortId'),
            LocationDeliveryPortId: varNameDict.get('LocationDeliveryPortId'),
            Transhipment: varNameDict.get('Transhipment') ? "Y" : "N",
        }
        const BLObj = {
            BL: tempBL,
            Booking: tempBooking,
            Address: tempAddress,
            Entities: tempEntities,
            ShipmentPlusBLListCreate: ShipmentPlusBLCreateArray
        }
        if (isBadBL) {
            return { 'Error': true, 'Message': error }
        } else {
            return BLObj
        }
    }

    const submitForApproval = () => {
        setOpenConfirmModal(true)
    }

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false)
    }

    const rejectBl = () => {
        ctx.setIsLoad(true)
        // return
        let values = new Map()
        values.set("RejectFields", [...rejectFields.values()])
        // values.set("RejectFields", rejectFields)
        values.set("CustomsRows", customsRows)
        values.set("SelectedRows", selectedRows)
        values.set("Notes", finalNotes)
        values = Object.fromEntries(values)
        const valueString = JSON.stringify(values)
        const temp = btoa(valueString)

        let tempString = '\n Fields Rejected: \n'

        values.RejectFields.forEach(elem => {
            tempString = tempString.concat(`${elem.label}: ${elem.value} - ${elem.Notes} \n`)
        })

        tempString = tempString.concat(`\n Customs Office Rejected: \n`)

        values.CustomsRows.forEach(elem => {
            tempString = tempString.concat(`Document Type: ${elem['Document Type']} | Despatch Number: ${elem['Despatch number']} | Customs Office: ${elem['Customs office']} - Notes: ${elem.Notes}`)
        })

        tempString = tempString.concat(`\n Shipment Details Rejected: \n`)

        values.SelectedRows.forEach(elem => {
            tempString = tempString.concat(`Line id ${elem.id} | Shipment: ${elem.shipment} | ${elem.matricula} | Description: ${elem.description} | Weight: ${elem.grossWeight} - Notes: ${elem.Notes}`)
        })

        tempString = tempString.concat(`\n Notes: \n ${finalNotes}`)

        const approvalPost = {
            "IdBooking": null,
            "IdBL": varNameDict.get('id'),
            "Approved": false,
            "Description": temp,
            "NotificationBody": tempString
        }

        const tempObj = dataToUpdate()
        if (tempObj?.Error) {
            ctx.setIsLoad(false)
            toastMessages('error', '', tempObj?.Message)
            return
        } else {
            tempObj.BL.IdProcessStatus = varNameDict.get('Rejected')
            BLService.update(varNameDict.get('id'), tempObj).then(res => {
                let success = true
                if (res.name === 'AxiosError') {
                    // toastMessages('error', '', res.message)
                    const errMsg = res?.response?.data?.Message || res?.response?.data?.Errors?.toString() || res.message
                    if (Array.isArray(res?.response?.data?.Errors)) {
                        ctx.toastMessages('error', res?.response?.data?.Errors.toString(), 'Erro, ')
                        setErrorMessage(res.response.data.Errors)
                    } else {
                        ctx.toastMessages('error', errMsg, 'Erro, ')
                        setErrorMessage(errMsg)
                    }
                    success = false
                }
                if (success) {
                    approveService.post(approvalPost).then(response => {
                        ctx.setIsLoad(false)
                        if (response.name === 'AxiosError') {
                            // toastMessages('error', '', response.message)
                            const errMsg = response?.response?.data?.Message || response?.response?.data?.Errors?.toString() || response.message
                            if (Array.isArray(response?.response?.data?.Errors)) {
                                ctx.toastMessages('error', response?.response?.data?.Errors.toString(), 'Erro, ')
                                setErrorMessage(response.response.data.Errors)
                            } else {
                                ctx.toastMessages('error', errMsg, 'Erro, ')
                                setErrorMessage(errMsg)
                            }
                            success = false
                        }
                        setApproveSuccess(success)
                        setIsApprove(false)
                        setConfirmationModal(true)
                    })
                } else {
                    setApproveSuccess(success)
                    setIsApprove(false)
                    setConfirmationModal(true)
                    ctx.setIsLoad(false)
                    toastMessages('success', '', t("MessageRedirectingMenu"))
                }
            })
            // handleTabClose(JSON.parse(id))
        }
    }

    const acceptBL = () => {
        ctx.setIsLoad(true)

        const approvalPost = {
            "IdBooking": null,
            "IdBL": varNameDict.get('id'),
            "Approved": true,
            "Description": "Approved",
            "NotificationBody": ""
        }

        const tempObj = dataToUpdate()
        if (tempObj?.Error) {
            ctx.setIsLoad(false)
            toastMessages('error', '', tempObj?.Message)
        } else {

            tempObj.BL.IdProcessStatus = varNameDict.get('Approved')
            BLService.update(varNameDict.get('id'), tempObj).then(res => {
                let success = true
                if (res.name === 'AxiosError') {
                    const errMsg = res?.response?.data?.Message || res?.response?.data?.Errors?.toString() || res.message
                    ctx.toastMessages('error', errMsg, 'Error: ')
                    success = false
                    setErrorMessage(errMsg)
                }
                if (success) {

                    approveService.post(approvalPost).then(response => {
                        if (response.name === 'AxiosError') {
                            ctx.setIsLoad(false)
                            // toastMessages('error', '', response.message)
                            if (Array.isArray(response?.response?.data?.Errors)) {
                                ctx.toastMessages('error', response?.response?.data?.Errors.toString(), 'Erro, ')
                            } else {
                                ctx.toastMessages('error', response?.message, 'Erro, ')
                            }
                            success = false
                            setErrorMessage(response.response.data.Errors)
                        }
                        setApproveSuccess(success)
                        setIsApprove(true)
                        setConfirmationModal(true)
                        ctx.setIsLoad(false)
                    })
                } else {
                    setApproveSuccess(success)
                    setIsApprove(true)
                    setConfirmationModal(true)
                    ctx.setIsLoad(false)
                    toastMessages('success', '', t("MessageRedirectingMenu"))
                }
            })
            // handleTabClose(JSON.parse(id))
        }
    }

    const confirmApproval = () => {
        setConfirmationModal(false)
        toastMessages('success', '', t("MessageRedirectingMenu"))
        handleTabClose(JSON.parse(id))
    }

    const closeModal = () => {
        setConfirmationModal(false)
    }

    const onReproveFields = (key, data) => {
        setRejectFields(new Map(rejectFields.set(key, { ...rejectFields.get(key), Notes: data })))
    }

    const onReproveCustoms = (obj, data) => {
        setCustomsRows(customsRows.map(elem => {
            if (elem.idCustomOffice === obj.idCustomOffice) {
                return { ...obj, 'Notes': data }
            } else {
                return elem
            }
        }))
        setDictCustomOFficeDict(dictCustomOfficeDict.map(elem => {
            if (elem.idCustomOffice === obj.idCustomOffice) {
                return { ...obj, 'Notes': data }
            } else {
                return elem
            }
        }))
    }

    const onReproveShipments = (obj, data, dict, setDict) => {
        setDict(dict.map(elem => {
            if (elem.id === obj.id) {
                return { ...obj, 'Notes': data }
            } else {
                return elem
            }
        }))
        const tempArray = organizedData.get(obj.matricula)
        organizedData.set(obj.matricula, tempArray.map((elem) => {
            if (elem.id === obj.id) {
                return { ...obj, 'Notes': data }
            } else {
                return elem
            }
        }))
        setOrganizedData(new Map(organizedData))
    }

    const getAddress = (key, id) => {
        const tempValue = id
        if (id) {
            const temp = filterService.queryBuilder(1, 1, undefined, null, `AccountId eq ${tempValue}`)
            officeService.filter(temp).then(res => {
                if (res.name === 'AxiosError') {
                    toastMessages('error', res.message, '')
                    return
                }
                if (res.Items.length > 0) {
                    getEntityValues(res.Items[0], key)
                }
            })
        }
    }

    const addImoValue = (key, value, obj) => {
        let tempArray = []
        if (typeof value === 'string' || value instanceof String) {
            value = value.toLocaleUpperCase()
        }
        obj[key] = value
        tempArray = shipmentToDispatch.dangerousGoods.map(imo => {
            if (imo.id === obj.id) {
                return obj
            } else {
                return imo
            }
        })
        setShipmentToDispatch({ ...shipmentToDispatch, dangerousGoods: tempArray })
    }

    const deleteImo = (obj) => {
        const tempArray = shipmentToDispatch.dangerousGoods
        const newArray = []
        tempArray.forEach(imo => {
            if (imo.id !== obj.id) {
                newArray.push(imo)
            }
        })
        setShipmentToDispatch({ ...shipmentToDispatch, dangerousGoods: newArray })
    }

    const createImo = () => {
        // Limitar a 1 IMO por shipment
        if (shipmentToDispatch?.dangerousGoods?.length >= 1) {
            return
        }
        const tempArray = shipmentToDispatch?.dangerousGoods || []
        let tempObj = { id: imoCounter }
        DangerousGoods.forEach(imo => {
            tempObj[imo.code] = null
        })
        tempArray.push(tempObj)
        setShipmentToDispatch({ ...shipmentToDispatch, dangerousGoods: tempArray })
        setImoCounter(imoCounter + 1)
    }

    const updateSOCValue = (key, value) => {
        if (typeof value === 'string' || value instanceof String) {
            value = value.toLocaleUpperCase()
        }
        setShipmentToDispatch({ ...shipmentToDispatch, [key]: value })
    }

    const updateReeferValue = (key, value) => {
        setShipmentToDispatch({ ...shipmentToDispatch, [key]: value })
    }

    const element = () => {
        return (
            <>
                <div className='titleDrawer'>
                    <h1>Shipment Options</h1>
                </div>
                <fieldset>
                    <legend>Despatch Number</legend>
                    <M_Select
                        label={'Despatch Number'}
                        value={shipmentToDispatch?.dispatchNumber}
                        onChange={(e) => {
                            setShipmentToDispatch({ ...shipmentToDispatch, 'dispatchNumber': e.target.value })
                            editDispatch(e.target.value, shipmentToDispatch)
                        }}
                        required={true}
                        options={dictCustomOfficeDict.map(el => { return { label: `#${el.id} Despatch - ${el['Despatch number']}`, value: el['Despatch number'] } })}
                        color={!shipmentToDispatch?.dispatchNumber ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes('shipmentDispatch') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                        secondColor={!shipmentToDispatch?.dispatchNumber ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes('shipmentDispatch') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                        disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                    />
                </fieldset>
                <fieldset>
                    <legend>Commmodity</legend>
                    <div className="divTextfields">
                        {Commmodity.map((value, index) => (
                            value.label === 'Code' ?
                                <M_DrawerTableTextField
                                    key={index}
                                    tableLabel={'Commodity'}
                                    label={value.label}
                                    value={shipmentToDispatch?.IdCommodity ?
                                        {
                                            CommodityCode: shipmentToDispatch?.CommodityCode,
                                            CommodityName: shipmentToDispatch?.CommodityName,
                                            Id: shipmentToDispatch?.IdCommodity

                                        } : null}
                                    entity={'commodity'}
                                    filterField={'CommodityCode'}
                                    labelFields={['CommodityCode', 'CommodityName']}
                                    onSubmitValue={(obj) => {
                                        if (obj) {
                                            editCommodity(new Map(Object.entries(obj)), shipmentToDispatch)
                                            setShipmentToDispatch({
                                                ...shipmentToDispatch,
                                                'CommodityCode': obj['CommodityCode'],
                                                'CommodityName': obj['CommodityName'],
                                                'IdCommodity': obj['Id'],
                                            })
                                        } else {
                                            editCommodity(new Map([['CommodityCode', ''], ['CommodityName', ''], ['Id', '']]), shipmentToDispatch)
                                            setShipmentToDispatch({
                                                ...shipmentToDispatch,
                                                'CommodityCode': '',
                                                'CommodityName': '',
                                                'IdCommodity': '',
                                            })
                                        }
                                    }}
                                    required={true}
                                    color={!shipmentToDispatch?.CommodityCode ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    secondColor={!shipmentToDispatch?.CommodityCode ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                                />
                                :
                                <div key={index} className="individualTextfield">
                                    <M_InputTextField
                                        label={value.label}
                                        value={shipmentToDispatch?.CommodityName || ''}
                                        disabled
                                        passRequired={true}
                                        color={!shipmentToDispatch?.CommodityName ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        disabledColor={!shipmentToDispatch?.CommodityName ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes('IdCommodity') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    />
                                </div>
                        ))}
                    </div>
                </fieldset>
                <fieldset style={{ position: 'relative' }}>
                    <legend>IMO</legend>

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <M_CheckBox
                            checked={shipmentToDispatch?.IMO}
                            label={'IMO'}
                            onChange={(e) => { setShipmentToDispatch({ ...shipmentToDispatch, 'IMO': e.target.checked }) }}
                            color={shipmentToDispatch?.shipmentChanged?.includes('IMO') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            labelColor={shipmentToDispatch?.shipmentChanged?.includes('IMO') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                            disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                        />
                    </div>
                    {shipmentToDispatch?.IMO ?
                        shipmentToDispatch?.dangerousGoods.map((imo, imoIndex) => (
                            <fieldset key={imoIndex} style={{ position: 'relative' }}>
                                <legend>Dangerous Goods</legend>
                                <div className="divTextfields">

                                    {DangerousGoods.map((value, index) => (
                                        value.label === 'UN No.' ?
                                            <div key={index} className="individualTextfield">
                                                <M_DrawerTableTextField
                                                    tableLabel={'Dangerous Goods'}
                                                    label={value.label}
                                                    value={imo.DangerousGoodsId ?
                                                        {
                                                            Id: imo.DangerousGoodsId,
                                                            Code: imo[value.code],
                                                            Class: imo.DangerousGoodsClass
                                                        } : null}
                                                    entity={'dangerousGoods'}
                                                    filterField={'Code'}
                                                    labelFields={['Class', 'Code']}
                                                    onSubmitValue={(obj) => {
                                                        if (obj) {
                                                            addImoValue(`DangerousGoodsId`, obj.Id, imo)
                                                            addImoValue('DangerousGoodsClass', obj['Class'], imo)
                                                            addImoValue(value.code, obj['Code'], imo)
                                                        } else {
                                                            addImoValue(`DangerousGoodsId`, '', imo)
                                                            addImoValue('DangerousGoodsClass', '', imo)
                                                            addImoValue(value.code, '', imo)
                                                        }
                                                    }}
                                                    color={imo?.shipmentChanged?.includes(`DangerousGoodsId`) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                    secondColor={imo?.shipmentChanged?.includes(`DangerousGoodsId`) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                    disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                                                />
                                            </div>
                                            : value.label === 'Class' ?
                                                <div key={index} className="individualTextfield">
                                                    <M_InputTextField
                                                        disabled
                                                        label={value.label}
                                                        value={imo[value.code] || ''}
                                                        onChange={(e) => addImoValue(value.code, e.target.value, imo)}
                                                        color={imo?.shipmentChanged?.includes(`DangerousGoodsId`) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                        secondColor={imo?.shipmentChanged?.includes(`DangerousGoodsId`) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                    />
                                                </div>
                                                : value.label === 'Flash Point (ºC)' ?
                                                    <div key={index} className="individualTextfield" >
                                                        <M_InputTextField
                                                            type={'number'}
                                                            label={value.label}
                                                            value={imo[value.code] || ''}
                                                            onChange={(e) => addImoValue(value.code, e.target.value, imo)}
                                                            color={imo?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                            passColor={imo?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                            disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                                                        />
                                                    </div>
                                                    :
                                                    <div key={index} className="individualTextfield">
                                                        <M_InputTextField
                                                            label={value.label}
                                                            value={imo[value.code] || ''}
                                                            onChange={(e) => addImoValue(value.code, e.target.value, imo)}
                                                            color={imo?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                            secondColor={imo?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                            disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                                                        />
                                                    </div>
                                    ))}
                                </div>
                            </fieldset>
                        ))
                        :
                        shipmentToDispatch?.dangerousGoods.map((imo, imoIndex) => (
                            <fieldset key={imoIndex} style={{ borderColor: 'grey' }}>
                                <legend style={{ color: 'grey' }}>Dangerous Goods</legend>
                                <div className="divTextfields">
                                    {DangerousGoods.map((value, index) => (
                                        <div key={index} className="individualTextfield">
                                            <M_InputTextField
                                                disabled
                                                label={value.label}
                                                value=' '
                                            />
                                        </div>
                                    ))}
                                </div>
                            </fieldset>
                        ))
                    }
                </fieldset>
                <fieldset>
                    <legend>SOC</legend>
                    <div style={{ display: 'grid', gridTemplateColumns: 'auto auto auto', textAlign: 'center' }}>
                        {SOC.map((value, index) => (
                            <div key={index} className="individualTextfield">
                                {value.code === 'Prefix' ?
                                    <>
                                        <div style={{ marginRight: '10px' }}>
                                            <M_Button
                                                isSimple={true}
                                                entity={'Equipment'}
                                                icon={<img src='/icons/svgsDaNet/searchBlue.svg' alt='searchEquipment'></img>}
                                                passIsTable={true}
                                                tableLabel={'Equipments'}
                                                onGetline={(e) => {
                                                    updateSOCValue('Prefix', e?.Prefix || '')
                                                    updateSOCValue('Number', e?.Number || '')
                                                    updateSOCValue('CheckDigit', e?.CheckDigit || '')
                                                    updateSOCValue('IdEquipment', e?.Id || '')
                                                    updateSOCValue('Payload', e?.Payload || '')
                                                    updateSOCValue('Tare', e?.Tare || '')
                                                }}
                                                errorMessage={t('fillCompany')}
                                                FILTER={`OwnerID eq ${varNameDict.get('UserCompanyId')}`}
                                            />
                                        </div>
                                        <M_InputTextField
                                            label={value.label}
                                            value={shipmentToDispatch?.Prefix || ''}
                                            maxNumbers={4}
                                            onChange={(e) => {
                                                updateSOCValue('Prefix', e.target.value)
                                                updateSOCValue('IdEquipment', '')
                                            }}
                                            secondColor={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                            color={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        />
                                    </>
                                    :
                                    value.code === 'Number' ?
                                        <M_InputTextField
                                            label={value.label}
                                            value={shipmentToDispatch?.Number || ''}
                                            maxNumbers={6}
                                            onChange={(e) => {
                                                updateSOCValue('Number', e.target.value)
                                                updateSOCValue('IdEquipment', '')
                                            }}
                                            type={'number'}
                                            secondColor={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                            color={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        /> :
                                        value.code === 'CheckDigit' ?
                                            <M_InputTextField
                                                label={value.label}
                                                value={shipmentToDispatch?.CheckDigit || ''}
                                                maxNumbers={1}
                                                onChange={(e) => {
                                                    updateSOCValue('CheckDigit', e.target.value)
                                                    updateSOCValue('IdEquipment', '')
                                                }}
                                                secondColor={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                                color={shipmentToDispatch?.shipmentChanged?.includes('IdEquipment') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                            />
                                            : ''
                                }
                            </div>
                        ))}
                    </div>
                    <div className="divTextfields">
                        {SOC.map((value, index) => (
                            value.code !== 'Prefix' && value.code !== 'Number' && value.code !== 'CheckDigit' ?
                                <div key={index} className="individualTextfield">
                                    <M_InputTextField
                                        type={'number'}
                                        label={value.label}
                                        value={shipmentToDispatch?.[value.code] || ''}
                                        onChange={(e) => updateSOCValue(value.code, e.target.value)}
                                        secondColor={shipmentToDispatch?.shipmentChanged?.includes(value.fieldChanges) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        color={shipmentToDispatch?.shipmentChanged?.includes(value.fieldChanges) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    />
                                </div>
                                : null
                        ))}
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Reefer</legend>
                    <div className="divTextfields">
                        {Reefer.map((value, index) => (
                            value.type === "textfield" ?
                                <div key={index} className="individualTextfield">
                                    <M_InputTextField
                                        type={'number'}
                                        disabled={shipmentToDispatch?.onOff !== true}
                                        required={shipmentToDispatch?.onOff === true}
                                        label={value.label}
                                        value={shipmentToDispatch?.[value.code] || ''}
                                        onChange={(e) => updateReeferValue(value.code, e.target.value)}
                                        secondColor={(shipmentToDispatch?.[value.code] === '' || shipmentToDispatch?.[value.code] === undefined || shipmentToDispatch?.[value.code] === null) && shipmentToDispatch?.onOff === true ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        color={(shipmentToDispatch?.[value.code] === '' || shipmentToDispatch?.[value.code] === undefined || shipmentToDispatch?.[value.code] === null) && shipmentToDispatch?.onOff === true ? 'var(--color-red)' : shipmentToDispatch?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    />
                                </div>
                                :
                                <div key={index} className="individualTextfield">
                                    <M_SwitchButton
                                        checked={shipmentToDispatch?.[value.code] !== undefined && shipmentToDispatch?.[value.code] !== null ? shipmentToDispatch?.[value.code] : false}
                                        onClick={(e) => updateReeferValue(value.code, e.target.checked)}
                                        secondColor={shipmentToDispatch?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                        color={shipmentToDispatch?.shipmentChanged?.includes(value.code) && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : undefined}
                                    />
                                    {value.label}
                                </div>
                        ))}
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Marks</legend>
                    <div className="divTextfields">
                        <div style={{ width: '100%', gridColumn: '1 / -1' }}>
                            <div style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '8px', minHeight: '70px' }}>
                                <M_TextArea
                                    label={<span style={{ fontSize: '1.25rem', fontWeight: 500 }}>{'Marks'}</span>}
                                    value={shipmentToDispatch?.marks || ''}
                                    blockSpecialChars={true}
                                    onChange={(e) => setShipmentToDispatch({ ...shipmentToDispatch, 'marks': e.target.value })}
                                    rows={3}
                                    disabled={shipmentToDispatch?.DBStatus === 'D' ? true : false}
                                    secondColor={shipmentToDispatch?.shipmentChanged?.includes('marks') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : null}
                                    color={shipmentToDispatch?.shipmentChanged?.includes('marks') && !shipmentToDispatch?.shipmentChanged?.includes('ShipmentId') ? 'var(--color-yellow)' : null}
                                />
                            </div>
                        </div>
                    </div>
                </fieldset>
            </>
        )
    }


    const elementContainer = () => {
        return (
            <>
                <div className='titleDrawer'>
                    <h1>New Equipment</h1>
                </div>
                <M_Fieldset
                    labelInside
                    elements={

                        <div id='CONTAINER_' style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                            <div id='CONTAINER_FIRST_ROW' style={{ display: 'flex', }}>
                                <div id='CONTAINER_MATRICULA' style={{ display: 'flex', marginRight: '20px' }}>
                                    <div style={{ marginTop: '10px' }}>
                                        <M_Button
                                            height={2}
                                            width={5}
                                            backgroundColor={'var(--color-blue)'}
                                            isSimple={true}
                                            entity={'Equipment'}
                                            icon={<Search style={{ color: 'var(--color-white)' }} />}
                                            passIsTable={true}
                                            tableLabel={'Equipments'}
                                            onGetline={(e) => {
                                                updateContainer('Prefix', e.Prefix)
                                                updateContainer('Number', e.Number)
                                                updateContainer('CheckDigit', e.CheckDigit)
                                                updateContainer('IdEquipment', e.EquipmentId)
                                                updateContainer('Payload', e.Payload)
                                                updateContainer('Tare', e.Tare)
                                            }}
                                            toastMessages={toastMessages ? toastMessages : null}
                                            message={t('fillCompany')}
                                            FILTER={`OwnerID eq ${varNameDict.get('UserCompanyId')}`}
                                        />
                                    </div>
                                    <div className="individualTextfield">
                                        <M_InputTextField
                                            // color={newContainerMap.get('SOC') && newContainerMap.get('Prefix')?.length !== 4 ? 'red' : ''}
                                            // secondColor={newContainerMap.get('SOC') && newContainerMap.get('Prefix')?.length !== 4 ? 'red' : ''}
                                            // required={newContainerMap.get('SOC') && newContainerMap.get('Prefix')?.length !== 4 ? true : false}
                                            label={'Prefix'}
                                            maxNumbers={4}
                                            value={newContainerMap.get('Prefix') || ''}
                                            onChange={(e) => { updateContainer('Prefix', e.target.value) }}
                                        />
                                    </div>
                                    <div className="individualTextfield">
                                        <M_InputTextField
                                            type={'number'}
                                            color={newContainerMap.get('SOC') && newContainerMap.get('Number')?.length !== 6 ? 'red' : ''}
                                            secondColor={newContainerMap.get('SOC') && newContainerMap.get('Number')?.length !== 6 ? 'red' : ''}
                                            required={newContainerMap.get('SOC') && newContainerMap.get('Number')?.length !== 6 ? true : false}
                                            label={'Number'}
                                            maxNumbers={6}
                                            value={newContainerMap.get('Number') || ''}
                                            onChange={(e) => { updateContainer('Number', e.target.value) }}
                                        />
                                    </div>
                                    <div className="individualTextfield">
                                        <M_InputTextField
                                            color={newContainerMap.get('SOC') && newContainerMap.get('CheckDigit')?.length !== 1 ? 'red' : ''}
                                            secondColor={newContainerMap.get('SOC') && newContainerMap.get('CheckDigit')?.length !== 1 ? 'red' : ''}
                                            required={newContainerMap.get('SOC') && newContainerMap.get('CheckDigit')?.length !== 1 ? true : false}
                                            label={'Check Digit'}
                                            maxNumbers={1}
                                            value={newContainerMap.get('CheckDigit') || ''}
                                            onChange={(e) => { updateContainer('CheckDigit', e.target.value) }}
                                        />
                                    </div>
                                </div>
                                <M_DrawerTableTextField
                                    tableLabel={'Equipment Types'}
                                    label={'EquipmentType'}
                                    value={newContainerMap.get('EquipmentTypeId') ?
                                        {
                                            Id: newContainerMap.get('EquipmentTypeId'),
                                            EquipmentTypeLenght: newContainerMap.get('EquipmentTypeLenght'),
                                            EquipmentTypeCode: newContainerMap.get('EquipmentTypeCode'),
                                            EquipmentClassCode: newContainerMap.get('EquipmentClassCode'),
                                        }
                                        : null}
                                    entity={'equipmentType'}
                                    filterField={'EquipmentTypeCode'}
                                    labelFields={['EquipmentTypeLenght', 'EquipmentTypeCode']}
                                    onSubmitValue={(obj) => {
                                        if (obj) {
                                            updateContainer(`EquipmentTypeId`, obj.Id)
                                            updateContainer('EquipmentType', `${obj['EquipmentTypeLenght'] || ''}${obj['EquipmentTypeCode'] || ''}`)
                                            updateContainer('EquipmentTypeLenght', obj['EquipmentTypeLenght'])
                                            updateContainer('EquipmentTypeCode', obj['EquipmentTypeCode'])
                                            updateContainer('EquipmentClassCode', obj['EquipmentClassCode'])
                                        } else {
                                            updateContainer(`EquipmentTypeId`, '')
                                            updateContainer('EquipmentType', '')
                                            updateContainer('EquipmentTypeLenght', '')
                                            updateContainer('EquipmentTypeCode', '')
                                            updateContainer('EquipmentClassCode', '')
                                        }
                                    }}
                                    onSaveId={(e) => updateContainer(`EquipmentTypeId`, e,)}
                                    onExtraFields={(e) => {
                                        updateContainer('EquipmentType', `${e.get('EquipmentTypeLenght') || ''}${e.get('EquipmentTypeCode') || ''}`)
                                        updateContainer('EquipmentTypeLenght', e.get('EquipmentTypeLenght'))
                                        updateContainer('EquipmentTypeCode', e.get('EquipmentTypeCode'))
                                        updateContainer('EquipmentClassCode', e.get('EquipmentClassCode'))
                                    }}
                                    color={newContainerMap.get('EquipmentType') ? '' : 'red'}
                                    secondColor={newContainerMap.get('EquipmentType') ? '' : 'red'}
                                    required={newContainerMap.get('EquipmentType') ? false : true}
                                />
                            </div>
                            <div id='CONTAINER_SECOND_ROW' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="individualTextfield" style={{ width: '600px' }}> 
                                    <M_InputTextField
                                        label={'Cargo Description'}
                                        value={newContainerMap.get('Cargo') || ''}
                                        blockSpecialChars={true}
                                        onChange={(e) => { updateContainer('Cargo', e.target.value) }}
                                    />
                                </div>
                                <div className="individualTextfield" style={{ width: '400px' }}>
                                    <M_InputTextField
                                        type={'number'}
                                        label={'Load Weight (KG)'}
                                        value={newContainerMap.get('Weight') || ''}
                                        onChange={(e) => { updateContainer('Weight', e.target.value) }}
                                    />
                                </div>
                                <div className='individualTextfield' style={{ width: '400px' }}>
                                    <M_InputTextField
                                        type='date'
                                        label={'Loading Date'}
                                        value={newContainerMap.get('Date') || ''}
                                        onChange={(e) => { updateContainer('Date', e.target.value) }}
                                    />
                                </div>
                            </div>
                            <div id='CONTAINER_THIRD_ROW' style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '5px', marginRight: '5px', width: '200px' }}>
                                    <M_CheckBox
                                        label={'SOC'}
                                        checked={newContainerMap.get('SOC') || false}
                                        onChange={(e) => { updateContainer('SOC', e.target.checked) }}
                                    />
                                </div>
                                <div className="individualTextfield" style={{ width: '400px' }}>
                                    <M_InputTextField
                                        type={'number'}
                                        label={'Payload'}
                                        value={newContainerMap.get('Payload') || ''}
                                        onChange={(e) => { updateContainer('Payload', e.target.value) }}
                                    />
                                </div>
                                <div className="individualTextfield" style={{ width: '400px' }}>
                                    <M_InputTextField
                                        type={'number'}
                                        value={newContainerMap.get('Tare') || ''}
                                        onChange={(e) => { updateContainer('Tare', e.target.value) }}
                                    />
                                </div>
                            </div>
                        </div >
                    }
                />

                <fieldset id='REEFER' style={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? { borderColor: 'grey' } : {}}>
                    <legend style={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? { color: 'grey' } : {}}>Reefer</legend>
                    <div className="divTextfields">
                        <div className="individualTextfield">
                            {/* <SwitchButton
                                disabled={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? true : false}
                                passColor={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? 'var(--color-grey)' : ''}
                                style={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? { color: 'grey' } : {}}
                                checked={newContainerMap.get('OnOff') !== undefined && newContainerMap.get('OnOff') !== null ? newContainerMap.get('OnOff') : true}
                                onClick={(e) => updateContainer('OnOff', e.target.checked)}
                            /> */}
                            <M_SwitchButton
                                disabled={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? true : false}
                                color={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? 'var(--color-grey)' : 'var(--color-blue)'}
                                checked={newContainerMap.get('OnOff') !== undefined && newContainerMap.get('OnOff') !== null ? newContainerMap.get('OnOff') : true}
                                onClick={(e) => updateContainer('OnOff', e.target.checked)}
                            />
                            <span style={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? { color: 'grey' } : {}}> {'On / Off'} </span>
                        </div>
                        <div className="individualTextfield">
                            <M_InputTextField
                                type={'number'}
                                disabled={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? true : newContainerMap.get('OnOff') !== true ? true : false}
                                color={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? 'grey' : newContainerMap.get('OnOff') !== true || newContainerMap.get('Temperature')?.length >= 1 ? '' : 'red'}
                                secondColor={newContainerMap.get('EquipmentTypeCode') !== 'RF' ? 'grey' : newContainerMap.get('OnOff') !== true || newContainerMap.get('Temperature')?.length >= 1 ? '' : 'red'}
                                required={newContainerMap.get('Temperature')?.length >= 1 ? false : true}
                                label={'Temperature'}
                                value={newContainerMap.get('Temperature') || ''}
                                onChange={(e) => { updateContainer('Temperature', e.target.value) }}
                            />
                        </div>
                    </div>
                </fieldset>
                <fieldset id='DIMENSIONS' style={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? { borderColor: 'grey' } : {}}>
                    <legend style={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? { color: 'grey' } : {}}>Dimensions</legend>
                    {newContainerMap.get('EquipmentTypeCode') && (newContainerMap.get('EquipmentTypeCode')?.search('OT') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('FL') !== -1) ?
                        <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            <div style={{ padding: '20px', height: '300px', width: '350px' }}>
                                <div id='CONTAINER' style={{ border: '2px #EC7F00 solid', position: 'relative', width: ' 88px', height: '185px', backgroundColor: '#E9E9E9', left: '100px', top: '30px' }}>

                                    <div className="Rectangle880" style={{ width: 1, height: 87, transform: 'rotate(-90deg)', transformOrigin: '0 0', background: 'black', position: 'absolute', top: '-6px', left: '-2px' }} />
                                    <div className="Rectangle881" style={{ width: 1, height: 7, background: 'black', position: 'absolute', top: '-10px', left: '-2px' }} />
                                    <div className="Rectangle882" style={{ width: 1, height: 7, background: 'black', position: 'absolute', top: '-10px', right: '-2px' }} />

                                    <div className="Rectangle875" style={{ width: 1, height: 7, background: 'black', transform: 'rotate(-90deg)', transformOrigin: '0 0', position: 'absolute', left: '-10.5px' }} />
                                    <div className="Rectangle874" style={{ width: 1, height: 183, background: 'black', position: 'absolute', left: '-7px' }} />
                                    <div className="Rectangle876" style={{ width: 1, height: 7, background: 'black', transform: 'rotate(-90deg)', transformOrigin: '0 0', position: 'absolute', left: '-10.5px', top: '183px' }} />

                                    <div className="Rectangle875" style={{ width: 1, height: 7, background: 'black', transform: 'rotate(-90deg)', transformOrigin: '0 0', position: 'absolute', right: '-3.5px' }} />
                                    <div className="Rectangle874" style={{ width: 1, height: 183, background: 'black', position: 'absolute', right: '-7px' }} />
                                    <div className="Rectangle876" style={{ width: 1, height: 7, background: 'black', transform: 'rotate(-90deg)', transformOrigin: '0 0', position: 'absolute', right: '-3.5px', top: '183px' }} />

                                    <div className="Rectangle880" style={{ width: 1, height: 87, transform: 'rotate(-90deg)', transformOrigin: '0 0', background: 'black', position: 'absolute', top: '189.9px', left: '-2px' }} />
                                    <div className="Rectangle881" style={{ width: 1, height: 7, background: 'black', position: 'absolute', top: '186px', left: '-2px' }} />
                                    <div className="Rectangle882" style={{ width: 1, height: 7, background: 'black', position: 'absolute', top: '186px', right: '-2px' }} />

                                    <div id='FRONT' style={{ width: '100px', position: 'absolute', top: '-60px', }}>
                                        <M_InputTextField
                                            type={'number'}
                                            label={'Front (CM)'}
                                            value={newContainerMap.get('Front') || ''}
                                            onChange={(e) => updateContainer('Front', e.target.value)}
                                        />
                                    </div>
                                    <div id='LEFT' style={{ width: '100px', position: 'absolute', top: '30px', right: '100px' }}>
                                        <M_InputTextField
                                            type={'number'}
                                            label={'Left (CM)'}
                                            value={newContainerMap.get('Left') || ''}
                                            onChange={(e) => updateContainer('Left', e.target.value)}
                                        />
                                    </div>
                                    <div id='RIGHT' style={{ width: '100px', position: 'absolute', top: '30px', left: '100px' }}>
                                        <M_InputTextField
                                            type={'number'}
                                            label={'Right (CM)'}
                                            value={newContainerMap.get('Right') || ''}
                                            onChange={(e) => updateContainer('Right', e.target.value)}
                                        />
                                    </div>
                                    <div id='BACK' style={{ width: '100px', position: 'absolute', top: '190px', }}>
                                        <M_InputTextField
                                            type={'number'}
                                            label={'Back (CM)'}
                                            value={newContainerMap.get('Back') || ''}
                                            onChange={(e) => updateContainer('Back', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ padding: '20px', height: '300px', width: '300px' }}>
                                <div id="CONTAINER" style={{ position: 'relative', width: 152, height: 71, background: '#EC7F00', borderLeft: '2px #B85800 solid', borderRight: '2px #B85800 solid', borderBottom: '2px #B85800 solid', top: '50px' }}>
                                    <div className="Rectangle907" style={{ width: 2, height: 152, transform: 'rotate(-90deg)', transformOrigin: '0 0', background: '#B85800', position: 'absolute', left: '-2px', top: '2px' }} />

                                    <div className="Rectangle886" style={{ width: 1, height: 71, background: 'black', position: 'absolute', left: '155px' }} />
                                    <div className="Rectangle887" style={{ width: 1, height: 7, transform: 'rotate(-90deg)', transformOrigin: '0 0', background: 'black', position: 'absolute', left: '152px', top: '71px' }} />
                                    <div className="Rectangle889" style={{ width: 1, height: 7, transform: 'rotate(-90deg)', transformOrigin: '0 0', background: 'black', position: 'absolute', left: '152px' }} />

                                    <div className="Rectangle890" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '15px' }} />
                                    <div className="Rectangle892" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '30px' }} />
                                    <div className="Rectangle894" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '45px' }} />
                                    <div className="Rectangle896" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '60px' }} />
                                    <div className="Rectangle898" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '75px' }} />
                                    <div className="Rectangle900" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '90px' }} />
                                    <div className="Rectangle902" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '105px' }} />
                                    <div className="Rectangle904" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '120px' }} />
                                    <div className="Rectangle906" style={{ width: 2, height: 68, background: '#B85800', position: 'absolute', left: '135px' }} />

                                    <div id='Height' style={{ width: '100px', position: 'absolute', top: '10px', right: '-120px' }}>
                                        <M_InputTextField
                                            type={'number'}
                                            label={'Height (CM)'}
                                            value={newContainerMap.get('Height') || ''}
                                            onChange={(e) => updateContainer('Height', e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="divTextfields">
                            <div className="individualTextfield">
                                <M_InputTextField
                                    type={'number'}
                                    required={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Width') === '' || newContainerMap.get('Width') === undefined) ? true : false}
                                    disabled={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? true : false}
                                    color={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Width') === '' || newContainerMap.get('Width') === undefined) ? 'red' : ''}
                                    secondColor={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Width') === '' || newContainerMap.get('Width') === undefined) ? 'red' : ''}
                                    label={'Width (CM)'}
                                    value={newContainerMap.get('Width') || ''}
                                    onChange={(e) => { updateContainer('Width', e.target.value) }}
                                />
                            </div>
                            <div className="individualTextfield">
                                <M_InputTextField
                                    type={'number'}
                                    required={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Height') === '' || newContainerMap.get('Height') === undefined) ? true : false}
                                    disabled={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? true : false}
                                    color={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Height') === '' || newContainerMap.get('Height') === undefined) ? 'red' : ''}
                                    secondColor={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Height') === '' || newContainerMap.get('Height') === undefined) ? 'red' : ''}
                                    label={'Height (CM)'}
                                    value={newContainerMap.get('Height') || ''}
                                    onChange={(e) => { updateContainer('Height', e.target.value) }}
                                />
                            </div>
                            <div className="individualTextfield">
                                <M_InputTextField
                                    type={'number'}
                                    required={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Length') === '' || newContainerMap.get('Length') === undefined) ? true : false}
                                    disabled={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? true : false}
                                    color={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Length') === '' || newContainerMap.get('Length') === undefined) ? 'red' : ''}
                                    secondColor={(newContainerMap.get('EquipmentTypeCode')?.search('OT') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('FL') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Length') === '' || newContainerMap.get('Length') === undefined) ? 'red' : ''}
                                    label={'Length (CM)'}
                                    value={newContainerMap.get('Length') || ''}
                                    onChange={(e) => { updateContainer('Length', e.target.value) }}
                                />
                            </div>
                        </div>
                    }
                </fieldset>
                <fieldset id='RORO' style={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? { borderColor: 'grey' } : {}}>
                    <legend style={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? { color: 'grey' } : {}}>Vehicle</legend>
                    <div className="divTextfields">
                        <div className="individualTextfield">
                            <M_InputTextField
                                disabled={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? true : false}
                                color={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('Brand') === '' || newContainerMap.get('Brand') === undefined) && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1 ? 'red' : ''}
                                secondColor={((newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined) ? 'grey' : (newContainerMap.get('Brand') === '' || newContainerMap.get('Brand') === undefined) && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1 ? 'red' : ''}
                                required={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Brand') === '' || newContainerMap.get('Brand') === undefined) ? true : false}
                                label={'Brand'}
                                value={newContainerMap.get('Brand') || ''}
                                onChange={(e) => { updateContainer('Brand', e.target.value) }}
                            />
                        </div>
                        <div className="individualTextfield">
                            <M_InputTextField
                                disabled={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? true : false}
                                color={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('Model') === '' || newContainerMap.get('Model') === undefined) && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1 ? 'red' : ''}
                                secondColor={((newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined) ? 'grey' : (newContainerMap.get('Model') === '' || newContainerMap.get('Model')) && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1 === undefined ? 'red' : ''}
                                required={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Model') === '' || newContainerMap.get('Model') === undefined) ? true : false}
                                label={'Model'}
                                value={newContainerMap.get('Model') || ''}
                                onChange={(e) => { updateContainer('Model', e.target.value) }}
                            />
                        </div>
                        <div className="individualTextfield">
                            <M_InputTextField
                                disabled={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? true : false}
                                color={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined ? 'grey' : (newContainerMap.get('Chassis') === '' || newContainerMap.get('Chassis') === undefined) && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1 ? 'red' : ''}
                                secondColor={((newContainerMap.get('EquipmentTypeCode')?.search('RORO') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('BULK') === -1 && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1) || newContainerMap.get('EquipmentTypeCode') === undefined) ? 'grey' : (newContainerMap.get('Chassis') === '' || newContainerMap.get('Chassis') === undefined) && newContainerMap.get('EquipmentTypeCode')?.search('GENERAL') === -1 ? 'red' : ''}
                                required={(newContainerMap.get('EquipmentTypeCode')?.search('RORO') !== -1 || newContainerMap.get('EquipmentTypeCode')?.search('BULK') !== -1) && (newContainerMap.get('Chassis') === '' || newContainerMap.get('Chassis') === undefined) ? true : false}
                                label={'Chassis'}
                                value={newContainerMap.get('Chassis') || ''}
                                onChange={(e) => { updateContainer('Chassis', e.target.value) }}
                            />
                        </div>
                    </div>
                </fieldset>
                <div className='divButtonSubmitForApproval'
                    style={{ justifyContent: 'right' }}
                >
                    <M_Button
                        label={'Cancel'}
                        backgroundColor={'var(--color-red)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => cancelContainer()}
                    />
                    <M_Button
                        label={'Add Equipment'}
                        backgroundColor={'var(--color-green)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => createContainer()}
                    />
                </div>
            </>
        )
    }

    const functionLeavingPage = () => {
        ctx2.closeTab(JSON.parse(id))
    }

    // Clauses functions
    const openClausesPopup = () => {
        // Tentar obter o ID do BL de vÃ¡rias fontes
        const blId = varNameDict.get('id') || lineId

        if (!blId) {
            ctx.toastMessages('error', '', `${t("ErrorIdentifyingBL")}`)
            return
        }

        setOpenClauses(true)
        setLoadingClauses(true)

        // Buscar clauses do BL usando o endpoint especÃ­fico
        ClausesService.getId(`by-bl/${blId}`).then(res => {
            if (Array.isArray(res)) {
                setClausesData(res)
                if (res.length === 0) {
                    ctx.toastMessages('info', '', `${t("NoRulesForBL")}`)
                }
            } else {
                setClausesData([])
            }
            setLoadingClauses(false)
        }).catch(err => {
            console.error('Error fetching clauses:', err)
            ctx.toastMessages('error', '', `${t("ErrorClausesBL")}`)
            setClausesData([])
            setLoadingClauses(false)
        })
    }

    const closeClausesPopup = () => {
        setOpenClauses(false)
        setClausesData([])
        setExpandedRows([])
        setClauseDetails({})
        setLoadingDetails({})
    }

    const onRowExpand = async (event) => {
        const clauseId = event.data.Id

        // Se jÃ¡ carregou os detalhes, nÃ£o carregar novamente
        if (clauseDetails[clauseId]) {
            return
        }

        setLoadingDetails(prev => ({ ...prev, [clauseId]: true }))

        try {
            const clause = event.data

            if (clause?.ClauseName) {
                const filter = `ClauseName eq '${clause.ClauseName.replace(/'/g, "''")}' and ClauseCode eq '${clause.ClauseCode.replace(/'/g, "''")}'`;
                const transportClauseResult = await TransportClauseService.filter(`?filter=${filter}`)
                if (transportClauseResult?.Items && transportClauseResult.Items.length > 0) {
                    const transportClauseId = transportClauseResult.Items[0].Id
                    const url = `/by-transport-clause/${transportClauseId}`
                    const details = await ClauseDetailsService.filter(url)
                    let detailsArray = []
                    if (Array.isArray(details)) {
                        detailsArray = details
                    } else if (details?.Items) {
                        detailsArray = details.Items
                    } else if (typeof details === 'object' && details !== null) {
                        detailsArray = Object.values(details)
                    }

                    setClauseDetails(prev => ({
                        ...prev,
                        [clauseId]: detailsArray
                    }))
                } else {
                    setClauseDetails(prev => ({ ...prev, [clauseId]: [] }))
                }
            } else {
                setClauseDetails(prev => ({ ...prev, [clauseId]: [] }))
            }
        } catch (err) {
            console.error('Error fetching clause details:', err)
            ctx.toastMessages('error', '', `${t("ErrorLoadingClauseDetails")}`)
            setClauseDetails(prev => ({ ...prev, [clauseId]: [] }))
        } finally {
            setLoadingDetails(prev => ({ ...prev, [clauseId]: false }))
        }
    }

    const handleRegenerateClauses = () => {
        // Tentar obter o ID do BL de vÃ¡rias fontes
        const blId = varNameDict.get('id') || lineId

        if (!blId) {
            ctx.toastMessages('error', '', `${t("ErrorIdentifyingBL")}`)
            return
        }

        setOpenConfirmRegenerate(true)
    }

    const confirmRegenerateClauses = async () => {
        const blId = varNameDict.get('id') || lineId

        setOpenConfirmRegenerate(false)
        ctx.setIsLoad(true)

        try {
            const url = RegenerateClausesService.url + RegenerateClausesService.entityName + `/regenerate/${blId}`
            const response = await axios.post(url)

            if (response?.data?.success) {
                const message = response.data.message ||
                    `${t("ClausesRegeneratedSuccess", { count: response.data.clausesCount || 0 })}`
                ctx.toastMessages('success', '', message)

                // Recarregar as clauses apÃ³s regenerar
                const refreshedClauses = await ClausesService.getId(`by-bl/${blId}`)
                if (Array.isArray(refreshedClauses)) {
                    setClausesData(refreshedClauses)
                    setExpandedRows({})
                    setClauseDetails({})
                }
            } else {
                ctx.toastMessages('error', '', response?.data?.message || `${t("ErrorRegeneratingClauses")}`)
            }
        } catch (err) {
            console.error('Error regenerating clauses:', err)
            const errorMessage = err?.response?.data?.message || err?.message || `${t("ErrorRegeneratingClauses")}`
            ctx.toastMessages('error', '', errorMessage)
        } finally {
            ctx.setIsLoad(false)
        }
    }


    return (
        <>
            {isLoaded ? (<LoadingBar />) : (
                <>
                    <M_Header
                        element={
                            <>
                                <M_Button
                                    tooltip={t("Back")}
                                    label={t("Back")}
                                    icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                                    onClick={() => { setLeavingPage(true) }}
                                />
                                {(operation === 'Edit' || operation === 'View') && (
                                    <M_Button
                                        tooltip={t("Clauses")}
                                        label={t("Clauses")}
                                        icon={<i className="pi pi-file-edit iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                        onClick={openClausesPopup}
                                    />
                                )}

                                {(operation === 'Edit') && errors.ErrorMessage ? (
                                    <M_Button
                                        tooltip={t("SeeErrors")}
                                        label={t("SeeErrors")}
                                        icon={<i className="pi pi-info iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                        onClick={() => setOpenModalSeeErrors(true)}
                                    />
                                ) : null}
                                {operation === 'Create' || operation === 'Edit' ?
                                    <M_Button
                                        tooltip={t("LabelSubmitForApproval")}
                                        icon={<img src='/icons/svgsDaNet/save.svg' style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '20px' }} alt='Submit for approval' />}
                                        label={t("LabelSubmitForApproval")}
                                        onClick={handleClickOpen}
                                    />
                                    : operation === 'Approve' && dataBLs?.ProcessStatus === "Waiting for Approval (Cancel)" ?
                                        <M_Button
                                            icon={<img src='/icons/svgsDaNet/x-circle.svg' style={{ filter: 'invert(8%) sepia(94%) saturate(6897%) hue-rotate(3deg) brightness(108%) contrast(110%)', width: '20px' }} className='iconCreateBooking' alt='SaveAsDraft' />}
                                            tooltip={t("ApproveDeletion")}
                                            label={t("ApproveDeletion")}
                                            onClick={() => setModalConfirmDeletion(true)}
                                        />
                                        :
                                        <>
                                            <M_Button
                                                icon={<img src='/icons/svgsDaNet/x-circle.svg' style={{ filter: 'invert(8%) sepia(94%) saturate(6897%) hue-rotate(3deg) brightness(108%) contrast(110%)', width: '20px' }} className='iconCreateBooking' alt='SaveAsDraft' />}
                                                tooltip={t("LabelRejectBL")}
                                                label={t("LabelRejectBL")}
                                                onClick={() => submitForApproval()}
                                            />
                                            <M_Button
                                                icon={<img src='/icons/svgsDaNet/check-circle.svg' style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '20px' }} className='iconCreateBooking' alt='Submit for approval' />}
                                                tooltip={t("LabelAcceptedBL")}
                                                label={t("LabelAcceptedBL")}
                                                onClick={acceptBL}
                                            />

                                            {listErrors.ErrorMessage ? (
                                                <M_Button
                                                    tooltip={t("SeeErrors")}
                                                    label={t("SeeErrors")}
                                                    icon={<i className="pi pi-info iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-blue)' }}></i>}
                                                    onClick={() => setOpenModalSeeErrors(true)}
                                                />
                                            ) : null}
                                        </>}
                            </>
                        }
                    />
                    <div className='principalDivTimeline'
                        onMouseEnter={() => setAnchor(null)}
                    >
                        <div className='divTimeline'>
                            <M_TimeLine valueTimeline={valueTimeline} color={'var(--color-blue)'} />
                        </div>
                    </div>
                    <div className='containerBL'>
                        <Splitter style={{ width: '100vw', background: 'transparent', border: '0px solid' }} onResizeEnd={(e) => {
                            setAnchor(null)
                            setSeparator(e.sizes)
                        }}>
                            <SplitterPanel size={separator[0]}>
                                <div className='formBL'>
                                    <div className='divCards'
                                        onMouseEnter={() => setAnchor(null)}
                                    >
                                        <M_TabsInpage
                                            type={"buttons"}
                                            firstTabOpen={
                                                formEntities ? 1
                                                : formCustomOffice ? 2
                                                : formShipmentDetails ? 3
                                                : formPorts ? 4
                                                : formAdditionalFields ? 5
                                                : 1
                                            }
                                            renderTabs={cards.map(obj => {

                                                return {
                                                    iconTab: obj.icon,
                                                    labelTab: obj.name,
                                                    id: obj.id,
                                                    color: changesTabs?.includes(obj.code) ? 'var(--color-yellow)' : ''
                                                }
                                            })}
                                            onGetTab={(e) => {
                                                showForm(e.id)
                                            }}
                                        />
                                    </div>
                                    {operation === 'Create' || operation === 'Edit' ?
                                        <div className='divButtonSubmitForApproval'
                                            style={{ justifyContent: 'space-between', margin: '5px' }}
                                            onMouseEnter={() => setAnchor(null)}
                                        >
                                            <div style={{ width: '33%', display: 'flex', alignItems: 'center' }}>

                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '33%' }}>
                                                <h4 style={{ margin: '0' }}>Booking Number: &nbsp; </h4> <h2 style={{ margin: '0' }}> {varNameDict.get('freightBookingNumber')}</h2>
                                            </div>
                                            <div style={{ width: '33%', display: 'flex', justifyContent: 'end' }}>
                                            </div>
                                        </div>
                                        :
                                        <div className='divButtonSubmitForApproval' style={{ justifyContent: 'space-between', margin: '5px' }}>
                                            <div style={{ width: '33%', display: 'flex', alignItems: 'center' }} >

                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '33%' }}>
                                                <h4 style={{ margin: '0' }}>Booking Number: &nbsp;  </h4> <h2 style={{ margin: '0' }}>{varNameDict.get('freightBookingNumber')} </h2>
                                            </div>
                                            <div style={{ width: '33%', display: 'flex', justifyContent: 'end' }}>
                                            </div>
                                        </div>}
                                    {formPorts &&
                                        <M_Fieldset
                                            labelInside
                                            label={t("Ports")}
                                            elements={
                                                <div className='divFormsBl' style={{ minWidth: '712px' }}>
                                                    <div className='displayGridBl'>
                                                        {portsLocations.map((value, index) => (
                                                            value.type === "textfield" ?
                                                                (<div className="textfieldBl" style={{ display: 'flex' }} key={index} >
                                                                    {operation === 'Approve' && <M_CheckBox
                                                                        icon={<LensOutlinedIcon />}
                                                                        checkedIcon={<CancelIcon />}
                                                                        checked={rejectFields.has(value.code)}
                                                                        onChange={(e) => addRejectFields(e, value.label, value.code, varNameDict)}
                                                                        disabled={true}
                                                                    />}
                                                                    <M_DrawerTableTextField
                                                                        label={value.label}
                                                                        value={varNameDict.get(value.id) ?
                                                                            {
                                                                                Id: varNameDict.get(value.id),
                                                                                LocationName: varNameDict.get(value.code)
                                                                            } : null
                                                                        }
                                                                        entity={'location'}
                                                                        filterField={'LocationName'}
                                                                        labelFields={['LocationName']}
                                                                        onSubmitValue={(obj) => {
                                                                            if (obj) {
                                                                                inputChanged(value.code, obj['LocationName'])
                                                                                inputChanged(value.id, obj.Id)
                                                                            } else {
                                                                                inputChanged(value.code, '')
                                                                                inputChanged(value.id, '')
                                                                            }
                                                                        }}
                                                                        tableLabel={'Locations'}
                                                                        required={value.name === 'LocationLoadingPortName' || value.name === 'LocationDischargePortName' ? true : false}
                                                                        FILTER={'LocationPortStatus eq true'}
                                                                        color={(value.name === 'LocationLoadingPortName' && !varNameDict.get(value.code)) || (value.name === 'LocationDischargePortName' && !varNameDict.get(value.code)) ? 'var(--color-red)' : varNameDict.get('shipmentChanged')?.includes(value.id) ? 'var(--color-yellow)' : undefined}
                                                                        secondColor={(value.name === 'LocationLoadingPortName' && !varNameDict.get(value.code)) || (value.name === 'LocationDischargePortName' && !varNameDict.get(value.code)) ? 'var(--color-red)' : varNameDict.get('shipmentChanged')?.includes(value.id) ? 'var(--color-yellow)' : undefined}
                                                                        disabledInput={true}
                                                                        disabled={true}
                                                                    />
                                                                </div>)
                                                                : value.type === "checkbox" ?
                                                                    <div className='checkbox textfield paddingLeft' key={index}>
                                                                        {value.label === "Transhipment" ?
                                                                            <>
                                                                                <M_CheckBox
                                                                                    checked={varNameDict.get(value.code) === undefined || varNameDict.get(value.code) === null ? false : varNameDict.get(value.code)}
                                                                                    label={value.label}
                                                                                    color={varNameDict.get('shipmentChanged')?.includes(value.code) ? 'var(--color-yellow)' : undefined}
                                                                                    disabled={true}
                                                                                />
                                                                            </>
                                                                            : <M_CheckBox />
                                                                        }
                                                                    </div>
                                                                    :
                                                                    ""
                                                        ))}
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', fontWeight: '500', marginLeft: '10px' }} >
                                                        <img src="/icons/svgsDaNet/alert-triangle.svg" alt="Alert" style={{ marginRight: '5px', width: '25px' }} />
                                                        {t("OnlyChangePortsOnBooking")}
                                                    </div>
                                                </div>
                                            } />}
                                    {formEntities ?
                                        operation !== 'Approve' ? (
                                            <M_FormFavorites
                                                entityName="BLs"
                                                pageUrl="CreateBL"
                                                varNameDict={varNameDict}
                                                setVarNameDict={setVarNameDict}
                                                onAfterApply={() => htmlRefresh()}
                                            >
                                                <div style={{ minWidth: '712px' }}>
                                                    {entityLabels.map((entity, index) => (
                                                        <div style={{ marginBottom: '20px', position: 'relative' }} key={index}>

                                                            <M_Fieldset
                                                                labelInside
                                                                label={entity.label}
                                                                headerElement={
                                                                    <div className='divEntityMiddleButton' style={{ marginRight: '10px' }}>
                                                                        <div>
                                                                            <M_DrawerTableTextField
                                                                                size={'250px'}
                                                                                tableLabel={entity.label}
                                                                                label={`${entity.label} Account`}
                                                                                value={
                                                                                    varNameDict.get(`${entity.label.toLowerCase()}Id`) ?
                                                                                        {
                                                                                            Id: varNameDict.get(`${entity.label.toLowerCase()}Id`),
                                                                                            AccountCode: varNameDict.get(`${entity.label.toLowerCase()}Code`),
                                                                                            AccountName: varNameDict.get(`${entity.label.toLowerCase()}Name`),
                                                                                            AccountVATNumber: varNameDict.get(`${entity.label.toLowerCase()}MainVat`),
                                                                                            CountryName: varNameDict.get(`${entity.label.toLowerCase()}Country`),
                                                                                        }
                                                                                        : null}
                                                                                entity={'account'}
                                                                                filterField={'AccountCode'}
                                                                                labelFields={['AccountCode', 'AccountVATNumber']}
                                                                                onSubmitValue={(obj) => {
                                                                                    if (obj) {
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Id`, obj.Id)
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Code`, obj['AccountCode'].toLocaleUpperCase().slice(0, entitySize).trim())
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Name`, obj[`AccountName`]?.toLocaleUpperCase().slice(0, entitySize).trim())
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}MainVat`, obj[`AccountVATNumber`].slice(0, entitySize).trim())
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Vat`, obj[`AccountVATNumber`].slice(0, entitySize).trim())
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Country`, obj[`CountryName`]?.toLocaleUpperCase().slice(0, entitySize).trim())
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Address`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Address2`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}ZipCode`, '')
                                                                                        getAddress(entity.label.toLowerCase(), obj[`Id`])
                                                                                        setVarNameDict(new Map(varNameDict))
                                                                                        htmlRefresh()
                                                                                    } else {
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Id`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Code`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Name`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}MainVat`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Vat`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Country`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Address`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}Address2`, '')
                                                                                        varNameDict.set(`${entity.label.toLowerCase()}ZipCode`, '')
                                                                                        setVarNameDict(new Map(varNameDict))
                                                                                        htmlRefresh()
                                                                                    }
                                                                                }}
                                                                                required={true}
                                                                                color={!varNameDict.get(`${entity.label.toLowerCase()}Code`) ? 'var(--color-red)' : varNameDict.get('shipmentChanged')?.includes(`${entity.label.toLowerCase()}Id`) ? 'var(--color-yellow)' : undefined}
                                                                                secondColor={!varNameDict.get(`${entity.label.toLowerCase()}Code`) ? 'var(--color-red)' : varNameDict.get('shipmentChanged')?.includes(`${entity.label.toLowerCase()}Id`) ? 'var(--color-yellow)' : undefined}
                                                                                favoritesFieldName={entity.label}
                                                                                favoritesGroupName={entity.label}
                                                                                favoritesIdKey={`${entity.label.toLowerCase()}Id`}
                                                                                favoritesVarKey={`${entity.label.toLowerCase()}Code`}
                                                                                favoritesDisplayKey={`${entity.label.toLowerCase()}Code`}
                                                                            />
                                                                        </div>
                                                                        <div style={{}}>
                                                                            <M_Button
                                                                                height={2}
                                                                                width={5}
                                                                                backgroundColor={'var(--color-blue)'}
                                                                                icon={<Search style={{ color: 'var(--color-white)' }} />}
                                                                                isSimple={true}
                                                                                entity={'AccountOffice'}
                                                                                passIsTable={true}
                                                                                tableLabel={'Offices'}
                                                                                onGetline={(e) => getEntityValues(e, entity.label)}
                                                                                errorMessage={t('noAccount')}
                                                                                disable={() => { return !varNameDict.get(`${entity.label.toLowerCase()}Id`) }}
                                                                                toastMessages={toastMessages}
                                                                                FILTER={`AccountId eq ${varNameDict.get(`${entity.label.toLowerCase()}Id`)}`}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                                elements={
                                                                    <>
                                                                        <div className='divEntityMiddleButton' >
                                                                            <div></div>

                                                                        </div>
                                                                        <div className='displayGridBl'>
                                                                            {entity.fields.map((name, i) => {
                                                                                const tempName = entity.label.toLowerCase().concat(name)
                                                                                return (
                                                                                    <div key={i} className="textfieldBl" style={{ display: 'flex' }}>
                                                                                        {operation === 'Approve' && <M_CheckBox
                                                                                            icon={<LensOutlinedIcon />}
                                                                                            checkedIcon={<CancelIcon />}
                                                                                            checked={rejectFields.has(tempName)}
                                                                                            onChange={(e) => addRejectFields(e, tempName, tempName, varNameDict)}
                                                                                        />}
                                                                                        <M_InputTextField
                                                                                            maxNumbers={100}
                                                                                            label={name}
                                                                                            value={varNameDict.get(tempName) || ''}
                                                                                            onChange={(e) => {
                                                                                                const raw = e.target.value;

                                                                                                // Remove acentos e cedilhas
                                                                                                let cleaned = raw
                                                                                                    .normalize("NFD")
                                                                                                    .replace(/[\u0300-\u036f]/g, "") // remove diacrÃ­ticos
                                                                                                    .replace(/Ã§/gi, "c"); // substitui Ã§

                                                                                                // Remove sÃ­mbolos que nÃ£o queres permitir de forma explÃ­cita
                                                                                                cleaned = cleaned.replace(/[~`Â´^\\\/]/g, ""); // remove ~, `, Â´, ^, \, /

                                                                                                inputChanged(tempName, cleaned);
                                                                                            }}
                                                                                            color={varNameDict.get('shipmentChanged')?.includes(tempName) ? 'var(--color-yellow)' : undefined}
                                                                                            secondColor={varNameDict.get('shipmentChanged')?.includes(tempName) ? 'var(--color-yellow)' : undefined}
                                                                                        />



                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                } />
                                                        </div>
                                                    ))}
                                                </div>
                                            </M_FormFavorites>
                                        ) : (
                                            <M_FormFavorites
                                                entityName="BLs"
                                                pageUrl="CreateBL"
                                                varNameDict={varNameDict}
                                                setVarNameDict={setVarNameDict}
                                                onAfterApply={() => htmlRefresh()}
                                            >
                                            <div style={{ minWidth: '712px' }}>
                                                {entityLabels.map((entity, index) => (
                                                    <div style={{ marginBottom: '20px', }} key={index}>
                                                        <M_Fieldset
                                                            labelInside
                                                            label={entity.label}
                                                            headerElement={
                                                                <div className='divEntityMiddleButton' style={{ marginRight: '10px' }}>
                                                                    <div>
                                                                        <M_DrawerTableTextField
                                                                            size={'250px'}
                                                                            tableLabel={entity.label}
                                                                            label={`${entity.label} Account`}
                                                                            value={
                                                                                varNameDict.get(`${entity.label.toLowerCase()}Id`) ?
                                                                                    {
                                                                                        Id: varNameDict.get(`${entity.label.toLowerCase()}Id`),
                                                                                        AccountCode: varNameDict.get(`${entity.label.toLowerCase()}Code`),
                                                                                        AccountName: varNameDict.get(`${entity.label.toLowerCase()}Name`),
                                                                                        AccountVATNumber: varNameDict.get(`${entity.label.toLowerCase()}MainVat`),
                                                                                        CountryName: varNameDict.get(`${entity.label.toLowerCase()}Country`),
                                                                                    }
                                                                                    : null}
                                                                            entity={'account'}
                                                                            filterField={'AccountCode'}
                                                                            labelFields={['AccountCode', 'AccountVATNumber']}
                                                                            onSubmitValue={(obj) => {
                                                                                if (obj) {
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Id`, obj.Id)
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Code`, obj['AccountCode'].toLocaleUpperCase().slice(0, entitySize).trim())
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Name`, obj[`AccountName`]?.toLocaleUpperCase().slice(0, entitySize).trim())
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}MainVat`, obj[`AccountVATNumber`].slice(0, entitySize).trim())
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Vat`, obj[`AccountVATNumber`].slice(0, entitySize).trim())
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Country`, obj[`CountryName`]?.toLocaleUpperCase().slice(0, entitySize).trim())
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Address`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Address2`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}ZipCode`, '')
                                                                                    getAddress(entity.label.toLowerCase(), obj[`Id`])
                                                                                    setVarNameDict(new Map(varNameDict))
                                                                                    htmlRefresh()
                                                                                } else {
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Id`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Code`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Name`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}MainVat`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Vat`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Country`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Address`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}Address2`, '')
                                                                                    varNameDict.set(`${entity.label.toLowerCase()}ZipCode`, '')
                                                                                    setVarNameDict(new Map(varNameDict))
                                                                                    htmlRefresh()
                                                                                }
                                                                            }}
                                                                            required={true}
                                                                            color={!varNameDict.get(`${entity.label.toLowerCase()}Code`) ? 'var(--color-red)' : varNameDict.get('shipmentChanged')?.includes(`${entity.label.toLowerCase()}Id`) ? 'var(--color-yellow)' : undefined}
                                                                            secondColor={!varNameDict.get(`${entity.label.toLowerCase()}Code`) ? 'var(--color-red)' : varNameDict.get('shipmentChanged')?.includes(`${entity.label.toLowerCase()}Id`) ? 'var(--color-yellow)' : undefined}
                                                                            favoritesFieldName={entity.label}
                                                                            favoritesGroupName={entity.label}
                                                                            favoritesIdKey={`${entity.label.toLowerCase()}Id`}
                                                                            favoritesVarKey={`${entity.label.toLowerCase()}Code`}
                                                                            favoritesDisplayKey={`${entity.label.toLowerCase()}Code`}
                                                                        />
                                                                    </div>
                                                                    <div style={{}}>
                                                                        <M_Button
                                                                            height={2}
                                                                            width={5}
                                                                            backgroundColor={'var(--color-blue)'}
                                                                            icon={<Search style={{ color: 'var(--color-white)' }} />}
                                                                            isSimple={true}
                                                                            entity={'AccountOffice'}
                                                                            passIsTable={true}
                                                                            tableLabel={'Offices'}
                                                                            onGetline={(e) => getEntityValues(e, entity.label)}
                                                                            errorMessage={t('noAccount')}
                                                                            disable={() => { return !varNameDict.get(`${entity.label.toLowerCase()}Id`) }}
                                                                            toastMessages={toastMessages}
                                                                            FILTER={`AccountId eq ${varNameDict.get(`${entity.label.toLowerCase()}Id`)}`}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }
                                                            elements={
                                                                <>
                                                                    <div className='divEntityMiddleButton' >
                                                                        <div></div>

                                                                    </div>
                                                                    <div className='displayGridBl'>
                                                                        {entity.fields.map((name, i) => {
                                                                            const tempName = entity.label.toLowerCase().concat(name)
                                                                            return (
                                                                                <div key={i} className="textfieldBl" style={{ display: 'flex' }}>
                                                                                    {operation === 'Approve' && <M_CheckBox
                                                                                        icon={<LensOutlinedIcon />}
                                                                                        checkedIcon={<CancelIcon />}
                                                                                        checked={rejectFields.has(tempName)}
                                                                                        onChange={(e) => addRejectFields(e, tempName, tempName, varNameDict)}
                                                                                    />}
                                                                                    <M_InputTextField
                                                                                        maxNumbers={100}
                                                                                        label={name}
                                                                                        value={varNameDict.get(tempName) || ''}
                                                                                        onChange={(e) => {
                                                                                            const raw = e.target.value;

                                                                                            // Remove acentos e cedilhas
                                                                                            let cleaned = raw
                                                                                                .normalize("NFD")
                                                                                                .replace(/[\u0300-\u036f]/g, "") // remove diacrÃ­ticos
                                                                                                .replace(/Ã§/gi, "c"); // substitui Ã§

                                                                                            // Remove sÃ­mbolos que nÃ£o queres permitir de forma explÃ­cita
                                                                                            cleaned = cleaned.replace(/[~`Â´^\\\/]/g, ""); // remove ~, `, Â´, ^, \, /

                                                                                            inputChanged(tempName, cleaned);
                                                                                        }}
                                                                                        color={varNameDict.get('shipmentChanged')?.includes(tempName) ? 'var(--color-yellow)' : undefined}
                                                                                        secondColor={varNameDict.get('shipmentChanged')?.includes(tempName) ? 'var(--color-yellow)' : undefined}
                                                                                    />



                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                </>
                                                            } />
                                                    </div>
                                                ))}
                                            </div>
                                            </M_FormFavorites>
                                        )
                                        : null
                                    }
                                    {formCustomOffice ?
                                        <M_FormFavorites
                                            entityName="BLs"
                                            pageUrl="CreateBL"
                                            varNameDict={customOfficeDict}
                                            setVarNameDict={setCustomOfficeDict}
                                        >
                                        <div style={{ position: 'relative' }}>
                                            <M_Fieldset
                                                label={"Customs Office"}
                                                labelInside
                                                elements={
                                                    <div className='divFormsBl' style={{ minWidth: '712px' }}>
                                                        <div className='displayGridBl'>
                                                            {customOffice.map((key, index) => (
                                                                key === 'Date' ?
                                                                    <div key={index} className="textfieldBl">
                                                                        <M_InputTextField
                                                                            value={customOfficeDict.get(key)}
                                                                            type='date'
                                                                            label={key}
                                                                            onChange={(e) => addCustomOffice(key, e.target.value)}
                                                                            disabled={true}
                                                                        />
                                                                    </div> :
                                                                    key === 'Document Type' ?
                                                                        <div className='textfieldBl' key={index} >
                                                                            <M_DrawerTableTextField
                                                                                tableLabel={key}
                                                                                label={key}
                                                                                required={true}
                                                                                value={
                                                                                    customOfficeDict.get('idDocumentType') ?
                                                                                        {
                                                                                            Id: customOfficeDict.get('idDocumentType'),
                                                                                            PCOMCustomsDocumentTypeDesc: customOfficeDict.get('Document Type'),
                                                                                        } :
                                                                                        null
                                                                                }
                                                                                entity={'CustomsDocumentType'}
                                                                                filterField={'PCOMCustomsDocumentTypeDesc'}
                                                                                labelFields={['PCOMCustomsDocumentTypeDesc']}
                                                                                onSubmitValue={(obj) => {
                                                                                    if (obj) {
                                                                                        addCustomOffice('idDocumentType', obj.Id)
                                                                                        addCustomOffice(key, obj['PCOMCustomsDocumentTypeDesc'])
                                                                                    } else {
                                                                                        addCustomOffice('idDocumentType', '')
                                                                                        addCustomOffice(key, '')
                                                                                    }
                                                                                }}
                                                                                favoritesFieldName="Document Type"
                                                                                favoritesGroupName="Customs Office"
                                                                                favoritesIdKey="idDocumentType"
                                                                                favoritesVarKey="Document Type"
                                                                            />
                                                                        </div> :
                                                                        key === 'Despatch number' ?
                                                                            <div key={index} className="textfieldBl">
                                                                                <M_InputTextField
                                                                                    label={key}
                                                                                    required={true}
                                                                                    value={customOfficeDict.get(key)}
                                                                                    blockSpecialChars={true}
                                                                                    onChange={(e) => addCustomOffice(key, e.target.value)}
                                                                                    maxNumbers={18}
                                                                                />
                                                                            </div>
                                                                            :
                                                                            <div key={index} className="textfieldBl">
                                                                                <M_InputTextField
                                                                                    label={key}
                                                                                    required={true}
                                                                                    value={customOfficeDict.get(key)}
                                                                                    onChange={(e) => addCustomOffice(key, e.target.value)}
                                                                                    disabled={true}
                                                                                />
                                                                            </div>
                                                            ))}
                                                        </div>
                                                        <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', padding: '5px', marginBottom: '20px' }}>
                                                            <M_Button
                                                                normal
                                                                label={t("LabelAddCustomsOffice")}
                                                                backgroundColor={'var(--color-green)'}
                                                                labelColor={'var(--color-white)'}
                                                                onClick={() => inputCustomOffice()}
                                                            />
                                                        </div>
                                                        <div>
                                                            <TableCustomsOffice isApprove={operation === 'Approve' && true} dictCustomOfficeDict={dictCustomOfficeDict} setDictCustomOFficeDict={setDictCustomOFficeDict} customsRows={customsRows} setCustomsRows={setCustomsRows} />
                                                        </div>
                                                    </div>
                                                }
                                            />
                                        </div>
                                        </M_FormFavorites>
                                        : null
                                    }
                                    {formShipmentDetails ?
                                        <M_Fieldset
                                            labelInside
                                            elements={
                                                <div>

                                                    <ContextMenu model={tempContexMenu} ref={cm} onHide={() => {
                                                        setSelectedLine(null)
                                                    }} />
                                                    {containerTypes.map((container, index) => (
                                                        <DataTable
                                                            key={index}
                                                            tabIndex={index}
                                                            header={() => header(container)}
                                                            size="small"
                                                            value={organizedData.get(container)}
                                                            rowGroupMode="rowspan"
                                                            groupRowsBy="shipment"
                                                            sortOrder={1}
                                                            sortField={"matricula"}
                                                            editMode="cell"

                                                            // showGridlines
                                                            contextMenuSelection={selectedLine}
                                                            selectionMode={operation === 'Approve' && "checkbox"}
                                                            selection={operation === 'Approve' && selectedRows}
                                                            onContextMenuSelectionChange={e => {
                                                                setSelectedLine(e.value)
                                                            }}
                                                            onSelectionChange={operation === 'Approve' && onSelectionChange}
                                                            onContextMenu={e => cm.current.show(e.originalEvent)}
                                                            breakpoint='0px'
                                                            className='BLTable'
                                                            onMouseOver={(e) => {
                                                                addLineButtonHover(e)
                                                            }}

                                                        // onMouseLeave={() => hideAddLineButton()}
                                                        >
                                                            {operation === 'Approve' && <Column
                                                                selectionMode="multiple"
                                                                className='approvSelectionColumn'
                                                                headerStyle={{
                                                                    borderBottom: `2px solid ${ctx.primaryColor}`,
                                                                    color: ctx.secondaryColor
                                                                }}  ></Column>}
                                                            <Column
                                                                className='shipmentName'
                                                                header='Shipment'
                                                                field='shipment'
                                                                body={subHeader}
                                                                headerStyle={{
                                                                    borderBottom: `2px solid ${ctx.primaryColor}`,
                                                                    color: ctx.secondaryColor
                                                                }}
                                                            />
                                                            {containerColumns}
                                                            <Column
                                                                onDragEnter={(e) => dragEnter(e)}
                                                                className='reOrder'
                                                                style={{ width: '30px', padding: '0px' }}
                                                                headerStyle={{
                                                                    borderBottom: `2px solid ${ctx.primaryColor}`,
                                                                    color: ctx.secondaryColor
                                                                }}
                                                                body={reorder}
                                                            />
                                                        </DataTable>
                                                    ))}
                                                </div>
                                            }
                                        />
                                        : null
                                    }
                                    {formAdditionalFields ?
                                    <M_Fieldset
                                        labelInside
                                        label={
                                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                                <i className="pi pi-list" style={{ marginRight: '10px' }} />
                                                {t('AdditionalFields') || 'Additional Fields'}
                                            </span>
                                        }
                                        elements={
                                            <div className='divFormsBl' style={{ minWidth: '712px', padding: '10px' }}>
                                                <ExtensionForm
                                                    ref={extensionFormRef}
                                                    extendedEntityId="BL"
                                                    extendedItemId={
                                                        (operation === 'Edit' || operation === 'Approve')
                                                            ? varNameDict.get('id')
                                                            : null
                                                    }
                                                    canEdit={operation !== 'Approve'}
                                                    handleErrorCallback={(error) => {
                                                        const msg = error?.response?.data?.message || error?.message
                                                        toastMessages('error', '', msg)
                                                    }}
                                                />
                                            </div>
                                        }
                                    />
                                    : null}
                                </div>
                            </SplitterPanel>
                            <SplitterPanel size={separator[1]}>
                                <M_Fieldset
                                    labelInside
                                    elements={
                                        <div className='renderContainer'>
                                            <div style={{ display: 'flex', zIndex: '1200', width: '100%', position: 'absolute', top: '0' }}>
                                                <M_Header
                                                    notsticky
                                                    element={
                                                        <>
                                                            <M_Button
                                                                label={t("Edit")}
                                                                tooltip={t("Edit")}
                                                                icon={showInput ? <LockOpenIcon color='info' /> : <LockIcon color='info' />}
                                                                onClick={() => {
                                                                    const tempBol = !showInput
                                                                    if (tempBol === false) {
                                                                        getValuesInput()
                                                                    }
                                                                    setShowInput(tempBol)
                                                                    htmlRefresh(tempBol)
                                                                }}
                                                            />
                                                            <M_Button
                                                                label={t("Refresh")}
                                                                tooltip={t("Refresh")}
                                                                icon={<Refresh color='info' />}
                                                                onClick={() => { htmlRefresh() }}
                                                            />
                                                            <M_Button
                                                                label={t("LabelZoomIn")}
                                                                tooltip={t("LabelZoomIn")}
                                                                icon={<ZoomInIcon color='info' />}
                                                                onClick={() => {
                                                                    if (zoom === 90) {
                                                                        return
                                                                    } else {
                                                                        setZoom(prev => prev + 10)
                                                                    }
                                                                }}
                                                            />
                                                            <M_Button
                                                                label={t("LabelZoomOut")}
                                                                tooltip={t("LabelZoomOut")}
                                                                icon={<ZoomOutIcon color='info' />}
                                                                onClick={() => {
                                                                    if (zoom === 20) {
                                                                        return
                                                                    }
                                                                    else {
                                                                        setZoom(prev => prev - 10)
                                                                    }
                                                                }}
                                                            />
                                                            {downloadablePDF && (
                                                                <M_Button
                                                                    label={t("LabelDownloadDraft")}
                                                                    tooltip={t("LabelDownloadDraft")}
                                                                    icon={<DownloadIcon color='info' />}
                                                                    onClick={() => { blHtmlDownload(1) }}
                                                                />
                                                            )}
                                                        </>
                                                    }
                                                />
                                            </div>


                                            <span className='render' style={{ transform: `scale(${zoom}%)` }}>
                                                <Draggable nodeRef={ref}>
                                                    {page === 1 ?
                                                        <div ref={ref} className='render' style={{ transform: `scale(${zoom}%)` }} dangerouslySetInnerHTML={{ __html: blHTML }}></div>
                                                        :
                                                        <div ref={ref} className='render' style={{ transform: `scale(${zoom}%)` }} dangerouslySetInnerHTML={{ __html: blSecondHTML }}></div>
                                                    }
                                                </Draggable>
                                            </span>
                                            <div style={{ position: 'absolute', bottom: '0', width: '100%' }}>
                                                <M_Header
                                                    element={
                                                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', borderTop: '1px solid var(--color-grey)' }}>
                                                            {
                                                                lines >= pageSize ?
                                                                    <>
                                                                        <M_Button
                                                                            none
                                                                            tooltip={t("LabelPreviousPage")}
                                                                            icon={<ArrowForwardIosSharpIcon sx={{ transform: 'rotate(180deg)' }} color='info' />}
                                                                            onClick={() => {
                                                                                const tempPage = page === 1 ? page : page - 1
                                                                                htmlRefresh(showInput, tempPage)
                                                                                setPage(tempPage)
                                                                            }}
                                                                        />

                                                                        <span style={{ color: 'var(--color-blue)', scale: '1.5', marginTop: '8px' }}>
                                                                            {page}
                                                                        </span>

                                                                        <M_Button
                                                                            none
                                                                            tooltip={t("LabelNextPage")}
                                                                            icon={<ArrowForwardIosSharpIcon color='info' />}
                                                                            onClick={() => {
                                                                                const tempPage = page === docSize ? page : page + 1
                                                                                htmlRefresh(showInput, tempPage)
                                                                                setPage(tempPage)
                                                                            }}
                                                                        />
                                                                    </>
                                                                    : ''
                                                            }
                                                        </div>
                                                    }
                                                />
                                            </div>
                                        </div>
                                    }
                                />


                                <M_MessageBoard
                                    open={open}
                                    onClose={handleClose}
                                    title={`${t("Print")} BL`}
                                    body={<>
                                        <div className='divPrincipalDialog'>
                                            <fieldset>
                                                <legend>{t("LabelOrigin")}</legend>
                                                <div className='divTextfieldDialog'>
                                                    {!hideOriginals ? <div className='textfieldDialog'>
                                                        <M_InputTextField
                                                            label={t("LabelOriginalNr")}
                                                            type={'number'}
                                                            onChange={(e) => setOriginOriginalNumbers(e.target.value)}
                                                            value={originOriginalNumber}
                                                        />
                                                    </div> : null}
                                                    <div className='textfieldDialog'>
                                                        <M_InputTextField
                                                            onChange={(e) => setOriginCopyNumbers(e.target.value)}
                                                            value={originCopyNumber}
                                                            type={'number'}
                                                            label={t("LabelCopyNr")}
                                                        />
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <fieldset>
                                                <legend>{t("LabelDestination")}</legend>
                                                <div className='divTextfieldDialog'>
                                                    {!hideOriginals ? <div className='textfieldDialog'>
                                                        <M_InputTextField
                                                            label={t("LabelOriginalNr")}
                                                            type={'number'}
                                                            value={destinationOriginalNumber}
                                                            onChange={(e) => setDestinationOriginalNumber(e.target.value)}
                                                        />
                                                    </div> : null}
                                                    <div className='textfieldDialog'>
                                                        <M_InputTextField
                                                            value={destinationCopyNumber}
                                                            onChange={(e) => setDestinationCopyNumber(e.target.value)}
                                                            type={'number'}
                                                            label={t("LabelCopyNr")}
                                                        />
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                        <div className='underTextfields'>
                                            <div className='divCheckbox'>
                                                <M_CheckBox
                                                    label={'Telex / Express Release'}
                                                    onChange={(e) => {
                                                        setHideOriginals(e.target.checked)
                                                        setDestinationOriginalNumber(0)
                                                        setOriginOriginalNumbers(0)
                                                    }}
                                                />
                                            </div>
                                            <div className='divTextFieldError'>
                                                {totalOfOriginals()}
                                            </div>
                                        </div>
                                    </>}
                                    footer={<>
                                        <M_Button
                                            label={t("ButtonCancel")}
                                            backgroundColor={'var(--color-red)'}
                                            labelColor={'var(--color-white)'}
                                            onClick={handleClose}
                                        />
                                        <M_Button
                                            label={t("ButtonConfirm")}
                                            backgroundColor={'var(--color-green)'}
                                            labelColor={'var(--color-white)'}
                                            onClick={() => submitBl()}
                                        />
                                    </>}
                                />

                                <Paper
                                    elevation={0}
                                    style={{
                                        display: Boolean(anchor) ? 'flex' : 'none',
                                        position: 'absolute',
                                        top: top - rowHeight,
                                        left: left,
                                        backgroundColor: 'transparent',
                                        height: '1px',
                                    }}
                                >
                                    <div
                                        style={{
                                            height: '1px',
                                            width: width,
                                            backgroundColor: 'var(--color-blue)',

                                        }}
                                    >
                                    </div>
                                    {anchor && <Tooltip title={t('addLine')}>
                                        <AddIcon style={{
                                            position: 'relative',
                                            bottom: '11px',
                                            'cursor': 'pointer',
                                            color: 'var(--color-blue)'

                                        }} onClick={() => {
                                            addLine(hoverLine, 'top')
                                            setAnchor(null)
                                        }} />
                                    </Tooltip>}
                                </Paper>
                                <Paper
                                    elevation={0}
                                    style={{
                                        display: Boolean(anchor) ? 'flex' : 'none',
                                        position: 'absolute',
                                        top: top,
                                        left: left,
                                        backgroundColor: 'transparent',
                                        height: '1px',
                                    }}
                                >
                                    <div
                                        style={{
                                            height: '1px',
                                            width: width,
                                            backgroundColor: 'var(--color-blue)',

                                        }}
                                    >
                                    </div>
                                    {anchor && <Tooltip title={t('addLine')}>
                                        <AddIcon style={{
                                            position: 'relative',
                                            bottom: '11px',
                                            'cursor': 'pointer',
                                            color: 'var(--color-blue)'

                                        }} onClick={() => {
                                            addLine(hoverLine, 'bottom')
                                            setAnchor(null)
                                        }} />
                                    </Tooltip>}
                                </Paper>
                                <Paper
                                    elevation={0}
                                    style={{
                                        display: Boolean(anchorShip) ? 'flex' : 'none',
                                        position: 'absolute',
                                        top: shipTop,
                                        left: -shipLeft,
                                        backgroundColor: 'transparent',
                                        height: '1px',
                                    }}
                                >
                                    {anchorShip && <Tooltip title={t('addShipment')}>
                                        <AddIcon style={{
                                            position: 'relative',
                                            bottom: '11px',
                                            left: '10px',
                                            'cursor': 'pointer',
                                            color: 'var(--color-blue)',
                                            // backgroundColor:'purple',

                                        }} onClick={() => {
                                            addShipment(hoverLine, 'bottom')
                                            setAnchorShip(null)
                                            setAnchor(null)
                                        }} />
                                    </Tooltip>}
                                    <div
                                        style={{
                                            height: '1px',
                                            marginLeft: '10px',
                                            width: shipWidth - 10,
                                            backgroundColor: 'var(--color-blue)',

                                        }}
                                    >
                                    </div>
                                </Paper>
                                <Paper
                                    elevation={0}
                                    style={{
                                        display: Boolean(anchorShip) ? 'flex' : 'none',
                                        position: 'absolute',
                                        top: shipTop - shipHeight - 1,
                                        left: -shipLeft,
                                        backgroundColor: 'transparent',
                                        height: '1px',
                                    }}
                                >
                                    {anchorShip && <Tooltip title={t('addShipment')}>
                                        <AddIcon style={{
                                            position: 'relative',
                                            bottom: '11px',
                                            left: '10px',
                                            'cursor': 'pointer',
                                            color: 'var(--color-blue)'

                                        }} onClick={() => {
                                            addShipment(hoverLine, 'top')
                                            setAnchorShip(null)
                                            setAnchor(null)
                                        }} />
                                    </Tooltip>}
                                    <div
                                        style={{
                                            height: '1px',
                                            marginLeft: '10px',
                                            width: shipWidth - 10,
                                            backgroundColor: 'var(--color-blue)',

                                        }}
                                    >
                                    </div>
                                </Paper>

                                {/* //* drag paper lines*/}
                                <Paper
                                    elevation={0}
                                    style={{
                                        display: Boolean(anchorDrag) ? 'flex' : 'none',
                                        flexDirection: 'column',
                                        position: 'absolute',
                                        top: topDrag,
                                        left: leftDrag,
                                        backgroundColor: 'transparent',
                                        height: '1px',
                                    }}
                                >
                                    <div
                                        //*CONTAINER TOP 
                                        style={{
                                            paddingTop: '5px',
                                            paddingBottom: '5px',
                                            position: 'absolute',
                                            top: - (rowHeight + 5),
                                        }}
                                        onDrop={e => {
                                            handleDrop(e)
                                            setHoverIndex(null)
                                            dragLines(hoverLine, anchorDrag, 'top', e.ctrlKey)
                                        }}
                                        onDragOver={e => {
                                            handleDragOver(e)
                                            setHoverIndex('top')
                                        }}
                                        onDragEnter={e => handleDragEnter(e)}
                                        onDragLeave={e => {
                                            handleDragLeave(e)
                                            setHoverIndex(null)
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: '2px',
                                                width: widthDrag,
                                                backgroundColor: hoverIndex === 'top' ? 'var(--color-blue)' : 'transparent',
                                            }}
                                        >
                                        </div>
                                    </div>
                                    <div
                                        //*CONTAINER BOTTOM
                                        style={{
                                            paddingTop: '5px',
                                            paddingBottom: '5px',
                                            position: 'absolute',
                                            top: '-5px',
                                        }}
                                        onDrop={e => {
                                            handleDrop(e)
                                            setHoverIndex(null)
                                            dragLines(hoverLine, anchorDrag, 'bot', e.ctrlKey)
                                        }}
                                        onDragOver={e => {
                                            handleDragOver(e)
                                            setHoverIndex('bot')
                                        }}
                                        onDragEnter={e => handleDragEnter(e)}
                                        onDragLeave={e => {
                                            handleDragLeave(e)
                                            setHoverIndex(null)
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: '2px',
                                                width: widthDrag,
                                                backgroundColor: hoverIndex === 'bot' ? 'var(--color-blue)' : 'transparent',
                                            }}
                                        >
                                        </div>
                                    </div>
                                </Paper>

                                {/* //* drag paper ship */}
                                <Paper
                                    elevation={0}
                                    style={{
                                        display: Boolean(anchorDragShip) ? 'flex' : 'none',
                                        flexDirection: 'column',
                                        position: 'absolute',
                                        top: shipTopDrag,
                                        left: shipLeftDrag,
                                        backgroundColor: 'transparent',
                                        height: '1px',
                                    }}
                                >
                                    <div
                                        //*CONTAINER TOP 
                                        style={{
                                            paddingTop: '5px',
                                            paddingBottom: '5px',
                                            position: 'absolute',
                                            top: - (shipHeightDrag + 5),
                                        }}
                                        onDrop={e => {
                                            handleDrop(e)
                                            setHoverIndex(null)

                                            dragShip(isDragShip, hoverLine, 'top', e.ctrlKey)
                                        }}
                                        onDragOver={e => {
                                            handleDragOver(e)
                                            setHoverIndex('top')
                                        }}
                                        onDragEnter={e => handleDragEnter(e)}
                                        onDragLeave={e => {
                                            handleDragLeave(e)
                                            setHoverIndex(null)
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: '2px',
                                                width: shipWidthDrag,
                                                backgroundColor: hoverIndex === 'top' ? 'var(--color-blue)' : 'transparent',
                                            }}
                                        >
                                        </div>
                                    </div>
                                    <div
                                        //*CONTAINER BOTTOM
                                        style={{
                                            paddingTop: '5px',
                                            paddingBottom: '5px',
                                            position: 'absolute',
                                            top: '-5px',
                                        }}
                                        onDrop={e => {
                                            handleDrop(e)
                                            setHoverIndex(null)
                                            dragShip(isDragShip, hoverLine, 'bot', e.ctrlKey)
                                        }}
                                        onDragOver={e => {
                                            handleDragOver(e)
                                            setHoverIndex('bot')
                                        }}
                                        onDragEnter={e => handleDragEnter(e)}
                                        onDragLeave={e => {
                                            handleDragLeave(e)
                                            setHoverIndex(null)
                                        }}
                                    >
                                        <div
                                            style={{
                                                height: '2px',
                                                width: shipWidthDrag,
                                                backgroundColor: hoverIndex === 'bot' ? 'var(--color-blue)' : 'transparent',
                                            }}
                                        >
                                        </div>
                                    </div>
                                </Paper>

                                <M_MessageBoard
                                    open={openConfirmModal}
                                    onClose={handleCloseConfirmModal}
                                    title={t("LabelRejectBL")}
                                    minWidth={"40%"}
                                    body={
                                        <>
                                            <span>
                                                {Object.keys(Object.fromEntries(rejectFields)).map((key, index) => {
                                                    return (
                                                        <div key={key}>
                                                            <M_InputTextField
                                                                key={index}
                                                                value={rejectFields.get(key).Notes || ''}
                                                                label={`${rejectFields.get(key).label}: ${rejectFields.get(key).value}`}
                                                                onChange={(e) => onReproveFields(key, e.target.value)}

                                                            />
                                                        </div>
                                                    )
                                                })}
                                                {customsRows.map((obj, index) => {
                                                    return (
                                                        <M_InputTextField
                                                            key={index}
                                                            value={obj.Notes || ''}
                                                            blockSpecialChars={true}
                                                            label={`Document Type: ${obj['Document Type']} | Despatch Number: ${obj['Despatch number']} | Customs Office: ${obj['Customs office']}`}
                                                            onChange={(e) => onReproveCustoms(obj, e.target.value)}
                                                        />
                                                    )
                                                })
                                                }
                                                {selectedRows.map((obj, index) => {
                                                    return (
                                                        <M_InputTextField
                                                            key={index}
                                                            value={obj.Notes || ''}
                                                            blockSpecialChars={true}
                                                            label={`Line id ${obj.id} | Shipment: ${obj.shipment} | ${obj.matricula} | Description: ${obj.description} | Weight: ${obj.grossWeight}`}
                                                            onChange={(e) => onReproveShipments(obj, e.target.value, selectedRows, setSelectedRows)}
                                                        />
                                                    )
                                                })}
                                            </span>
                                            <br />
                                            <M_TextArea
                                                label={t("Notes")}
                                                value={finalNotes}
                                                onChange={(e) => setFinalNotes(e.target.value)}
                                            />
                                        </>
                                    }
                                    footer={
                                        <M_Button
                                            label={t("ConfiRejecBook")}
                                            labelColor={'var(--color-white)'}
                                            backgroundColor={'var(--color-green)'}
                                            onClick={rejectBl}
                                        />
                                    }
                                />

                                <M_MessageBoard
                                    open={OpenModalSeeErrors}
                                    minWidth={'30%'}
                                    onClose={() => setOpenModalSeeErrors(false)}
                                    title={t("ListErrors")}
                                    body={
                                        <span>
                                            <b>{errors.CreatedOn}</b>: {errors.ErrorMessage}
                                        </span>
                                    }
                                    footer={
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setOpenModalSeeErrors(false)} label={t("ButtonCancel")} />
                                        </span>
                                    }
                                />

                                <M_MessageBoard
                                    open={confirmationModal}
                                    onClose={approveSuccess ? confirmApproval : closeModal}
                                    title={isApprove ?
                                        approveSuccess ?
                                            t("submitBLApproval")
                                            :
                                            t("submitBLNotApproval")
                                        :
                                        approveSuccess ?
                                            t("submitBLRejected")
                                            :
                                            t("submitBLNotRejected")
                                    }
                                    body={isApprove ?
                                        approveSuccess ?
                                            <b>
                                                <span className='modalgrid'>
                                                    <DoneOutlinedIcon /> <span className='spanItems'>  {t("BL_Approval_Sent")}</span>
                                                </span>
                                            </b>
                                            :
                                            <b>
                                                <span className='modalgrid'>
                                                    <ErrorOutlineIcon />
                                                    <span className='spanItems'>
                                                        {Array.isArray(errorMessage) ?
                                                            errorMessage.map((error, ind) => (
                                                                <span key={ind}>{error}</span>
                                                            ))
                                                            :
                                                            <span >{errorMessage}</span>
                                                        }
                                                    </span>
                                                </span>
                                            </b>
                                        :
                                        approveSuccess ?
                                            <b>
                                                <span className='modalgrid'>
                                                    <DoneOutlinedIcon /> <span className='spanItems'>  {t("BLRejected")}</span>
                                                </span>
                                            </b>
                                            :
                                            <b>
                                                <span className='modalgrid'>
                                                    <ErrorOutlineIcon />
                                                    <span className='spanItems'>
                                                        {Array.isArray(errorMessage) ?
                                                            errorMessage.map((error, ind) => (
                                                                <span key={ind}>{error}</span>
                                                            ))
                                                            :
                                                            <span>{errorMessage || t("BLNotRejected")}</span>
                                                        }
                                                    </span>
                                                </span>
                                            </b>
                                    }
                                    footer={
                                        <span>
                                            {approveSuccess && <M_Button
                                                backgroundColor={'var(--color-green)'}
                                                onClick={confirmApproval}
                                                label={t("ButtonConfirm")}
                                                labelColor={'var(--color-white)'}
                                            />}
                                            {!approveSuccess && <M_Button
                                                backgroundColor={'var(--color-red)'}
                                                onClick={closeModal}
                                                label={t("ButtonCancel")}
                                                labelColor={'var(--color-white)'}
                                            />}
                                        </span>
                                    }
                                />

                                <M_ElementDrawer
                                    open={openElement}
                                    setOpen={setOpenElement}
                                    onClose={closeElement}
                                    element={element()}
                                />
                                <M_ElementDrawer
                                    open={openContainer}
                                    setOpen={setOpenContainer}
                                    onClose={() => {
                                        cancelContainer()
                                    }}
                                    element={elementContainer()}
                                    minWidth={'700px'}
                                />

                                <M_MessageBoard
                                    warning
                                    open={leavingPage}
                                    onClose={functionLeavingPage}
                                    title={t("leavingPageTitle")}
                                    body={t("leavingPageBody")}
                                    footer={
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                            <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                                            <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={functionLeavingPage} label={t("ButtonConfirm")} />
                                        </span>
                                    }
                                />

                            </SplitterPanel>
                        </Splitter>
                    </div >
                    {/* modal confirm deletion */}
                    <M_MessageBoard
                        title={t('ApproveDeletion')}
                        open={openModalConfirmDeletion}
                        onClose={() => { setModalConfirmDeletion(false) }}
                        body={t('BodyConfirmDelete')}
                        footer={
                            <M_Button
                                normal
                                hoverEffect
                                label={t('ButtonConfirm')}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                onClick={() => {
                                    setModalConfirmDeletion(false)
                                    deleteBL()
                                }}
                            />
                        }
                    />

                    {/* MODAL SE ERRORS */}
                    <M_MessageBoard
                        open={OpenModalSeeErrors}
                        minWidth={'30%'}
                        onClose={() => setOpenModalSeeErrors(false)}
                        title={t("ListErrors")}
                        body={
                            <span>
                                <b>{listErrors.CreatedOn}</b>: {listErrors.ErrorMessage}
                            </span>
                        }
                        footer={
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setOpenModalSeeErrors(false)} label={t("ButtonCancel")} />
                            </span>
                        }
                    />

                    <M_MessageBoard
                        open={openConfirm}
                        onClose={() => setOpenConfirm(false)}
                        title={t('ApproveDeletion')}
                        body={t('BLDeleted')}
                        footer={
                            <M_Button
                                normal
                                hoverEffect
                                label={t('Confirm')}
                                backgroundColor={'var(--color-green)'}
                                labelColor={'var(--color-white)'}
                                onClick={() => {
                                    setOpenConfirm(false)
                                    handleTabClose(JSON.parse(id))
                                }}
                            />
                        }
                    />

                    {/* MODAL CONFIRM REGENERATE */}
                    <M_MessageBoard
                        warning
                        open={openConfirmRegenerate}
                        onClose={() => setOpenConfirmRegenerate(false)}
                        title={t("RegenerateClauses") + " " + (varNameDict.get('freightBLNumber') || varNameDict.get('freightBookingNumber') || '') + "?"}
                        body={
                            <div>
                                <p><b>{t("ClausesAction")}</b></p>
                                <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
                                    <li>{t("RemoveAllExistingClauses")}</li>
                                    <li>{t("CreateNewClausesBasedOnConfiguredRules")}</li>
                                </ul>
                            </div>
                        }
                        footer={
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <M_Button
                                    hoverEffect
                                    normal
                                    labelColor={'white'}
                                    backgroundColor={'var(--color-red)'}
                                    onClick={() => setOpenConfirmRegenerate(false)}
                                    label={t("ButtonCancel")}
                                />
                                <M_Button
                                    hoverEffect
                                    normal
                                    labelColor={'white'}
                                    backgroundColor={'var(--color-green)'}
                                    onClick={confirmRegenerateClauses}
                                    label={t("ButtonConfirm")}
                                />
                            </span>
                        }
                    />

                    {/* MODAL CLAUSES */}
                    <Dialog
                        open={openClauses}
                        onClose={closeClausesPopup}
                        maxWidth="lg"
                        fullWidth
                        PaperProps={{ className: 'clausesDialogPaper' }}
                    >
                        <DialogTitle className="clausesDialogTitle">
                            <b>{t('ClausesFor')} {varNameDict.get('freightBLNumber') || varNameDict.get('freightBookingNumber') || ''}</b>
                        </DialogTitle>
                        <DialogContent>
                            <div className="clausesDialogContent">
                                {loadingClauses ? (
                                    <div className="clausesLoadingContainer">
                                        <p>{t('LoadingClauses')}</p>
                                    </div>
                                ) : clausesData.length === 0 ? (
                                    <div className="clausesEmptyContainer">
                                        <p className="clausesEmptyText">
                                            {t('NoClausesFound')}
                                        </p>
                                    </div>
                                ) : (
                                    <DataTable
                                        value={clausesData}
                                        expandedRows={expandedRows}
                                        onRowToggle={(e) => setExpandedRows(e.data)}
                                        onRowExpand={onRowExpand}
                                        rowExpansionTemplate={(rowData) => {
                                            return (
                                                <div className="clausesExpansionWrapper">
                                                    {loadingDetails[rowData.Id] ? (
                                                        <div className="clausesDetailLoadingContainer">
                                                            <i className="pi pi-spin pi-spinner clausesDetailSpinner"></i>
                                                            <p>{t('LoadingDetails')}</p>
                                                        </div>
                                                    ) : clauseDetails[rowData.Id]?.length > 0 ? (
                                                        <div>
                                                            <DataTable
                                                                value={clauseDetails[rowData.Id]}
                                                                emptyMessage={t('NoDetailsFound')}
                                                                size="small"
                                                            >
                                                                <Column
                                                                    field="DetailKey"
                                                                    header={t('DetailKey')}
                                                                    className="clausesDetailColumn"
                                                                />
                                                                <Column
                                                                    field="DetailDescription"
                                                                    header={t('DetailDescription')}
                                                                    className="clausesDescriptionColumn"
                                                                />
                                                            </DataTable>
                                                        </div>
                                                    ) : (
                                                        <p className="clausesDetailEmptyText">
                                                            {t('NoTransportClauseDetails')}
                                                        </p>
                                                    )}
                                                </div>
                                            )
                                        }}
                                        dataKey="Id"
                                        size="small"
                                        stripedRows
                                    >
                                        <Column expander className="clausesExpanderColumn" />
                                        <Column field="ClauseCode" header={t('ClauseCode')} sortable />
                                        <Column field="ClauseName" header={t('ClauseName')} sortable />
                                        <Column field="ClauseDocument" header={t('ClauseDocument')} sortable className="clausesDocumentColumn" />
                                        <Column field="TradeLineCode" header={t('TradeLineCode')} sortable className="clausesTradeLineColumn" />
                                        <Column field="TransportModeCode" header={t('TransportMode')} sortable className="clausesModeColumn" />
                                        <Column field="TransportVesselCode" header={t('Vessel')} sortable className="clausesVesselColumn" />
                                        <Column field="TransportVoyageNumber" header={t('Voyage')} sortable className="clausesVoyageColumn" />
                                    </DataTable>
                                )}
                            </div>
                            <div className="clausesCloseButton">
                                <M_Button
                                    none
                                    icon={<CloseRounded className="clausesCloseIcon" />}
                                    onClick={closeClausesPopup}
                                />
                            </div>
                            <div className="clausesRegenerateButton">
                                <M_Button
                                    normal
                                    hoverEffect
                                    label={t('Regenerate')}
                                    icon={<i className="pi pi-refresh"></i>}
                                    backgroundColor={'var(--color-blue)'}
                                    labelColor={'var(--color-white)'}
                                    onClick={handleRegenerateClauses}
                                />
                            </div>
                        </DialogContent>
                    </Dialog>


                    <br /><br /><br /><br /><br />
                </>
            )
            }
        </>
    )
}